(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
'use strict';
var $ca66147c52f1c36f$exports = {};
'use strict';
var $1cca30410cf11b53$exports = {};
'use strict';
var $1cca30410cf11b53$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$1cca30410cf11b53$exports = // eslint-disable-next-line es/no-global-this -- safe
$1cca30410cf11b53$var$check(typeof globalThis == 'object' && globalThis) || $1cca30410cf11b53$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$1cca30410cf11b53$var$check(typeof self == 'object' && self) || $1cca30410cf11b53$var$check(typeof $parcel$global == 'object' && $parcel$global) || $1cca30410cf11b53$var$check(typeof $1cca30410cf11b53$exports == 'object' && $1cca30410cf11b53$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


var $07309be0dc62a21a$exports = {};

$parcel$export($07309be0dc62a21a$exports, "f", function () { return $07309be0dc62a21a$export$2d1720544b23b823; }, function (v) { return $07309be0dc62a21a$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $07309be0dc62a21a$export$2d1720544b23b823;
'use strict';
var $ce6ba28f66317609$exports = {};
'use strict';
var $10beeae1ca6f1357$exports = {};
'use strict';
$10beeae1ca6f1357$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$ce6ba28f66317609$exports = !$10beeae1ca6f1357$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $6dd48e140907213f$exports = {};
'use strict';
var $a1a957feecabdd81$exports = {};
'use strict';

$a1a957feecabdd81$exports = !$10beeae1ca6f1357$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $6dd48e140907213f$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$6dd48e140907213f$exports = $a1a957feecabdd81$exports ? $6dd48e140907213f$var$call.bind($6dd48e140907213f$var$call) : function() {
    return $6dd48e140907213f$var$call.apply($6dd48e140907213f$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $d83fa12b384925d6$export$2d1720544b23b823;
'use strict';
var $d83fa12b384925d6$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $d83fa12b384925d6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $d83fa12b384925d6$var$NASHORN_BUG = $d83fa12b384925d6$var$getOwnPropertyDescriptor && !$d83fa12b384925d6$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$d83fa12b384925d6$export$2d1720544b23b823 = $d83fa12b384925d6$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $d83fa12b384925d6$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $d83fa12b384925d6$var$$propertyIsEnumerable;


var $b941c4cd0c3c4a09$exports = {};
'use strict';
$b941c4cd0c3c4a09$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $c76b30b2095e794e$exports = {};
'use strict';
var $2ca02031c916d962$exports = {};
'use strict';
var $966303461c07e127$exports = {};
'use strict';

var $966303461c07e127$var$FunctionPrototype = Function.prototype;
var $966303461c07e127$var$call = $966303461c07e127$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $966303461c07e127$var$uncurryThisWithBind = $a1a957feecabdd81$exports && $966303461c07e127$var$FunctionPrototype.bind.bind($966303461c07e127$var$call, $966303461c07e127$var$call);
$966303461c07e127$exports = $a1a957feecabdd81$exports ? $966303461c07e127$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $966303461c07e127$var$call.apply(fn, arguments);
    };
};



var $11458573e8c84e00$exports = {};
'use strict';

var $11458573e8c84e00$var$toString = $966303461c07e127$exports({}.toString);
var $11458573e8c84e00$var$stringSlice = $966303461c07e127$exports(''.slice);
$11458573e8c84e00$exports = function(it) {
    return $11458573e8c84e00$var$stringSlice($11458573e8c84e00$var$toString(it), 8, -1);
};


var $2ca02031c916d962$var$$Object = Object;
var $2ca02031c916d962$var$split = $966303461c07e127$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$2ca02031c916d962$exports = $10beeae1ca6f1357$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$2ca02031c916d962$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $11458573e8c84e00$exports(it) === 'String' ? $2ca02031c916d962$var$split(it, '') : $2ca02031c916d962$var$$Object(it);
} : $2ca02031c916d962$var$$Object;


var $8fd6426c81bfca55$exports = {};
'use strict';
var $fc561a35c297b392$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$fc561a35c297b392$exports = function(it) {
    return it === null || it === undefined;
};


var $8fd6426c81bfca55$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$8fd6426c81bfca55$exports = function(it) {
    if ($fc561a35c297b392$exports(it)) throw new $8fd6426c81bfca55$var$$TypeError("Can't call method on " + it);
    return it;
};


$c76b30b2095e794e$exports = function(it) {
    return $2ca02031c916d962$exports($8fd6426c81bfca55$exports(it));
};


var $efaf6c0cd88f6b3c$exports = {};
'use strict';
var $d47a7b24ae80b9f5$exports = {};
'use strict';

var $96a478191b33f4fa$exports = {};
'use strict';
var $66733457c42e4bfd$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $66733457c42e4bfd$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$66733457c42e4bfd$exports = typeof $66733457c42e4bfd$var$documentAll == 'undefined' && $66733457c42e4bfd$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $66733457c42e4bfd$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$96a478191b33f4fa$exports = function(it) {
    return typeof it == 'object' ? it !== null : $66733457c42e4bfd$exports(it);
};


var $98a3ba51b30ebcfa$exports = {};
'use strict';
var $a262b772204f9131$exports = {};
'use strict';


var $a262b772204f9131$var$aFunction = function(argument) {
    return $66733457c42e4bfd$exports(argument) ? argument : undefined;
};
$a262b772204f9131$exports = function(namespace, method) {
    return arguments.length < 2 ? $a262b772204f9131$var$aFunction($1cca30410cf11b53$exports[namespace]) : $1cca30410cf11b53$exports[namespace] && $1cca30410cf11b53$exports[namespace][method];
};



var $05d64d70d0804181$exports = {};
'use strict';

$05d64d70d0804181$exports = $966303461c07e127$exports({}.isPrototypeOf);


var $ae1d24c570307aaa$exports = {};
'use strict';
var $5f9e167ffc659503$exports = {};
'use strict';
var $cc9c540ab7776841$exports = {};
'use strict';

var $bcca79ca01f4b5fb$exports = {};
'use strict';

var $bcca79ca01f4b5fb$var$navigator = $1cca30410cf11b53$exports.navigator;
var $bcca79ca01f4b5fb$var$userAgent = $bcca79ca01f4b5fb$var$navigator && $bcca79ca01f4b5fb$var$navigator.userAgent;
$bcca79ca01f4b5fb$exports = $bcca79ca01f4b5fb$var$userAgent ? String($bcca79ca01f4b5fb$var$userAgent) : '';


var $cc9c540ab7776841$var$process = $1cca30410cf11b53$exports.process;
var $cc9c540ab7776841$var$Deno = $1cca30410cf11b53$exports.Deno;
var $cc9c540ab7776841$var$versions = $cc9c540ab7776841$var$process && $cc9c540ab7776841$var$process.versions || $cc9c540ab7776841$var$Deno && $cc9c540ab7776841$var$Deno.version;
var $cc9c540ab7776841$var$v8 = $cc9c540ab7776841$var$versions && $cc9c540ab7776841$var$versions.v8;
var $cc9c540ab7776841$var$match, $cc9c540ab7776841$var$version;
if ($cc9c540ab7776841$var$v8) {
    $cc9c540ab7776841$var$match = $cc9c540ab7776841$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $cc9c540ab7776841$var$version = $cc9c540ab7776841$var$match[0] > 0 && $cc9c540ab7776841$var$match[0] < 4 ? 1 : +($cc9c540ab7776841$var$match[0] + $cc9c540ab7776841$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$cc9c540ab7776841$var$version && $bcca79ca01f4b5fb$exports) {
    $cc9c540ab7776841$var$match = $bcca79ca01f4b5fb$exports.match(/Edge\/(\d+)/);
    if (!$cc9c540ab7776841$var$match || $cc9c540ab7776841$var$match[1] >= 74) {
        $cc9c540ab7776841$var$match = $bcca79ca01f4b5fb$exports.match(/Chrome\/(\d+)/);
        if ($cc9c540ab7776841$var$match) $cc9c540ab7776841$var$version = +$cc9c540ab7776841$var$match[1];
    }
}
$cc9c540ab7776841$exports = $cc9c540ab7776841$var$version;




var $5f9e167ffc659503$var$$String = $1cca30410cf11b53$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$5f9e167ffc659503$exports = !!Object.getOwnPropertySymbols && !$10beeae1ca6f1357$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$5f9e167ffc659503$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $cc9c540ab7776841$exports && $cc9c540ab7776841$exports < 41;
});


$ae1d24c570307aaa$exports = $5f9e167ffc659503$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $98a3ba51b30ebcfa$var$$Object = Object;
$98a3ba51b30ebcfa$exports = $ae1d24c570307aaa$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $a262b772204f9131$exports('Symbol');
    return $66733457c42e4bfd$exports($Symbol) && $05d64d70d0804181$exports($Symbol.prototype, $98a3ba51b30ebcfa$var$$Object(it));
};


var $cb7d485ba5a2e30b$exports = {};
'use strict';
var $ac451d11dfa909df$exports = {};
'use strict';

var $624baa4627a5b446$exports = {};
'use strict';
var $624baa4627a5b446$var$$String = String;
$624baa4627a5b446$exports = function(argument) {
    try {
        return $624baa4627a5b446$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $ac451d11dfa909df$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$ac451d11dfa909df$exports = function(argument) {
    if ($66733457c42e4bfd$exports(argument)) return argument;
    throw new $ac451d11dfa909df$var$$TypeError($624baa4627a5b446$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$cb7d485ba5a2e30b$exports = function(V, P) {
    var func = V[P];
    return $fc561a35c297b392$exports(func) ? undefined : $ac451d11dfa909df$exports(func);
};


var $ec3cce4183377438$exports = {};
'use strict';



var $ec3cce4183377438$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$ec3cce4183377438$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $66733457c42e4bfd$exports(fn = input.toString) && !$96a478191b33f4fa$exports(val = $6dd48e140907213f$exports(fn, input))) return val;
    if ($66733457c42e4bfd$exports(fn = input.valueOf) && !$96a478191b33f4fa$exports(val = $6dd48e140907213f$exports(fn, input))) return val;
    if (pref !== 'string' && $66733457c42e4bfd$exports(fn = input.toString) && !$96a478191b33f4fa$exports(val = $6dd48e140907213f$exports(fn, input))) return val;
    throw new $ec3cce4183377438$var$$TypeError("Can't convert object to primitive value");
};


var $2f02eb6a25cfaf08$exports = {};
'use strict';

var $310c440ce6020a4b$exports = {};
'use strict';
var $29653fbd8576c383$exports = {};
'use strict';
var $0f2d8b335bd97f65$exports = {};
'use strict';
$0f2d8b335bd97f65$exports = false;



var $5dfcf5bb0f12c1a2$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $5dfcf5bb0f12c1a2$var$defineProperty = Object.defineProperty;
$5dfcf5bb0f12c1a2$exports = function(key, value) {
    try {
        $5dfcf5bb0f12c1a2$var$defineProperty($1cca30410cf11b53$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $1cca30410cf11b53$exports[key] = value;
    }
    return value;
};


var $29653fbd8576c383$var$SHARED = '__core-js_shared__';
var $29653fbd8576c383$var$store = $29653fbd8576c383$exports = $1cca30410cf11b53$exports[$29653fbd8576c383$var$SHARED] || $5dfcf5bb0f12c1a2$exports($29653fbd8576c383$var$SHARED, {});
($29653fbd8576c383$var$store.versions || ($29653fbd8576c383$var$store.versions = [])).push({
    version: '3.45.1',
    mode: $0f2d8b335bd97f65$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.45.1/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$310c440ce6020a4b$exports = function(key, value) {
    return $29653fbd8576c383$exports[key] || ($29653fbd8576c383$exports[key] = value || {});
};


var $1d9d3902a50a2fcd$exports = {};
'use strict';

var $3281447d22a40e21$exports = {};
'use strict';

var $3281447d22a40e21$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$3281447d22a40e21$exports = function(argument) {
    return $3281447d22a40e21$var$$Object($8fd6426c81bfca55$exports(argument));
};


var $1d9d3902a50a2fcd$var$hasOwnProperty = $966303461c07e127$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1d9d3902a50a2fcd$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1d9d3902a50a2fcd$var$hasOwnProperty($3281447d22a40e21$exports(it), key);
};


var $4d94c21d38bd74cf$exports = {};
'use strict';

var $4d94c21d38bd74cf$var$id = 0;
var $4d94c21d38bd74cf$var$postfix = Math.random();
var $4d94c21d38bd74cf$var$toString = $966303461c07e127$exports(1.1.toString);
$4d94c21d38bd74cf$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $4d94c21d38bd74cf$var$toString(++$4d94c21d38bd74cf$var$id + $4d94c21d38bd74cf$var$postfix, 36);
};




var $2f02eb6a25cfaf08$var$Symbol = $1cca30410cf11b53$exports.Symbol;
var $2f02eb6a25cfaf08$var$WellKnownSymbolsStore = $310c440ce6020a4b$exports('wks');
var $2f02eb6a25cfaf08$var$createWellKnownSymbol = $ae1d24c570307aaa$exports ? $2f02eb6a25cfaf08$var$Symbol['for'] || $2f02eb6a25cfaf08$var$Symbol : $2f02eb6a25cfaf08$var$Symbol && $2f02eb6a25cfaf08$var$Symbol.withoutSetter || $4d94c21d38bd74cf$exports;
$2f02eb6a25cfaf08$exports = function(name) {
    if (!$1d9d3902a50a2fcd$exports($2f02eb6a25cfaf08$var$WellKnownSymbolsStore, name)) $2f02eb6a25cfaf08$var$WellKnownSymbolsStore[name] = $5f9e167ffc659503$exports && $1d9d3902a50a2fcd$exports($2f02eb6a25cfaf08$var$Symbol, name) ? $2f02eb6a25cfaf08$var$Symbol[name] : $2f02eb6a25cfaf08$var$createWellKnownSymbol('Symbol.' + name);
    return $2f02eb6a25cfaf08$var$WellKnownSymbolsStore[name];
};


var $d47a7b24ae80b9f5$var$$TypeError = TypeError;
var $d47a7b24ae80b9f5$var$TO_PRIMITIVE = $2f02eb6a25cfaf08$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$d47a7b24ae80b9f5$exports = function(input, pref) {
    if (!$96a478191b33f4fa$exports(input) || $98a3ba51b30ebcfa$exports(input)) return input;
    var exoticToPrim = $cb7d485ba5a2e30b$exports(input, $d47a7b24ae80b9f5$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $6dd48e140907213f$exports(exoticToPrim, input, pref);
        if (!$96a478191b33f4fa$exports(result) || $98a3ba51b30ebcfa$exports(result)) return result;
        throw new $d47a7b24ae80b9f5$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $ec3cce4183377438$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$efaf6c0cd88f6b3c$exports = function(argument) {
    var key = $d47a7b24ae80b9f5$exports(argument, 'string');
    return $98a3ba51b30ebcfa$exports(key) ? key : key + '';
};



var $ad53780beb7d7be7$exports = {};
'use strict';


var $d0a57510c81c1621$exports = {};
'use strict';


var $d0a57510c81c1621$var$document = $1cca30410cf11b53$exports.document;
// typeof document.createElement is 'object' in old IE
var $d0a57510c81c1621$var$EXISTS = $96a478191b33f4fa$exports($d0a57510c81c1621$var$document) && $96a478191b33f4fa$exports($d0a57510c81c1621$var$document.createElement);
$d0a57510c81c1621$exports = function(it) {
    return $d0a57510c81c1621$var$EXISTS ? $d0a57510c81c1621$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$ad53780beb7d7be7$exports = !$ce6ba28f66317609$exports && !$10beeae1ca6f1357$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($d0a57510c81c1621$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $07309be0dc62a21a$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$07309be0dc62a21a$export$2d1720544b23b823 = $ce6ba28f66317609$exports ? $07309be0dc62a21a$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $c76b30b2095e794e$exports(O);
    P = $efaf6c0cd88f6b3c$exports(P);
    if ($ad53780beb7d7be7$exports) try {
        return $07309be0dc62a21a$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1d9d3902a50a2fcd$exports(O, P)) return $b941c4cd0c3c4a09$exports(!$6dd48e140907213f$exports($d83fa12b384925d6$export$2d1720544b23b823, O, P), O[P]);
};


var $ca66147c52f1c36f$require$getOwnPropertyDescriptor = $07309be0dc62a21a$export$2d1720544b23b823;
var $b4e3b093ae5606fa$exports = {};
'use strict';

var $a334f8c362aafa38$exports = {};

$parcel$export($a334f8c362aafa38$exports, "f", function () { return $a334f8c362aafa38$export$2d1720544b23b823; }, function (v) { return $a334f8c362aafa38$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $a334f8c362aafa38$export$2d1720544b23b823;
'use strict';


var $c93a0f7d1b983b05$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$c93a0f7d1b983b05$exports = $ce6ba28f66317609$exports && $10beeae1ca6f1357$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c7d52dd23854385b$exports = {};
'use strict';

var $c7d52dd23854385b$var$$String = String;
var $c7d52dd23854385b$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c7d52dd23854385b$exports = function(argument) {
    if ($96a478191b33f4fa$exports(argument)) return argument;
    throw new $c7d52dd23854385b$var$$TypeError($c7d52dd23854385b$var$$String(argument) + ' is not an object');
};



var $a334f8c362aafa38$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $a334f8c362aafa38$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $a334f8c362aafa38$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $a334f8c362aafa38$var$ENUMERABLE = 'enumerable';
var $a334f8c362aafa38$var$CONFIGURABLE = 'configurable';
var $a334f8c362aafa38$var$WRITABLE = 'writable';
$a334f8c362aafa38$export$2d1720544b23b823 = $ce6ba28f66317609$exports ? $c93a0f7d1b983b05$exports ? function defineProperty(O, P, Attributes) {
    $c7d52dd23854385b$exports(O);
    P = $efaf6c0cd88f6b3c$exports(P);
    $c7d52dd23854385b$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $a334f8c362aafa38$var$WRITABLE in Attributes && !Attributes[$a334f8c362aafa38$var$WRITABLE]) {
        var current = $a334f8c362aafa38$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$a334f8c362aafa38$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $a334f8c362aafa38$var$CONFIGURABLE in Attributes ? Attributes[$a334f8c362aafa38$var$CONFIGURABLE] : current[$a334f8c362aafa38$var$CONFIGURABLE],
                enumerable: $a334f8c362aafa38$var$ENUMERABLE in Attributes ? Attributes[$a334f8c362aafa38$var$ENUMERABLE] : current[$a334f8c362aafa38$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $a334f8c362aafa38$var$$defineProperty(O, P, Attributes);
} : $a334f8c362aafa38$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c7d52dd23854385b$exports(O);
    P = $efaf6c0cd88f6b3c$exports(P);
    $c7d52dd23854385b$exports(Attributes);
    if ($ad53780beb7d7be7$exports) try {
        return $a334f8c362aafa38$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $a334f8c362aafa38$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$b4e3b093ae5606fa$exports = $ce6ba28f66317609$exports ? function(object, key, value) {
    return $a334f8c362aafa38$export$2d1720544b23b823(object, key, $b941c4cd0c3c4a09$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $a5378e288f28a3de$exports = {};
'use strict';


var $4ca00373aa17e58f$exports = {};
'use strict';





var $c5158caaca2f8ecd$exports = {};
'use strict';


var $c5158caaca2f8ecd$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $c5158caaca2f8ecd$var$getDescriptor = $ce6ba28f66317609$exports && Object.getOwnPropertyDescriptor;
var $c5158caaca2f8ecd$var$EXISTS = $1d9d3902a50a2fcd$exports($c5158caaca2f8ecd$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $c5158caaca2f8ecd$var$PROPER = $c5158caaca2f8ecd$var$EXISTS && (function something() {}).name === 'something';
var $c5158caaca2f8ecd$var$CONFIGURABLE = $c5158caaca2f8ecd$var$EXISTS && (!$ce6ba28f66317609$exports || $ce6ba28f66317609$exports && $c5158caaca2f8ecd$var$getDescriptor($c5158caaca2f8ecd$var$FunctionPrototype, 'name').configurable);
$c5158caaca2f8ecd$exports = {
    EXISTS: $c5158caaca2f8ecd$var$EXISTS,
    PROPER: $c5158caaca2f8ecd$var$PROPER,
    CONFIGURABLE: $c5158caaca2f8ecd$var$CONFIGURABLE
};


var $4ca00373aa17e58f$require$CONFIGURABLE_FUNCTION_NAME = $c5158caaca2f8ecd$exports.CONFIGURABLE;
var $12069b4949848a4e$exports = {};
'use strict';



var $12069b4949848a4e$var$functionToString = $966303461c07e127$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$66733457c42e4bfd$exports($29653fbd8576c383$exports.inspectSource)) $29653fbd8576c383$exports.inspectSource = function(it) {
    return $12069b4949848a4e$var$functionToString(it);
};
$12069b4949848a4e$exports = $29653fbd8576c383$exports.inspectSource;


var $1f4f460c9ddf95ba$exports = {};
'use strict';
var $fd45195445cad199$exports = {};
'use strict';


var $fd45195445cad199$var$WeakMap = $1cca30410cf11b53$exports.WeakMap;
$fd45195445cad199$exports = $66733457c42e4bfd$exports($fd45195445cad199$var$WeakMap) && /native code/.test(String($fd45195445cad199$var$WeakMap));







var $1949a81a9c5770b0$exports = {};
'use strict';


var $1949a81a9c5770b0$var$keys = $310c440ce6020a4b$exports('keys');
$1949a81a9c5770b0$exports = function(key) {
    return $1949a81a9c5770b0$var$keys[key] || ($1949a81a9c5770b0$var$keys[key] = $4d94c21d38bd74cf$exports(key));
};


var $15a8dc1e99b1ac8f$exports = {};
'use strict';
$15a8dc1e99b1ac8f$exports = {};


var $1f4f460c9ddf95ba$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $1f4f460c9ddf95ba$var$TypeError = $1cca30410cf11b53$exports.TypeError;
var $1f4f460c9ddf95ba$var$WeakMap = $1cca30410cf11b53$exports.WeakMap;
var $1f4f460c9ddf95ba$var$set, $1f4f460c9ddf95ba$var$get, $1f4f460c9ddf95ba$var$has;
var $1f4f460c9ddf95ba$var$enforce = function(it) {
    return $1f4f460c9ddf95ba$var$has(it) ? $1f4f460c9ddf95ba$var$get(it) : $1f4f460c9ddf95ba$var$set(it, {});
};
var $1f4f460c9ddf95ba$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$96a478191b33f4fa$exports(it) || (state = $1f4f460c9ddf95ba$var$get(it)).type !== TYPE) throw new $1f4f460c9ddf95ba$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($fd45195445cad199$exports || $29653fbd8576c383$exports.state) {
    var $1f4f460c9ddf95ba$var$store = $29653fbd8576c383$exports.state || ($29653fbd8576c383$exports.state = new $1f4f460c9ddf95ba$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $1f4f460c9ddf95ba$var$store.get = $1f4f460c9ddf95ba$var$store.get;
    $1f4f460c9ddf95ba$var$store.has = $1f4f460c9ddf95ba$var$store.has;
    $1f4f460c9ddf95ba$var$store.set = $1f4f460c9ddf95ba$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $1f4f460c9ddf95ba$var$set = function(it, metadata) {
        if ($1f4f460c9ddf95ba$var$store.has(it)) throw new $1f4f460c9ddf95ba$var$TypeError($1f4f460c9ddf95ba$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $1f4f460c9ddf95ba$var$store.set(it, metadata);
        return metadata;
    };
    $1f4f460c9ddf95ba$var$get = function(it) {
        return $1f4f460c9ddf95ba$var$store.get(it) || {};
    };
    $1f4f460c9ddf95ba$var$has = function(it) {
        return $1f4f460c9ddf95ba$var$store.has(it);
    };
} else {
    var $1f4f460c9ddf95ba$var$STATE = $1949a81a9c5770b0$exports('state');
    $15a8dc1e99b1ac8f$exports[$1f4f460c9ddf95ba$var$STATE] = true;
    $1f4f460c9ddf95ba$var$set = function(it, metadata) {
        if ($1d9d3902a50a2fcd$exports(it, $1f4f460c9ddf95ba$var$STATE)) throw new $1f4f460c9ddf95ba$var$TypeError($1f4f460c9ddf95ba$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b4e3b093ae5606fa$exports(it, $1f4f460c9ddf95ba$var$STATE, metadata);
        return metadata;
    };
    $1f4f460c9ddf95ba$var$get = function(it) {
        return $1d9d3902a50a2fcd$exports(it, $1f4f460c9ddf95ba$var$STATE) ? it[$1f4f460c9ddf95ba$var$STATE] : {};
    };
    $1f4f460c9ddf95ba$var$has = function(it) {
        return $1d9d3902a50a2fcd$exports(it, $1f4f460c9ddf95ba$var$STATE);
    };
}
$1f4f460c9ddf95ba$exports = {
    set: $1f4f460c9ddf95ba$var$set,
    get: $1f4f460c9ddf95ba$var$get,
    has: $1f4f460c9ddf95ba$var$has,
    enforce: $1f4f460c9ddf95ba$var$enforce,
    getterFor: $1f4f460c9ddf95ba$var$getterFor
};


var $4ca00373aa17e58f$var$enforceInternalState = $1f4f460c9ddf95ba$exports.enforce;
var $4ca00373aa17e58f$var$getInternalState = $1f4f460c9ddf95ba$exports.get;
var $4ca00373aa17e58f$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ca00373aa17e58f$var$defineProperty = Object.defineProperty;
var $4ca00373aa17e58f$var$stringSlice = $966303461c07e127$exports(''.slice);
var $4ca00373aa17e58f$var$replace = $966303461c07e127$exports(''.replace);
var $4ca00373aa17e58f$var$join = $966303461c07e127$exports([].join);
var $4ca00373aa17e58f$var$CONFIGURABLE_LENGTH = $ce6ba28f66317609$exports && !$10beeae1ca6f1357$exports(function() {
    return $4ca00373aa17e58f$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $4ca00373aa17e58f$var$TEMPLATE = String(String).split('String');
var $4ca00373aa17e58f$var$makeBuiltIn = $4ca00373aa17e58f$exports = function(value, name, options) {
    if ($4ca00373aa17e58f$var$stringSlice($4ca00373aa17e58f$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $4ca00373aa17e58f$var$replace($4ca00373aa17e58f$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$1d9d3902a50a2fcd$exports(value, 'name') || $4ca00373aa17e58f$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($ce6ba28f66317609$exports) $4ca00373aa17e58f$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($4ca00373aa17e58f$var$CONFIGURABLE_LENGTH && options && $1d9d3902a50a2fcd$exports(options, 'arity') && value.length !== options.arity) $4ca00373aa17e58f$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $1d9d3902a50a2fcd$exports(options, 'constructor') && options.constructor) {
            if ($ce6ba28f66317609$exports) $4ca00373aa17e58f$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $4ca00373aa17e58f$var$enforceInternalState(value);
    if (!$1d9d3902a50a2fcd$exports(state, 'source')) state.source = $4ca00373aa17e58f$var$join($4ca00373aa17e58f$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $4ca00373aa17e58f$var$makeBuiltIn(function toString() {
    return $66733457c42e4bfd$exports(this) && $4ca00373aa17e58f$var$getInternalState(this).source || $12069b4949848a4e$exports(this);
}, 'toString');



$a5378e288f28a3de$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($66733457c42e4bfd$exports(value)) $4ca00373aa17e58f$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $5dfcf5bb0f12c1a2$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $a334f8c362aafa38$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ba431b68b50390cb$exports = {};
'use strict';

var $daff5b67b3ec61ed$exports = {};
'use strict';


var $42f35ac27ca8991e$exports = {};

$parcel$export($42f35ac27ca8991e$exports, "f", function () { return $42f35ac27ca8991e$export$2d1720544b23b823; }, function (v) { return $42f35ac27ca8991e$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $42f35ac27ca8991e$export$2d1720544b23b823;
'use strict';
var $4a3892fc8411edf8$exports = {};
'use strict';



var $3d04ec442fc68600$exports = {};
'use strict';

var $82ea8bcccff50613$exports = {};
'use strict';
var $9f3eb545512efe9e$exports = {};
'use strict';
var $25230e052fee030f$exports = {};
'use strict';
var $25230e052fee030f$var$ceil = Math.ceil;
var $25230e052fee030f$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$25230e052fee030f$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $25230e052fee030f$var$floor : $25230e052fee030f$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$9f3eb545512efe9e$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $25230e052fee030f$exports(number);
};


var $82ea8bcccff50613$var$max = Math.max;
var $82ea8bcccff50613$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$82ea8bcccff50613$exports = function(index, length) {
    var integer = $9f3eb545512efe9e$exports(index);
    return integer < 0 ? $82ea8bcccff50613$var$max(integer + length, 0) : $82ea8bcccff50613$var$min(integer, length);
};


var $ffd1deb5f4ba5f93$exports = {};
'use strict';
var $462654e2015d596f$exports = {};
'use strict';

var $462654e2015d596f$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$462654e2015d596f$exports = function(argument) {
    var len = $9f3eb545512efe9e$exports(argument);
    return len > 0 ? $462654e2015d596f$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$ffd1deb5f4ba5f93$exports = function(obj) {
    return $462654e2015d596f$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $3d04ec442fc68600$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $c76b30b2095e794e$exports($this);
        var length = $ffd1deb5f4ba5f93$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $82ea8bcccff50613$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$3d04ec442fc68600$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $3d04ec442fc68600$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $3d04ec442fc68600$var$createMethod(false)
};


var $4a3892fc8411edf8$require$indexOf = $3d04ec442fc68600$exports.indexOf;

var $4a3892fc8411edf8$var$push = $966303461c07e127$exports([].push);
$4a3892fc8411edf8$exports = function(object, names) {
    var O = $c76b30b2095e794e$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1d9d3902a50a2fcd$exports($15a8dc1e99b1ac8f$exports, key) && $1d9d3902a50a2fcd$exports(O, key) && $4a3892fc8411edf8$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1d9d3902a50a2fcd$exports(O, key = names[i++])) ~$4a3892fc8411edf8$require$indexOf(result, key) || $4a3892fc8411edf8$var$push(result, key);
    return result;
};


var $5e940fcac05c1bb4$exports = {};
'use strict';
// IE8- don't enum bug keys
$5e940fcac05c1bb4$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $42f35ac27ca8991e$var$hiddenKeys = $5e940fcac05c1bb4$exports.concat('length', 'prototype');
$42f35ac27ca8991e$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $4a3892fc8411edf8$exports(O, $42f35ac27ca8991e$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $93f684b8fcf2e660$export$2d1720544b23b823;
'use strict';
$93f684b8fcf2e660$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $daff5b67b3ec61ed$var$concat = $966303461c07e127$exports([].concat);
// all object keys, includes non-enumerable and symbols
$daff5b67b3ec61ed$exports = $a262b772204f9131$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $42f35ac27ca8991e$export$2d1720544b23b823($c7d52dd23854385b$exports(it));
    var getOwnPropertySymbols = $93f684b8fcf2e660$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $daff5b67b3ec61ed$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ba431b68b50390cb$exports = function(target, source, exceptions) {
    var keys = $daff5b67b3ec61ed$exports(source);
    var defineProperty = $a334f8c362aafa38$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $07309be0dc62a21a$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1d9d3902a50a2fcd$exports(target, key) && !(exceptions && $1d9d3902a50a2fcd$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $77d6726afe62b52c$exports = {};
'use strict';


var $77d6726afe62b52c$var$replacement = /#|\.prototype\./;
var $77d6726afe62b52c$var$isForced = function(feature, detection) {
    var value = $77d6726afe62b52c$var$data[$77d6726afe62b52c$var$normalize(feature)];
    return value === $77d6726afe62b52c$var$POLYFILL ? true : value === $77d6726afe62b52c$var$NATIVE ? false : $66733457c42e4bfd$exports(detection) ? $10beeae1ca6f1357$exports(detection) : !!detection;
};
var $77d6726afe62b52c$var$normalize = $77d6726afe62b52c$var$isForced.normalize = function(string) {
    return String(string).replace($77d6726afe62b52c$var$replacement, '.').toLowerCase();
};
var $77d6726afe62b52c$var$data = $77d6726afe62b52c$var$isForced.data = {};
var $77d6726afe62b52c$var$NATIVE = $77d6726afe62b52c$var$isForced.NATIVE = 'N';
var $77d6726afe62b52c$var$POLYFILL = $77d6726afe62b52c$var$isForced.POLYFILL = 'P';
$77d6726afe62b52c$exports = $77d6726afe62b52c$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ca66147c52f1c36f$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $1cca30410cf11b53$exports;
    else if (STATIC) target = $1cca30410cf11b53$exports[TARGET] || $5dfcf5bb0f12c1a2$exports(TARGET, {});
    else target = $1cca30410cf11b53$exports[TARGET] && $1cca30410cf11b53$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca66147c52f1c36f$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $77d6726afe62b52c$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ba431b68b50390cb$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $b4e3b093ae5606fa$exports(sourceProperty, 'sham', true);
        $a5378e288f28a3de$exports(target, key, sourceProperty, options);
    }
};








var $cc1f216aa7e44c59$exports = {};
'use strict';
var $39673a197979f5e7$exports = {};
'use strict';
var $71a86e2d0991bd16$exports = {};
'use strict';

var $71a86e2d0991bd16$var$TO_STRING_TAG = $2f02eb6a25cfaf08$exports('toStringTag');
var $71a86e2d0991bd16$var$test = {};
$71a86e2d0991bd16$var$test[$71a86e2d0991bd16$var$TO_STRING_TAG] = 'z';
$71a86e2d0991bd16$exports = String($71a86e2d0991bd16$var$test) === '[object z]';





var $39673a197979f5e7$var$TO_STRING_TAG = $2f02eb6a25cfaf08$exports('toStringTag');
var $39673a197979f5e7$var$$Object = Object;
// ES3 wrong here
var $39673a197979f5e7$var$CORRECT_ARGUMENTS = $11458573e8c84e00$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $39673a197979f5e7$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$39673a197979f5e7$exports = $71a86e2d0991bd16$exports ? $11458573e8c84e00$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $39673a197979f5e7$var$tryGet(O = $39673a197979f5e7$var$$Object(it), $39673a197979f5e7$var$TO_STRING_TAG)) == 'string' ? tag : $39673a197979f5e7$var$CORRECT_ARGUMENTS ? $11458573e8c84e00$exports(O) : (result = $11458573e8c84e00$exports(O)) === 'Object' && $66733457c42e4bfd$exports(O.callee) ? 'Arguments' : result;
};


var $cc1f216aa7e44c59$var$$String = String;
$cc1f216aa7e44c59$exports = function(argument) {
    if ($39673a197979f5e7$exports(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $cc1f216aa7e44c59$var$$String(argument);
};


var $ae34d1f2f4f59697$exports = {};
'use strict';


$ae34d1f2f4f59697$exports = function(target, name, descriptor) {
    if (descriptor.get) $4ca00373aa17e58f$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $4ca00373aa17e58f$exports(descriptor.set, name, {
        setter: true
    });
    return $a334f8c362aafa38$export$2d1720544b23b823(target, name, descriptor);
};



var $166dd7f129138244$var$NativeSymbol = $1cca30410cf11b53$exports.Symbol;
var $166dd7f129138244$var$SymbolPrototype = $166dd7f129138244$var$NativeSymbol && $166dd7f129138244$var$NativeSymbol.prototype;
if ($ce6ba28f66317609$exports && $66733457c42e4bfd$exports($166dd7f129138244$var$NativeSymbol) && (!('description' in $166dd7f129138244$var$SymbolPrototype) || // Safari 12 bug
$166dd7f129138244$var$NativeSymbol().description !== undefined)) {
    var $166dd7f129138244$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $166dd7f129138244$var$SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $cc1f216aa7e44c59$exports(arguments[0]);
        var result = $05d64d70d0804181$exports($166dd7f129138244$var$SymbolPrototype, this) ? new $166dd7f129138244$var$NativeSymbol(description) : description === undefined ? $166dd7f129138244$var$NativeSymbol() : $166dd7f129138244$var$NativeSymbol(description);
        if (description === '') $166dd7f129138244$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $ba431b68b50390cb$exports($166dd7f129138244$var$SymbolWrapper, $166dd7f129138244$var$NativeSymbol);
    $166dd7f129138244$var$SymbolWrapper.prototype = $166dd7f129138244$var$SymbolPrototype;
    $166dd7f129138244$var$SymbolPrototype.constructor = $166dd7f129138244$var$SymbolWrapper;
    var $166dd7f129138244$var$NATIVE_SYMBOL = String($166dd7f129138244$var$NativeSymbol('description detection')) === 'Symbol(description detection)';
    var $166dd7f129138244$var$thisSymbolValue = $966303461c07e127$exports($166dd7f129138244$var$SymbolPrototype.valueOf);
    var $166dd7f129138244$var$symbolDescriptiveString = $966303461c07e127$exports($166dd7f129138244$var$SymbolPrototype.toString);
    var $166dd7f129138244$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $166dd7f129138244$var$replace = $966303461c07e127$exports(''.replace);
    var $166dd7f129138244$var$stringSlice = $966303461c07e127$exports(''.slice);
    $ae34d1f2f4f59697$exports($166dd7f129138244$var$SymbolPrototype, 'description', {
        configurable: true,
        get: function description() {
            var symbol = $166dd7f129138244$var$thisSymbolValue(this);
            if ($1d9d3902a50a2fcd$exports($166dd7f129138244$var$EmptyStringDescriptionStore, symbol)) return '';
            var string = $166dd7f129138244$var$symbolDescriptiveString(symbol);
            var desc = $166dd7f129138244$var$NATIVE_SYMBOL ? $166dd7f129138244$var$stringSlice(string, 7, -1) : $166dd7f129138244$var$replace(string, $166dd7f129138244$var$regexp, '$1');
            return desc === '' ? undefined : desc;
        }
    });
    $ca66147c52f1c36f$exports({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $166dd7f129138244$var$SymbolWrapper
    });
}


'use strict';
var $84249ed0242ebe31$exports = {};
'use strict';
var $5bbaec6d4c68d2f0$exports = {};
'use strict';

$5bbaec6d4c68d2f0$exports = $1cca30410cf11b53$exports;



var $5542aaec85571fbc$export$2d1720544b23b823;
'use strict';

$5542aaec85571fbc$export$2d1720544b23b823 = $2f02eb6a25cfaf08$exports;



var $84249ed0242ebe31$require$defineProperty = $a334f8c362aafa38$export$2d1720544b23b823;
$84249ed0242ebe31$exports = function(NAME) {
    var Symbol = $5bbaec6d4c68d2f0$exports.Symbol || ($5bbaec6d4c68d2f0$exports.Symbol = {});
    if (!$1d9d3902a50a2fcd$exports(Symbol, NAME)) $84249ed0242ebe31$require$defineProperty(Symbol, NAME, {
        value: $5542aaec85571fbc$export$2d1720544b23b823(NAME)
    });
};


// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$84249ed0242ebe31$exports('asyncIterator');


'use strict';

var $38f6601e3834de81$exports = {};
'use strict';
var $dbbf9b0a5a4ce70b$exports = {};
'use strict';

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$dbbf9b0a5a4ce70b$exports = Array.isArray || function isArray(argument) {
    return $11458573e8c84e00$exports(argument) === 'Array';
};



var $7bf63003fd55b340$exports = {};
'use strict';
var $7bf63003fd55b340$var$$TypeError = TypeError;
var $7bf63003fd55b340$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
$7bf63003fd55b340$exports = function(it) {
    if (it > $7bf63003fd55b340$var$MAX_SAFE_INTEGER) throw $7bf63003fd55b340$var$$TypeError('Maximum allowed index exceeded');
    return it;
};


var $2d52694feff5f895$exports = {};
'use strict';
var $f587f14398031c29$exports = {};
'use strict';


$f587f14398031c29$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($11458573e8c84e00$exports(fn) === 'Function') return $966303461c07e127$exports(fn);
};




var $2d52694feff5f895$var$bind = $f587f14398031c29$exports($f587f14398031c29$exports.bind);
// optional / simple context binding
$2d52694feff5f895$exports = function(fn, that) {
    $ac451d11dfa909df$exports(fn);
    return that === undefined ? fn : $a1a957feecabdd81$exports ? $2d52694feff5f895$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};


// `FlattenIntoArray` abstract operation
// https://tc39.es/ecma262/#sec-flattenintoarray
var $38f6601e3834de81$var$flattenIntoArray = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $2d52694feff5f895$exports(mapper, thisArg) : false;
    var element, elementLen;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && $dbbf9b0a5a4ce70b$exports(element)) {
                elementLen = $ffd1deb5f4ba5f93$exports(element);
                targetIndex = $38f6601e3834de81$var$flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
                $7bf63003fd55b340$exports(targetIndex + 1);
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
$38f6601e3834de81$exports = $38f6601e3834de81$var$flattenIntoArray;





var $6eab3c345ba4bc77$exports = {};
'use strict';
var $46ef96f2d52f728e$exports = {};
'use strict';

var $d81cf5a9f1de1452$exports = {};
'use strict';






var $d81cf5a9f1de1452$var$noop = function() {};
var $d81cf5a9f1de1452$var$construct = $a262b772204f9131$exports('Reflect', 'construct');
var $d81cf5a9f1de1452$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $d81cf5a9f1de1452$var$exec = $966303461c07e127$exports($d81cf5a9f1de1452$var$constructorRegExp.exec);
var $d81cf5a9f1de1452$var$INCORRECT_TO_STRING = !$d81cf5a9f1de1452$var$constructorRegExp.test($d81cf5a9f1de1452$var$noop);
var $d81cf5a9f1de1452$var$isConstructorModern = function isConstructor(argument) {
    if (!$66733457c42e4bfd$exports(argument)) return false;
    try {
        $d81cf5a9f1de1452$var$construct($d81cf5a9f1de1452$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $d81cf5a9f1de1452$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$66733457c42e4bfd$exports(argument)) return false;
    switch($39673a197979f5e7$exports(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $d81cf5a9f1de1452$var$INCORRECT_TO_STRING || !!$d81cf5a9f1de1452$var$exec($d81cf5a9f1de1452$var$constructorRegExp, $12069b4949848a4e$exports(argument));
    } catch (error) {
        return true;
    }
};
$d81cf5a9f1de1452$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$d81cf5a9f1de1452$exports = !$d81cf5a9f1de1452$var$construct || $10beeae1ca6f1357$exports(function() {
    var called;
    return $d81cf5a9f1de1452$var$isConstructorModern($d81cf5a9f1de1452$var$isConstructorModern.call) || !$d81cf5a9f1de1452$var$isConstructorModern(Object) || !$d81cf5a9f1de1452$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $d81cf5a9f1de1452$var$isConstructorLegacy : $d81cf5a9f1de1452$var$isConstructorModern;




var $46ef96f2d52f728e$var$SPECIES = $2f02eb6a25cfaf08$exports('species');
var $46ef96f2d52f728e$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$46ef96f2d52f728e$exports = function(originalArray) {
    var C;
    if ($dbbf9b0a5a4ce70b$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($d81cf5a9f1de1452$exports(C) && (C === $46ef96f2d52f728e$var$$Array || $dbbf9b0a5a4ce70b$exports(C.prototype))) C = undefined;
        else if ($96a478191b33f4fa$exports(C)) {
            C = C[$46ef96f2d52f728e$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $46ef96f2d52f728e$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$6eab3c345ba4bc77$exports = function(originalArray, length) {
    return new ($46ef96f2d52f728e$exports(originalArray))(length === 0 ? 0 : length);
};


// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$ca66147c52f1c36f$exports({
    target: 'Array',
    proto: true
}, {
    flat: function flat() {
        var depthArg = arguments.length ? arguments[0] : undefined;
        var O = $3281447d22a40e21$exports(this);
        var sourceLen = $ffd1deb5f4ba5f93$exports(O);
        var A = $6eab3c345ba4bc77$exports(O, 0);
        A.length = $38f6601e3834de81$exports(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : $9f3eb545512efe9e$exports(depthArg));
        return A;
    }
});


'use strict';






// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$ca66147c52f1c36f$exports({
    target: 'Array',
    proto: true
}, {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $3281447d22a40e21$exports(this);
        var sourceLen = $ffd1deb5f4ba5f93$exports(O);
        var A;
        $ac451d11dfa909df$exports(callbackfn);
        A = $6eab3c345ba4bc77$exports(O, 0);
        A.length = $38f6601e3834de81$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return A;
    }
});


'use strict';



var $d51580ac702bca13$var$nativeReverse = $966303461c07e127$exports([].reverse);
var $d51580ac702bca13$var$test = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$ca66147c52f1c36f$exports({
    target: 'Array',
    proto: true,
    forced: String($d51580ac702bca13$var$test) === String($d51580ac702bca13$var$test.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($dbbf9b0a5a4ce70b$exports(this)) this.length = this.length;
        return $d51580ac702bca13$var$nativeReverse(this);
    }
});


'use strict';





var $ae45a525b9fc11f1$exports = {};
'use strict';

var $ae45a525b9fc11f1$var$$TypeError = TypeError;
$ae45a525b9fc11f1$exports = function(O, P) {
    if (!delete O[P]) throw new $ae45a525b9fc11f1$var$$TypeError('Cannot delete property ' + $624baa4627a5b446$exports(P) + ' of ' + $624baa4627a5b446$exports(O));
};




var $716434f03ef1b685$exports = {};
'use strict';
var $7720efb2736da874$exports = {};
'use strict';

$7720efb2736da874$exports = $966303461c07e127$exports([].slice);


var $716434f03ef1b685$var$floor = Math.floor;
var $716434f03ef1b685$var$sort = function(array, comparefn) {
    var length = array.length;
    if (length < 8) {
        // insertion sort
        var i = 1;
        var element, j;
        while(i < length){
            j = i;
            element = array[i];
            while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
            if (j !== i++) array[j] = element;
        }
    } else {
        // merge sort
        var middle = $716434f03ef1b685$var$floor(length / 2);
        var left = $716434f03ef1b685$var$sort($7720efb2736da874$exports(array, 0, middle), comparefn);
        var right = $716434f03ef1b685$var$sort($7720efb2736da874$exports(array, middle), comparefn);
        var llength = left.length;
        var rlength = right.length;
        var lindex = 0;
        var rindex = 0;
        while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
    return array;
};
$716434f03ef1b685$exports = $716434f03ef1b685$var$sort;


var $3bde58ba77490dab$exports = {};
'use strict';

$3bde58ba77490dab$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $10beeae1ca6f1357$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};


var $c9ca29d7405627e5$exports = {};
'use strict';

var $c9ca29d7405627e5$var$firefox = $bcca79ca01f4b5fb$exports.match(/firefox\/(\d+)/i);
$c9ca29d7405627e5$exports = !!$c9ca29d7405627e5$var$firefox && +$c9ca29d7405627e5$var$firefox[1];


var $b3eb7c58d85007c6$exports = {};
'use strict';

$b3eb7c58d85007c6$exports = /MSIE|Trident/.test($bcca79ca01f4b5fb$exports);



var $af76fa95a3abaac9$exports = {};
'use strict';

var $af76fa95a3abaac9$var$webkit = $bcca79ca01f4b5fb$exports.match(/AppleWebKit\/(\d+)\./);
$af76fa95a3abaac9$exports = !!$af76fa95a3abaac9$var$webkit && +$af76fa95a3abaac9$var$webkit[1];


var $60f9cccd59b83b37$var$test = [];
var $60f9cccd59b83b37$var$nativeSort = $966303461c07e127$exports($60f9cccd59b83b37$var$test.sort);
var $60f9cccd59b83b37$var$push = $966303461c07e127$exports($60f9cccd59b83b37$var$test.push);
// IE8-
var $60f9cccd59b83b37$var$FAILS_ON_UNDEFINED = $10beeae1ca6f1357$exports(function() {
    $60f9cccd59b83b37$var$test.sort(undefined);
});
// V8 bug
var $60f9cccd59b83b37$var$FAILS_ON_NULL = $10beeae1ca6f1357$exports(function() {
    $60f9cccd59b83b37$var$test.sort(null);
});
// Old WebKit
var $60f9cccd59b83b37$var$STRICT_METHOD = $3bde58ba77490dab$exports('sort');
var $60f9cccd59b83b37$var$STABLE_SORT = !$10beeae1ca6f1357$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($cc9c540ab7776841$exports) return $cc9c540ab7776841$exports < 70;
    if ($c9ca29d7405627e5$exports && $c9ca29d7405627e5$exports > 3) return;
    if ($b3eb7c58d85007c6$exports) return true;
    if ($af76fa95a3abaac9$exports) return $af76fa95a3abaac9$exports < 603;
    var result = '';
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$60f9cccd59b83b37$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $60f9cccd59b83b37$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $60f9cccd59b83b37$var$test.length; index++){
        chr = $60f9cccd59b83b37$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== 'DGBEFHACIJK';
});
var $60f9cccd59b83b37$var$FORCED = $60f9cccd59b83b37$var$FAILS_ON_UNDEFINED || !$60f9cccd59b83b37$var$FAILS_ON_NULL || !$60f9cccd59b83b37$var$STRICT_METHOD || !$60f9cccd59b83b37$var$STABLE_SORT;
var $60f9cccd59b83b37$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $cc1f216aa7e44c59$exports(x) > $cc1f216aa7e44c59$exports(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$ca66147c52f1c36f$exports({
    target: 'Array',
    proto: true,
    forced: $60f9cccd59b83b37$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $ac451d11dfa909df$exports(comparefn);
        var array = $3281447d22a40e21$exports(this);
        if ($60f9cccd59b83b37$var$STABLE_SORT) return comparefn === undefined ? $60f9cccd59b83b37$var$nativeSort(array) : $60f9cccd59b83b37$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $ffd1deb5f4ba5f93$exports(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $60f9cccd59b83b37$var$push(items, array[index]);
        $716434f03ef1b685$exports(items, $60f9cccd59b83b37$var$getSortCompare(comparefn));
        itemsLength = $ffd1deb5f4ba5f93$exports(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$ae45a525b9fc11f1$exports(array, index++);
        return array;
    }
});


'use strict';
var $5fd67419be7a523c$exports = {};
'use strict';

var $cfd63855ca92cd7c$exports = {};
'use strict';

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $3cebfee288254ce6$export$2d1720544b23b823;
'use strict';





var $1093d14884b34661$exports = {};
'use strict';


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$1093d14884b34661$exports = Object.keys || function keys(O) {
    return $4a3892fc8411edf8$exports(O, $5e940fcac05c1bb4$exports);
};


$3cebfee288254ce6$export$2d1720544b23b823 = $ce6ba28f66317609$exports && !$c93a0f7d1b983b05$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $c7d52dd23854385b$exports(O);
    var props = $c76b30b2095e794e$exports(Properties);
    var keys = $1093d14884b34661$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$a334f8c362aafa38$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $797eb120e966f699$exports = {};
'use strict';

$797eb120e966f699$exports = $a262b772204f9131$exports('document', 'documentElement');




var $cfd63855ca92cd7c$var$GT = '>';
var $cfd63855ca92cd7c$var$LT = '<';
var $cfd63855ca92cd7c$var$PROTOTYPE = 'prototype';
var $cfd63855ca92cd7c$var$SCRIPT = 'script';
var $cfd63855ca92cd7c$var$IE_PROTO = $1949a81a9c5770b0$exports('IE_PROTO');
var $cfd63855ca92cd7c$var$EmptyConstructor = function() {};
var $cfd63855ca92cd7c$var$scriptTag = function(content) {
    return $cfd63855ca92cd7c$var$LT + $cfd63855ca92cd7c$var$SCRIPT + $cfd63855ca92cd7c$var$GT + content + $cfd63855ca92cd7c$var$LT + '/' + $cfd63855ca92cd7c$var$SCRIPT + $cfd63855ca92cd7c$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $cfd63855ca92cd7c$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($cfd63855ca92cd7c$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $cfd63855ca92cd7c$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $d0a57510c81c1621$exports('iframe');
    var JS = 'java' + $cfd63855ca92cd7c$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $797eb120e966f699$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($cfd63855ca92cd7c$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $cfd63855ca92cd7c$var$activeXDocument;
var $cfd63855ca92cd7c$var$NullProtoObject = function() {
    try {
        $cfd63855ca92cd7c$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $cfd63855ca92cd7c$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $cfd63855ca92cd7c$var$activeXDocument ? $cfd63855ca92cd7c$var$NullProtoObjectViaActiveX($cfd63855ca92cd7c$var$activeXDocument) // old IE
     : $cfd63855ca92cd7c$var$NullProtoObjectViaIFrame() : $cfd63855ca92cd7c$var$NullProtoObjectViaActiveX($cfd63855ca92cd7c$var$activeXDocument); // WSH
    var length = $5e940fcac05c1bb4$exports.length;
    while(length--)delete $cfd63855ca92cd7c$var$NullProtoObject[$cfd63855ca92cd7c$var$PROTOTYPE][$5e940fcac05c1bb4$exports[length]];
    return $cfd63855ca92cd7c$var$NullProtoObject();
};
$15a8dc1e99b1ac8f$exports[$cfd63855ca92cd7c$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$cfd63855ca92cd7c$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $cfd63855ca92cd7c$var$EmptyConstructor[$cfd63855ca92cd7c$var$PROTOTYPE] = $c7d52dd23854385b$exports(O);
        result = new $cfd63855ca92cd7c$var$EmptyConstructor();
        $cfd63855ca92cd7c$var$EmptyConstructor[$cfd63855ca92cd7c$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$cfd63855ca92cd7c$var$IE_PROTO] = O;
    } else result = $cfd63855ca92cd7c$var$NullProtoObject();
    return Properties === undefined ? result : $3cebfee288254ce6$export$2d1720544b23b823(result, Properties);
};



var $5fd67419be7a523c$require$defineProperty = $a334f8c362aafa38$export$2d1720544b23b823;
var $5fd67419be7a523c$var$UNSCOPABLES = $2f02eb6a25cfaf08$exports('unscopables');
var $5fd67419be7a523c$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($5fd67419be7a523c$var$ArrayPrototype[$5fd67419be7a523c$var$UNSCOPABLES] === undefined) $5fd67419be7a523c$require$defineProperty($5fd67419be7a523c$var$ArrayPrototype, $5fd67419be7a523c$var$UNSCOPABLES, {
    configurable: true,
    value: $cfd63855ca92cd7c$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$5fd67419be7a523c$exports = function(key) {
    $5fd67419be7a523c$var$ArrayPrototype[$5fd67419be7a523c$var$UNSCOPABLES][key] = true;
};


// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$5fd67419be7a523c$exports('flat');


'use strict';

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$5fd67419be7a523c$exports('flatMap');


'use strict';


var $e81d46ec19751ad8$exports = {};
'use strict';



var $c46b487bfa01a5ea$exports = {};
'use strict';
// eslint-disable-next-line es/no-typed-arrays -- safe
$c46b487bfa01a5ea$exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';





var $6ca4ef67338bdded$exports = {};
'use strict';

$6ca4ef67338bdded$exports = function(target, src, options) {
    for(var key in src)$a5378e288f28a3de$exports(target, key, src[key], options);
    return target;
};



var $e75aa794ae249210$exports = {};
'use strict';

var $e75aa794ae249210$var$$TypeError = TypeError;
$e75aa794ae249210$exports = function(it, Prototype) {
    if ($05d64d70d0804181$exports(Prototype, it)) return it;
    throw new $e75aa794ae249210$var$$TypeError('Incorrect invocation');
};




var $f8e63a566deab523$exports = {};
'use strict';


var $f8e63a566deab523$var$$RangeError = RangeError;
// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
$f8e63a566deab523$exports = function(it) {
    if (it === undefined) return 0;
    var number = $9f3eb545512efe9e$exports(it);
    var length = $462654e2015d596f$exports(number);
    if (number !== length) throw new $f8e63a566deab523$var$$RangeError('Wrong length or index');
    return length;
};


var $18b20c7125f37382$exports = {};
'use strict';
var $d2b65aaf45545e5c$exports = {};
'use strict';
var $b9413027964e63f3$exports = {};
'use strict';
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
$b9413027964e63f3$exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


var $d94cdb8707315168$exports = {};
'use strict';
var $d94cdb8707315168$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
var $d94cdb8707315168$var$INVERSE_EPSILON = 1 / $d94cdb8707315168$var$EPSILON;
$d94cdb8707315168$exports = function(n) {
    return n + $d94cdb8707315168$var$INVERSE_EPSILON - $d94cdb8707315168$var$INVERSE_EPSILON;
};


var $d2b65aaf45545e5c$var$abs = Math.abs;
var $d2b65aaf45545e5c$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
$d2b65aaf45545e5c$exports = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
    var n = +x;
    var absolute = $d2b65aaf45545e5c$var$abs(n);
    var s = $b9413027964e63f3$exports(n);
    if (absolute < FLOAT_MIN_VALUE) return s * $d94cdb8707315168$exports(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
    var a = (1 + FLOAT_EPSILON / $d2b65aaf45545e5c$var$EPSILON) * absolute;
    var result = a - (a - absolute);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
    return s * result;
};


var $18b20c7125f37382$var$FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var $18b20c7125f37382$var$FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var $18b20c7125f37382$var$FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
$18b20c7125f37382$exports = Math.fround || function fround(x) {
    return $d2b65aaf45545e5c$exports(x, $18b20c7125f37382$var$FLOAT32_EPSILON, $18b20c7125f37382$var$FLOAT32_MAX_VALUE, $18b20c7125f37382$var$FLOAT32_MIN_VALUE);
};


var $80f6ac531b5c70da$exports = {};
'use strict';
// IEEE754 conversions based on https://github.com/feross/ieee754
var $80f6ac531b5c70da$var$$Array = Array;
var $80f6ac531b5c70da$var$abs = Math.abs;
var $80f6ac531b5c70da$var$pow = Math.pow;
var $80f6ac531b5c70da$var$floor = Math.floor;
var $80f6ac531b5c70da$var$log = Math.log;
var $80f6ac531b5c70da$var$LN2 = Math.LN2;
var $80f6ac531b5c70da$var$pack = function(number, mantissaLength, bytes) {
    var buffer = $80f6ac531b5c70da$var$$Array(bytes);
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var rt = mantissaLength === 23 ? $80f6ac531b5c70da$var$pow(2, -24) - $80f6ac531b5c70da$var$pow(2, -77) : 0;
    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
    var index = 0;
    var exponent, mantissa, c;
    number = $80f6ac531b5c70da$var$abs(number);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number || number === Infinity) {
        // eslint-disable-next-line no-self-compare -- NaN check
        mantissa = number !== number ? 1 : 0;
        exponent = eMax;
    } else {
        exponent = $80f6ac531b5c70da$var$floor($80f6ac531b5c70da$var$log(number) / $80f6ac531b5c70da$var$LN2);
        c = $80f6ac531b5c70da$var$pow(2, -exponent);
        if (number * c < 1) {
            exponent--;
            c *= 2;
        }
        if (exponent + eBias >= 1) number += rt / c;
        else number += rt * $80f6ac531b5c70da$var$pow(2, 1 - eBias);
        if (number * c >= 2) {
            exponent++;
            c /= 2;
        }
        if (exponent + eBias >= eMax) {
            mantissa = 0;
            exponent = eMax;
        } else if (exponent + eBias >= 1) {
            mantissa = (number * c - 1) * $80f6ac531b5c70da$var$pow(2, mantissaLength);
            exponent += eBias;
        } else {
            mantissa = number * $80f6ac531b5c70da$var$pow(2, eBias - 1) * $80f6ac531b5c70da$var$pow(2, mantissaLength);
            exponent = 0;
        }
    }
    while(mantissaLength >= 8){
        buffer[index++] = mantissa & 255;
        mantissa /= 256;
        mantissaLength -= 8;
    }
    exponent = exponent << mantissaLength | mantissa;
    exponentLength += mantissaLength;
    while(exponentLength > 0){
        buffer[index++] = exponent & 255;
        exponent /= 256;
        exponentLength -= 8;
    }
    buffer[index - 1] |= sign * 128;
    return buffer;
};
var $80f6ac531b5c70da$var$unpack = function(buffer, mantissaLength) {
    var bytes = buffer.length;
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var nBits = exponentLength - 7;
    var index = bytes - 1;
    var sign = buffer[index--];
    var exponent = sign & 127;
    var mantissa;
    sign >>= 7;
    while(nBits > 0){
        exponent = exponent * 256 + buffer[index--];
        nBits -= 8;
    }
    mantissa = exponent & (1 << -nBits) - 1;
    exponent >>= -nBits;
    nBits += mantissaLength;
    while(nBits > 0){
        mantissa = mantissa * 256 + buffer[index--];
        nBits -= 8;
    }
    if (exponent === 0) exponent = 1 - eBias;
    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
    else {
        mantissa += $80f6ac531b5c70da$var$pow(2, mantissaLength);
        exponent -= eBias;
    }
    return (sign ? -1 : 1) * mantissa * $80f6ac531b5c70da$var$pow(2, exponent - mantissaLength);
};
$80f6ac531b5c70da$exports = {
    pack: $80f6ac531b5c70da$var$pack,
    unpack: $80f6ac531b5c70da$var$unpack
};


var $93253fe4514fc36d$exports = {};
'use strict';




var $283dcd17f15bbec7$exports = {};
'use strict';

$283dcd17f15bbec7$exports = !$10beeae1ca6f1357$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $93253fe4514fc36d$var$IE_PROTO = $1949a81a9c5770b0$exports('IE_PROTO');
var $93253fe4514fc36d$var$$Object = Object;
var $93253fe4514fc36d$var$ObjectPrototype = $93253fe4514fc36d$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$93253fe4514fc36d$exports = $283dcd17f15bbec7$exports ? $93253fe4514fc36d$var$$Object.getPrototypeOf : function(O) {
    var object = $3281447d22a40e21$exports(O);
    if ($1d9d3902a50a2fcd$exports(object, $93253fe4514fc36d$var$IE_PROTO)) return object[$93253fe4514fc36d$var$IE_PROTO];
    var constructor = object.constructor;
    if ($66733457c42e4bfd$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $93253fe4514fc36d$var$$Object ? $93253fe4514fc36d$var$ObjectPrototype : null;
};


var $60e5bf26176fe7cd$exports = {};
'use strict';
var $77aa6ef82c147863$exports = {};
'use strict';


$77aa6ef82c147863$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $966303461c07e127$exports($ac451d11dfa909df$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $9adef45ef1209f42$exports = {};
'use strict';
var $8b3a8c27680abe33$exports = {};
'use strict';

$8b3a8c27680abe33$exports = function(argument) {
    return $96a478191b33f4fa$exports(argument) || argument === null;
};


var $9adef45ef1209f42$var$$String = String;
var $9adef45ef1209f42$var$$TypeError = TypeError;
$9adef45ef1209f42$exports = function(argument) {
    if ($8b3a8c27680abe33$exports(argument)) return argument;
    throw new $9adef45ef1209f42$var$$TypeError("Can't set " + $9adef45ef1209f42$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$60e5bf26176fe7cd$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $77aa6ef82c147863$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $8fd6426c81bfca55$exports(O);
        $9adef45ef1209f42$exports(proto);
        if (!$96a478191b33f4fa$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);


var $c4b8b4b807bbc363$exports = {};
'use strict';



// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
$c4b8b4b807bbc363$exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $3281447d22a40e21$exports(this);
    var length = $ffd1deb5f4ba5f93$exports(O);
    var argumentsLength = arguments.length;
    var index = $82ea8bcccff50613$exports(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $82ea8bcccff50613$exports(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};



var $b00bcd5177827a19$exports = {};
'use strict';



// makes subclassing work correct for wrapped built-ins
$b00bcd5177827a19$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $60e5bf26176fe7cd$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $66733457c42e4bfd$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $96a478191b33f4fa$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $60e5bf26176fe7cd$exports($this, NewTargetPrototype);
    return $this;
};



var $7fe02f462050b03b$exports = {};
'use strict';

var $7fe02f462050b03b$require$defineProperty = $a334f8c362aafa38$export$2d1720544b23b823;


var $7fe02f462050b03b$var$TO_STRING_TAG = $2f02eb6a25cfaf08$exports('toStringTag');
$7fe02f462050b03b$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$1d9d3902a50a2fcd$exports(target, $7fe02f462050b03b$var$TO_STRING_TAG)) $7fe02f462050b03b$require$defineProperty(target, $7fe02f462050b03b$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $e81d46ec19751ad8$var$PROPER_FUNCTION_NAME = $c5158caaca2f8ecd$exports.PROPER;
var $e81d46ec19751ad8$var$CONFIGURABLE_FUNCTION_NAME = $c5158caaca2f8ecd$exports.CONFIGURABLE;
var $e81d46ec19751ad8$var$ARRAY_BUFFER = 'ArrayBuffer';
var $e81d46ec19751ad8$var$DATA_VIEW = 'DataView';
var $e81d46ec19751ad8$var$PROTOTYPE = 'prototype';
var $e81d46ec19751ad8$var$WRONG_LENGTH = 'Wrong length';
var $e81d46ec19751ad8$var$WRONG_INDEX = 'Wrong index';
var $e81d46ec19751ad8$var$getInternalArrayBufferState = $1f4f460c9ddf95ba$exports.getterFor($e81d46ec19751ad8$var$ARRAY_BUFFER);
var $e81d46ec19751ad8$var$getInternalDataViewState = $1f4f460c9ddf95ba$exports.getterFor($e81d46ec19751ad8$var$DATA_VIEW);
var $e81d46ec19751ad8$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $e81d46ec19751ad8$var$NativeArrayBuffer = $1cca30410cf11b53$exports[$e81d46ec19751ad8$var$ARRAY_BUFFER];
var $e81d46ec19751ad8$var$$ArrayBuffer = $e81d46ec19751ad8$var$NativeArrayBuffer;
var $e81d46ec19751ad8$var$ArrayBufferPrototype = $e81d46ec19751ad8$var$$ArrayBuffer && $e81d46ec19751ad8$var$$ArrayBuffer[$e81d46ec19751ad8$var$PROTOTYPE];
var $e81d46ec19751ad8$var$$DataView = $1cca30410cf11b53$exports[$e81d46ec19751ad8$var$DATA_VIEW];
var $e81d46ec19751ad8$var$DataViewPrototype = $e81d46ec19751ad8$var$$DataView && $e81d46ec19751ad8$var$$DataView[$e81d46ec19751ad8$var$PROTOTYPE];
var $e81d46ec19751ad8$var$ObjectPrototype = Object.prototype;
var $e81d46ec19751ad8$var$Array = $1cca30410cf11b53$exports.Array;
var $e81d46ec19751ad8$var$RangeError = $1cca30410cf11b53$exports.RangeError;
var $e81d46ec19751ad8$var$fill = $966303461c07e127$exports($c4b8b4b807bbc363$exports);
var $e81d46ec19751ad8$var$reverse = $966303461c07e127$exports([].reverse);
var $e81d46ec19751ad8$var$packIEEE754 = $80f6ac531b5c70da$exports.pack;
var $e81d46ec19751ad8$var$unpackIEEE754 = $80f6ac531b5c70da$exports.unpack;
var $e81d46ec19751ad8$var$packInt8 = function(number) {
    return [
        number & 0xFF
    ];
};
var $e81d46ec19751ad8$var$packInt16 = function(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF
    ];
};
var $e81d46ec19751ad8$var$packInt32 = function(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF,
        number >> 16 & 0xFF,
        number >> 24 & 0xFF
    ];
};
var $e81d46ec19751ad8$var$unpackInt32 = function(buffer) {
    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var $e81d46ec19751ad8$var$packFloat32 = function(number) {
    return $e81d46ec19751ad8$var$packIEEE754($18b20c7125f37382$exports(number), 23, 4);
};
var $e81d46ec19751ad8$var$packFloat64 = function(number) {
    return $e81d46ec19751ad8$var$packIEEE754(number, 52, 8);
};
var $e81d46ec19751ad8$var$addGetter = function(Constructor, key, getInternalState) {
    $ae34d1f2f4f59697$exports(Constructor[$e81d46ec19751ad8$var$PROTOTYPE], key, {
        configurable: true,
        get: function() {
            return getInternalState(this)[key];
        }
    });
};
var $e81d46ec19751ad8$var$get = function(view, count, index, isLittleEndian) {
    var store = $e81d46ec19751ad8$var$getInternalDataViewState(view);
    var intIndex = $f8e63a566deab523$exports(index);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $e81d46ec19751ad8$var$RangeError($e81d46ec19751ad8$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    var pack = $7720efb2736da874$exports(bytes, start, start + count);
    return boolIsLittleEndian ? pack : $e81d46ec19751ad8$var$reverse(pack);
};
var $e81d46ec19751ad8$var$set = function(view, count, index, conversion, value, isLittleEndian) {
    var store = $e81d46ec19751ad8$var$getInternalDataViewState(view);
    var intIndex = $f8e63a566deab523$exports(index);
    var pack = conversion(+value);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $e81d46ec19751ad8$var$RangeError($e81d46ec19751ad8$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    for(var i = 0; i < count; i++)bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};
if (!$c46b487bfa01a5ea$exports) {
    $e81d46ec19751ad8$var$$ArrayBuffer = function ArrayBuffer(length) {
        $e75aa794ae249210$exports(this, $e81d46ec19751ad8$var$ArrayBufferPrototype);
        var byteLength = $f8e63a566deab523$exports(length);
        $e81d46ec19751ad8$var$setInternalState(this, {
            type: $e81d46ec19751ad8$var$ARRAY_BUFFER,
            bytes: $e81d46ec19751ad8$var$fill($e81d46ec19751ad8$var$Array(byteLength), 0),
            byteLength: byteLength
        });
        if (!$ce6ba28f66317609$exports) {
            this.byteLength = byteLength;
            this.detached = false;
        }
    };
    $e81d46ec19751ad8$var$ArrayBufferPrototype = $e81d46ec19751ad8$var$$ArrayBuffer[$e81d46ec19751ad8$var$PROTOTYPE];
    $e81d46ec19751ad8$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $e75aa794ae249210$exports(this, $e81d46ec19751ad8$var$DataViewPrototype);
        $e75aa794ae249210$exports(buffer, $e81d46ec19751ad8$var$ArrayBufferPrototype);
        var bufferState = $e81d46ec19751ad8$var$getInternalArrayBufferState(buffer);
        var bufferLength = bufferState.byteLength;
        var offset = $9f3eb545512efe9e$exports(byteOffset);
        if (offset < 0 || offset > bufferLength) throw new $e81d46ec19751ad8$var$RangeError('Wrong offset');
        byteLength = byteLength === undefined ? bufferLength - offset : $462654e2015d596f$exports(byteLength);
        if (offset + byteLength > bufferLength) throw new $e81d46ec19751ad8$var$RangeError($e81d46ec19751ad8$var$WRONG_LENGTH);
        $e81d46ec19751ad8$var$setInternalState(this, {
            type: $e81d46ec19751ad8$var$DATA_VIEW,
            buffer: buffer,
            byteLength: byteLength,
            byteOffset: offset,
            bytes: bufferState.bytes
        });
        if (!$ce6ba28f66317609$exports) {
            this.buffer = buffer;
            this.byteLength = byteLength;
            this.byteOffset = offset;
        }
    };
    $e81d46ec19751ad8$var$DataViewPrototype = $e81d46ec19751ad8$var$$DataView[$e81d46ec19751ad8$var$PROTOTYPE];
    if ($ce6ba28f66317609$exports) {
        $e81d46ec19751ad8$var$addGetter($e81d46ec19751ad8$var$$ArrayBuffer, 'byteLength', $e81d46ec19751ad8$var$getInternalArrayBufferState);
        $e81d46ec19751ad8$var$addGetter($e81d46ec19751ad8$var$$DataView, 'buffer', $e81d46ec19751ad8$var$getInternalDataViewState);
        $e81d46ec19751ad8$var$addGetter($e81d46ec19751ad8$var$$DataView, 'byteLength', $e81d46ec19751ad8$var$getInternalDataViewState);
        $e81d46ec19751ad8$var$addGetter($e81d46ec19751ad8$var$$DataView, 'byteOffset', $e81d46ec19751ad8$var$getInternalDataViewState);
    }
    $6ca4ef67338bdded$exports($e81d46ec19751ad8$var$DataViewPrototype, {
        getInt8: function getInt8(byteOffset) {
            return $e81d46ec19751ad8$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $e81d46ec19751ad8$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $e81d46ec19751ad8$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $e81d46ec19751ad8$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $e81d46ec19751ad8$var$unpackInt32($e81d46ec19751ad8$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $e81d46ec19751ad8$var$unpackInt32($e81d46ec19751ad8$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $e81d46ec19751ad8$var$unpackIEEE754($e81d46ec19751ad8$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $e81d46ec19751ad8$var$unpackIEEE754($e81d46ec19751ad8$var$get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
        },
        setInt8: function setInt8(byteOffset, value) {
            $e81d46ec19751ad8$var$set(this, 1, byteOffset, $e81d46ec19751ad8$var$packInt8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $e81d46ec19751ad8$var$set(this, 1, byteOffset, $e81d46ec19751ad8$var$packInt8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $e81d46ec19751ad8$var$set(this, 2, byteOffset, $e81d46ec19751ad8$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $e81d46ec19751ad8$var$set(this, 2, byteOffset, $e81d46ec19751ad8$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $e81d46ec19751ad8$var$set(this, 4, byteOffset, $e81d46ec19751ad8$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $e81d46ec19751ad8$var$set(this, 4, byteOffset, $e81d46ec19751ad8$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $e81d46ec19751ad8$var$set(this, 4, byteOffset, $e81d46ec19751ad8$var$packFloat32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $e81d46ec19751ad8$var$set(this, 8, byteOffset, $e81d46ec19751ad8$var$packFloat64, value, arguments.length > 2 ? arguments[2] : false);
        }
    });
} else {
    var $e81d46ec19751ad8$var$INCORRECT_ARRAY_BUFFER_NAME = $e81d46ec19751ad8$var$PROPER_FUNCTION_NAME && $e81d46ec19751ad8$var$NativeArrayBuffer.name !== $e81d46ec19751ad8$var$ARRAY_BUFFER;
    /* eslint-disable no-new, sonarjs/inconsistent-function-call -- required for testing */ if (!$10beeae1ca6f1357$exports(function() {
        $e81d46ec19751ad8$var$NativeArrayBuffer(1);
    }) || !$10beeae1ca6f1357$exports(function() {
        new $e81d46ec19751ad8$var$NativeArrayBuffer(-1);
    }) || $10beeae1ca6f1357$exports(function() {
        new $e81d46ec19751ad8$var$NativeArrayBuffer();
        new $e81d46ec19751ad8$var$NativeArrayBuffer(1.5);
        new $e81d46ec19751ad8$var$NativeArrayBuffer(NaN);
        return $e81d46ec19751ad8$var$NativeArrayBuffer.length !== 1 || $e81d46ec19751ad8$var$INCORRECT_ARRAY_BUFFER_NAME && !$e81d46ec19751ad8$var$CONFIGURABLE_FUNCTION_NAME;
    })) {
        /* eslint-enable no-new, sonarjs/inconsistent-function-call -- required for testing */ $e81d46ec19751ad8$var$$ArrayBuffer = function ArrayBuffer(length) {
            $e75aa794ae249210$exports(this, $e81d46ec19751ad8$var$ArrayBufferPrototype);
            return $b00bcd5177827a19$exports(new $e81d46ec19751ad8$var$NativeArrayBuffer($f8e63a566deab523$exports(length)), this, $e81d46ec19751ad8$var$$ArrayBuffer);
        };
        $e81d46ec19751ad8$var$$ArrayBuffer[$e81d46ec19751ad8$var$PROTOTYPE] = $e81d46ec19751ad8$var$ArrayBufferPrototype;
        $e81d46ec19751ad8$var$ArrayBufferPrototype.constructor = $e81d46ec19751ad8$var$$ArrayBuffer;
        $ba431b68b50390cb$exports($e81d46ec19751ad8$var$$ArrayBuffer, $e81d46ec19751ad8$var$NativeArrayBuffer);
    } else if ($e81d46ec19751ad8$var$INCORRECT_ARRAY_BUFFER_NAME && $e81d46ec19751ad8$var$CONFIGURABLE_FUNCTION_NAME) $b4e3b093ae5606fa$exports($e81d46ec19751ad8$var$NativeArrayBuffer, 'name', $e81d46ec19751ad8$var$ARRAY_BUFFER);
    // WebKit bug - the same parent prototype for typed arrays and data view
    if ($60e5bf26176fe7cd$exports && $93253fe4514fc36d$exports($e81d46ec19751ad8$var$DataViewPrototype) !== $e81d46ec19751ad8$var$ObjectPrototype) $60e5bf26176fe7cd$exports($e81d46ec19751ad8$var$DataViewPrototype, $e81d46ec19751ad8$var$ObjectPrototype);
    // iOS Safari 7.x bug
    var $e81d46ec19751ad8$var$testView = new $e81d46ec19751ad8$var$$DataView(new $e81d46ec19751ad8$var$$ArrayBuffer(2));
    var $e81d46ec19751ad8$var$$setInt8 = $966303461c07e127$exports($e81d46ec19751ad8$var$DataViewPrototype.setInt8);
    $e81d46ec19751ad8$var$testView.setInt8(0, 2147483648);
    $e81d46ec19751ad8$var$testView.setInt8(1, 2147483649);
    if ($e81d46ec19751ad8$var$testView.getInt8(0) || !$e81d46ec19751ad8$var$testView.getInt8(1)) $6ca4ef67338bdded$exports($e81d46ec19751ad8$var$DataViewPrototype, {
        setInt8: function setInt8(byteOffset, value) {
            $e81d46ec19751ad8$var$$setInt8(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $e81d46ec19751ad8$var$$setInt8(this, byteOffset, value << 24 >> 24);
        }
    }, {
        unsafe: true
    });
}
$7fe02f462050b03b$exports($e81d46ec19751ad8$var$$ArrayBuffer, $e81d46ec19751ad8$var$ARRAY_BUFFER);
$7fe02f462050b03b$exports($e81d46ec19751ad8$var$$DataView, $e81d46ec19751ad8$var$DATA_VIEW);
$e81d46ec19751ad8$exports = {
    ArrayBuffer: $e81d46ec19751ad8$var$$ArrayBuffer,
    DataView: $e81d46ec19751ad8$var$$DataView
};


var $8d29cdfa1a37667d$exports = {};
'use strict';




var $8d29cdfa1a37667d$var$SPECIES = $2f02eb6a25cfaf08$exports('species');
$8d29cdfa1a37667d$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $a262b772204f9131$exports(CONSTRUCTOR_NAME);
    if ($ce6ba28f66317609$exports && Constructor && !Constructor[$8d29cdfa1a37667d$var$SPECIES]) $ae34d1f2f4f59697$exports(Constructor, $8d29cdfa1a37667d$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};


var $db6bbc2343164155$var$ARRAY_BUFFER = 'ArrayBuffer';
var $db6bbc2343164155$var$ArrayBuffer = $e81d46ec19751ad8$exports[$db6bbc2343164155$var$ARRAY_BUFFER];
var $db6bbc2343164155$var$NativeArrayBuffer = $1cca30410cf11b53$exports[$db6bbc2343164155$var$ARRAY_BUFFER];
// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$ca66147c52f1c36f$exports({
    global: true,
    constructor: true,
    forced: $db6bbc2343164155$var$NativeArrayBuffer !== $db6bbc2343164155$var$ArrayBuffer
}, {
    ArrayBuffer: $db6bbc2343164155$var$ArrayBuffer
});
$8d29cdfa1a37667d$exports($db6bbc2343164155$var$ARRAY_BUFFER);


'use strict';







var $13dcf455f5b4e0ec$var$ArrayBuffer = $e81d46ec19751ad8$exports.ArrayBuffer;
var $13dcf455f5b4e0ec$var$DataView = $e81d46ec19751ad8$exports.DataView;
var $13dcf455f5b4e0ec$var$DataViewPrototype = $13dcf455f5b4e0ec$var$DataView.prototype;
var $13dcf455f5b4e0ec$var$nativeArrayBufferSlice = $f587f14398031c29$exports($13dcf455f5b4e0ec$var$ArrayBuffer.prototype.slice);
var $13dcf455f5b4e0ec$var$getUint8 = $f587f14398031c29$exports($13dcf455f5b4e0ec$var$DataViewPrototype.getUint8);
var $13dcf455f5b4e0ec$var$setUint8 = $f587f14398031c29$exports($13dcf455f5b4e0ec$var$DataViewPrototype.setUint8);
var $13dcf455f5b4e0ec$var$INCORRECT_SLICE = $10beeae1ca6f1357$exports(function() {
    return !new $13dcf455f5b4e0ec$var$ArrayBuffer(2).slice(1, undefined).byteLength;
});
// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$ca66147c52f1c36f$exports({
    target: 'ArrayBuffer',
    proto: true,
    unsafe: true,
    forced: $13dcf455f5b4e0ec$var$INCORRECT_SLICE
}, {
    slice: function slice(start, end) {
        if ($13dcf455f5b4e0ec$var$nativeArrayBufferSlice && end === undefined) return $13dcf455f5b4e0ec$var$nativeArrayBufferSlice($c7d52dd23854385b$exports(this), start); // FF fix
        var length = $c7d52dd23854385b$exports(this).byteLength;
        var first = $82ea8bcccff50613$exports(start, length);
        var fin = $82ea8bcccff50613$exports(end === undefined ? length : end, length);
        var result = new $13dcf455f5b4e0ec$var$ArrayBuffer($462654e2015d596f$exports(fin - first));
        var viewSource = new $13dcf455f5b4e0ec$var$DataView(this);
        var viewTarget = new $13dcf455f5b4e0ec$var$DataView(result);
        var index = 0;
        while(first < fin)$13dcf455f5b4e0ec$var$setUint8(viewTarget, index++, $13dcf455f5b4e0ec$var$getUint8(viewSource, first++));
        return result;
    }
});


'use strict';

var $a33355781d2bfa3d$exports = {};
'use strict';




var $7da3fc42db2cd048$exports = {};
'use strict';

var $45e5c1d92d8f6e7f$exports = {};
'use strict';
$45e5c1d92d8f6e7f$exports = {};


var $7da3fc42db2cd048$var$ITERATOR = $2f02eb6a25cfaf08$exports('iterator');
var $7da3fc42db2cd048$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$7da3fc42db2cd048$exports = function(it) {
    return it !== undefined && ($45e5c1d92d8f6e7f$exports.Array === it || $7da3fc42db2cd048$var$ArrayPrototype[$7da3fc42db2cd048$var$ITERATOR] === it);
};




var $f9d5016d77a62d39$exports = {};
'use strict';




var $44917bb2b551135b$exports = {};
'use strict';





var $44917bb2b551135b$var$ITERATOR = $2f02eb6a25cfaf08$exports('iterator');
$44917bb2b551135b$exports = function(it) {
    if (!$fc561a35c297b392$exports(it)) return $cb7d485ba5a2e30b$exports(it, $44917bb2b551135b$var$ITERATOR) || $cb7d485ba5a2e30b$exports(it, '@@iterator') || $45e5c1d92d8f6e7f$exports[$39673a197979f5e7$exports(it)];
};


var $f9d5016d77a62d39$var$$TypeError = TypeError;
$f9d5016d77a62d39$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $44917bb2b551135b$exports(argument) : usingIterator;
    if ($ac451d11dfa909df$exports(iteratorMethod)) return $c7d52dd23854385b$exports($6dd48e140907213f$exports(iteratorMethod, argument));
    throw new $f9d5016d77a62d39$var$$TypeError($624baa4627a5b446$exports(argument) + ' is not iterable');
};



var $970ad60dab2ac818$exports = {};
'use strict';



$970ad60dab2ac818$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c7d52dd23854385b$exports(iterator);
    try {
        innerResult = $cb7d485ba5a2e30b$exports(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $6dd48e140907213f$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $c7d52dd23854385b$exports(innerResult);
    return value;
};


var $a33355781d2bfa3d$var$$TypeError = TypeError;
var $a33355781d2bfa3d$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a33355781d2bfa3d$var$ResultPrototype = $a33355781d2bfa3d$var$Result.prototype;
$a33355781d2bfa3d$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $2d52694feff5f895$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $970ad60dab2ac818$exports(iterator, 'normal');
        return new $a33355781d2bfa3d$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $c7d52dd23854385b$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $44917bb2b551135b$exports(iterable);
        if (!iterFn) throw new $a33355781d2bfa3d$var$$TypeError($624baa4627a5b446$exports(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($7da3fc42db2cd048$exports(iterFn)) {
            for(index = 0, length = $ffd1deb5f4ba5f93$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $05d64d70d0804181$exports($a33355781d2bfa3d$var$ResultPrototype, result)) return result;
            }
            return new $a33355781d2bfa3d$var$Result(false);
        }
        iterator = $f9d5016d77a62d39$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $6dd48e140907213f$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $970ad60dab2ac818$exports(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && $05d64d70d0804181$exports($a33355781d2bfa3d$var$ResultPrototype, result)) return result;
    }
    return new $a33355781d2bfa3d$var$Result(false);
};


var $6aba7e79cb797392$exports = {};
'use strict';



$6aba7e79cb797392$exports = function(object, key, value) {
    if ($ce6ba28f66317609$exports) $a334f8c362aafa38$export$2d1720544b23b823(object, key, $b941c4cd0c3c4a09$exports(0, value));
    else object[key] = value;
};


// `Object.fromEntries` method
// https://tc39.es/ecma262/#sec-object.fromentries
$ca66147c52f1c36f$exports({
    target: 'Object',
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        $a33355781d2bfa3d$exports(iterable, function(k, v) {
            $6aba7e79cb797392$exports(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});


'use strict';


var $829d0cfc1679e6db$exports = {};
'use strict';

$829d0cfc1679e6db$exports = $1cca30410cf11b53$exports.Promise;





var $04bcffad7dfc75d7$exports = {};
'use strict';

var $799ef19a1a3659da$exports = {};
'use strict';


var $799ef19a1a3659da$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$799ef19a1a3659da$exports = function(argument) {
    if ($d81cf5a9f1de1452$exports(argument)) return argument;
    throw new $799ef19a1a3659da$var$$TypeError($624baa4627a5b446$exports(argument) + ' is not a constructor');
};




var $04bcffad7dfc75d7$var$SPECIES = $2f02eb6a25cfaf08$exports('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$04bcffad7dfc75d7$exports = function(O, defaultConstructor) {
    var C = $c7d52dd23854385b$exports(O).constructor;
    var S;
    return C === undefined || $fc561a35c297b392$exports(S = $c7d52dd23854385b$exports(C)[$04bcffad7dfc75d7$var$SPECIES]) ? defaultConstructor : $799ef19a1a3659da$exports(S);
};


var $f7e58d4c8fa3d8c4$exports = {};
'use strict';


// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $f491a36e63b3b535$export$2d1720544b23b823;
'use strict';

var $f491a36e63b3b535$var$$TypeError = TypeError;
var $f491a36e63b3b535$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $f491a36e63b3b535$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $ac451d11dfa909df$exports(resolve);
    this.reject = $ac451d11dfa909df$exports(reject);
};
$f491a36e63b3b535$export$2d1720544b23b823 = function(C) {
    return new $f491a36e63b3b535$var$PromiseCapability(C);
};


$f7e58d4c8fa3d8c4$exports = function(C, x) {
    $c7d52dd23854385b$exports(C);
    if ($96a478191b33f4fa$exports(x) && x.constructor === C) return x;
    var promiseCapability = $f491a36e63b3b535$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};



var $b513d43ff0d6198f$var$NativePromisePrototype = $829d0cfc1679e6db$exports && $829d0cfc1679e6db$exports.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $b513d43ff0d6198f$var$NON_GENERIC = !!$829d0cfc1679e6db$exports && $10beeae1ca6f1357$exports(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $b513d43ff0d6198f$var$NativePromisePrototype['finally'].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$ca66147c52f1c36f$exports({
    target: 'Promise',
    proto: true,
    real: true,
    forced: $b513d43ff0d6198f$var$NON_GENERIC
}, {
    'finally': function(onFinally) {
        var C = $04bcffad7dfc75d7$exports(this, $a262b772204f9131$exports('Promise'));
        var isFunction = $66733457c42e4bfd$exports(onFinally);
        return this.then(isFunction ? function(x) {
            return $f7e58d4c8fa3d8c4$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $f7e58d4c8fa3d8c4$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$0f2d8b335bd97f65$exports && $66733457c42e4bfd$exports($829d0cfc1679e6db$exports)) {
    var $b513d43ff0d6198f$var$method = $a262b772204f9131$exports('Promise').prototype['finally'];
    if ($b513d43ff0d6198f$var$NativePromisePrototype['finally'] !== $b513d43ff0d6198f$var$method) $a5378e288f28a3de$exports($b513d43ff0d6198f$var$NativePromisePrototype, 'finally', $b513d43ff0d6198f$var$method, {
        unsafe: true
    });
}


'use strict';








var $7db9612b0f78b4b9$require$getOwnPropertyNames = $42f35ac27ca8991e$export$2d1720544b23b823;

var $ee87bb9f21e79629$exports = {};
'use strict';



var $ee87bb9f21e79629$var$MATCH = $2f02eb6a25cfaf08$exports('match');
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
$ee87bb9f21e79629$exports = function(it) {
    var isRegExp;
    return $96a478191b33f4fa$exports(it) && ((isRegExp = it[$ee87bb9f21e79629$var$MATCH]) !== undefined ? !!isRegExp : $11458573e8c84e00$exports(it) === 'RegExp');
};



var $3b8fa5b93677d7ee$exports = {};
'use strict';



var $306f7ba6eea8d5cb$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $306f7ba6eea8d5cb$var$RegExp = $1cca30410cf11b53$exports.RegExp;
var $306f7ba6eea8d5cb$var$FLAGS_GETTER_IS_CORRECT = !$10beeae1ca6f1357$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $306f7ba6eea8d5cb$var$RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($306f7ba6eea8d5cb$var$RegExp.prototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
$306f7ba6eea8d5cb$exports = {
    correct: $306f7ba6eea8d5cb$var$FLAGS_GETTER_IS_CORRECT
};


var $36a0e40f840023fd$exports = {};
'use strict';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$36a0e40f840023fd$exports = function() {
    var that = $c7d52dd23854385b$exports(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};


var $3b8fa5b93677d7ee$var$RegExpPrototype = RegExp.prototype;
$3b8fa5b93677d7ee$exports = $306f7ba6eea8d5cb$exports.correct ? function(it) {
    return it.flags;
} : function(it) {
    return !$306f7ba6eea8d5cb$exports.correct && $05d64d70d0804181$exports($3b8fa5b93677d7ee$var$RegExpPrototype, it) && !$1d9d3902a50a2fcd$exports(it, 'flags') ? $6dd48e140907213f$exports($36a0e40f840023fd$exports, it) : it.flags;
};


var $a7d146820b3b8ae3$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $a7d146820b3b8ae3$var$$RegExp = $1cca30410cf11b53$exports.RegExp;
var $a7d146820b3b8ae3$var$UNSUPPORTED_Y = $10beeae1ca6f1357$exports(function() {
    var re = $a7d146820b3b8ae3$var$$RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $a7d146820b3b8ae3$var$MISSED_STICKY = $a7d146820b3b8ae3$var$UNSUPPORTED_Y || $10beeae1ca6f1357$exports(function() {
    return !$a7d146820b3b8ae3$var$$RegExp('a', 'y').sticky;
});
var $a7d146820b3b8ae3$var$BROKEN_CARET = $a7d146820b3b8ae3$var$UNSUPPORTED_Y || $10beeae1ca6f1357$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $a7d146820b3b8ae3$var$$RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') !== null;
});
$a7d146820b3b8ae3$exports = {
    BROKEN_CARET: $a7d146820b3b8ae3$var$BROKEN_CARET,
    MISSED_STICKY: $a7d146820b3b8ae3$var$MISSED_STICKY,
    UNSUPPORTED_Y: $a7d146820b3b8ae3$var$UNSUPPORTED_Y
};


var $bf49694bd512ae5c$exports = {};
'use strict';

var $bf49694bd512ae5c$require$defineProperty = $a334f8c362aafa38$export$2d1720544b23b823;
$bf49694bd512ae5c$exports = function(Target, Source, key) {
    key in Target || $bf49694bd512ae5c$require$defineProperty(Target, key, {
        configurable: true,
        get: function() {
            return Source[key];
        },
        set: function(it) {
            Source[key] = it;
        }
    });
};






var $7db9612b0f78b4b9$require$enforceInternalState = $1f4f460c9ddf95ba$exports.enforce;


var $3905a0e25b44a4cc$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $3905a0e25b44a4cc$var$$RegExp = $1cca30410cf11b53$exports.RegExp;
$3905a0e25b44a4cc$exports = $10beeae1ca6f1357$exports(function() {
    var re = $3905a0e25b44a4cc$var$$RegExp('.', 's');
    return !(re.dotAll && re.test('\n') && re.flags === 's');
});


var $63551198a3745407$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $63551198a3745407$var$$RegExp = $1cca30410cf11b53$exports.RegExp;
$63551198a3745407$exports = $10beeae1ca6f1357$exports(function() {
    var re = $63551198a3745407$var$$RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});


var $7db9612b0f78b4b9$var$MATCH = $2f02eb6a25cfaf08$exports('match');
var $7db9612b0f78b4b9$var$NativeRegExp = $1cca30410cf11b53$exports.RegExp;
var $7db9612b0f78b4b9$var$RegExpPrototype = $7db9612b0f78b4b9$var$NativeRegExp.prototype;
var $7db9612b0f78b4b9$var$SyntaxError = $1cca30410cf11b53$exports.SyntaxError;
var $7db9612b0f78b4b9$var$exec = $966303461c07e127$exports($7db9612b0f78b4b9$var$RegExpPrototype.exec);
var $7db9612b0f78b4b9$var$charAt = $966303461c07e127$exports(''.charAt);
var $7db9612b0f78b4b9$var$replace = $966303461c07e127$exports(''.replace);
var $7db9612b0f78b4b9$var$stringIndexOf = $966303461c07e127$exports(''.indexOf);
var $7db9612b0f78b4b9$var$stringSlice = $966303461c07e127$exports(''.slice);
// TODO: Use only proper RegExpIdentifierName
var $7db9612b0f78b4b9$var$IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var $7db9612b0f78b4b9$var$re1 = /a/g;
var $7db9612b0f78b4b9$var$re2 = /a/g;
// "new" should create a new object, old webkit bug
var $7db9612b0f78b4b9$var$CORRECT_NEW = new $7db9612b0f78b4b9$var$NativeRegExp($7db9612b0f78b4b9$var$re1) !== $7db9612b0f78b4b9$var$re1;
var $7db9612b0f78b4b9$var$MISSED_STICKY = $a7d146820b3b8ae3$exports.MISSED_STICKY;
var $7db9612b0f78b4b9$var$UNSUPPORTED_Y = $a7d146820b3b8ae3$exports.UNSUPPORTED_Y;
var $7db9612b0f78b4b9$var$BASE_FORCED = $ce6ba28f66317609$exports && (!$7db9612b0f78b4b9$var$CORRECT_NEW || $7db9612b0f78b4b9$var$MISSED_STICKY || $3905a0e25b44a4cc$exports || $63551198a3745407$exports || $10beeae1ca6f1357$exports(function() {
    $7db9612b0f78b4b9$var$re2[$7db9612b0f78b4b9$var$MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    // eslint-disable-next-line sonarjs/inconsistent-function-call -- required for testing
    return $7db9612b0f78b4b9$var$NativeRegExp($7db9612b0f78b4b9$var$re1) !== $7db9612b0f78b4b9$var$re1 || $7db9612b0f78b4b9$var$NativeRegExp($7db9612b0f78b4b9$var$re2) === $7db9612b0f78b4b9$var$re2 || String($7db9612b0f78b4b9$var$NativeRegExp($7db9612b0f78b4b9$var$re1, 'i')) !== '/a/i';
}));
var $7db9612b0f78b4b9$var$handleDotAll = function(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var brackets = false;
    var chr;
    for(; index <= length; index++){
        chr = $7db9612b0f78b4b9$var$charAt(string, index);
        if (chr === '\\') {
            result += chr + $7db9612b0f78b4b9$var$charAt(string, ++index);
            continue;
        }
        if (!brackets && chr === '.') result += '[\\s\\S]';
        else {
            if (chr === '[') brackets = true;
            else if (chr === ']') brackets = false;
            result += chr;
        }
    }
    return result;
};
var $7db9612b0f78b4b9$var$handleNCG = function(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var named = [];
    var names = $cfd63855ca92cd7c$exports(null);
    var brackets = false;
    var ncg = false;
    var groupid = 0;
    var groupname = '';
    var chr;
    for(; index <= length; index++){
        chr = $7db9612b0f78b4b9$var$charAt(string, index);
        if (chr === '\\') chr += $7db9612b0f78b4b9$var$charAt(string, ++index);
        else if (chr === ']') brackets = false;
        else if (!brackets) switch(true){
            case chr === '[':
                brackets = true;
                break;
            case chr === '(':
                result += chr;
                // ignore non-capturing groups
                if ($7db9612b0f78b4b9$var$stringSlice(string, index + 1, index + 3) === '?:') continue;
                if ($7db9612b0f78b4b9$var$exec($7db9612b0f78b4b9$var$IS_NCG, $7db9612b0f78b4b9$var$stringSlice(string, index + 1))) {
                    index += 2;
                    ncg = true;
                }
                groupid++;
                continue;
            case chr === '>' && ncg:
                if (groupname === '' || $1d9d3902a50a2fcd$exports(names, groupname)) throw new $7db9612b0f78b4b9$var$SyntaxError('Invalid capture group name');
                names[groupname] = true;
                named[named.length] = [
                    groupname,
                    groupid
                ];
                ncg = false;
                groupname = '';
                continue;
        }
        if (ncg) groupname += chr;
        else result += chr;
    }
    return [
        result,
        named
    ];
};
// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if ($77d6726afe62b52c$exports('RegExp', $7db9612b0f78b4b9$var$BASE_FORCED)) {
    var $7db9612b0f78b4b9$var$RegExpWrapper = function RegExp(pattern, flags) {
        var thisIsRegExp = $05d64d70d0804181$exports($7db9612b0f78b4b9$var$RegExpPrototype, this);
        var patternIsRegExp = $ee87bb9f21e79629$exports(pattern);
        var flagsAreUndefined = flags === undefined;
        var groups = [];
        var rawPattern = pattern;
        var rawFlags, dotAll, sticky, handled, result, state;
        if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === $7db9612b0f78b4b9$var$RegExpWrapper) return pattern;
        if (patternIsRegExp || $05d64d70d0804181$exports($7db9612b0f78b4b9$var$RegExpPrototype, pattern)) {
            pattern = pattern.source;
            if (flagsAreUndefined) flags = $3b8fa5b93677d7ee$exports(rawPattern);
        }
        pattern = pattern === undefined ? '' : $cc1f216aa7e44c59$exports(pattern);
        flags = flags === undefined ? '' : $cc1f216aa7e44c59$exports(flags);
        rawPattern = pattern;
        if ($3905a0e25b44a4cc$exports && 'dotAll' in $7db9612b0f78b4b9$var$re1) {
            dotAll = !!flags && $7db9612b0f78b4b9$var$stringIndexOf(flags, 's') > -1;
            if (dotAll) flags = $7db9612b0f78b4b9$var$replace(flags, /s/g, '');
        }
        rawFlags = flags;
        if ($7db9612b0f78b4b9$var$MISSED_STICKY && 'sticky' in $7db9612b0f78b4b9$var$re1) {
            sticky = !!flags && $7db9612b0f78b4b9$var$stringIndexOf(flags, 'y') > -1;
            if (sticky && $7db9612b0f78b4b9$var$UNSUPPORTED_Y) flags = $7db9612b0f78b4b9$var$replace(flags, /y/g, '');
        }
        if ($63551198a3745407$exports) {
            handled = $7db9612b0f78b4b9$var$handleNCG(pattern);
            pattern = handled[0];
            groups = handled[1];
        }
        result = $b00bcd5177827a19$exports($7db9612b0f78b4b9$var$NativeRegExp(pattern, flags), thisIsRegExp ? this : $7db9612b0f78b4b9$var$RegExpPrototype, $7db9612b0f78b4b9$var$RegExpWrapper);
        if (dotAll || sticky || groups.length) {
            state = $7db9612b0f78b4b9$require$enforceInternalState(result);
            if (dotAll) {
                state.dotAll = true;
                state.raw = $7db9612b0f78b4b9$var$RegExpWrapper($7db9612b0f78b4b9$var$handleDotAll(pattern), rawFlags);
            }
            if (sticky) state.sticky = true;
            if (groups.length) state.groups = groups;
        }
        if (pattern !== rawPattern) try {
            // fails in old engines, but we have no alternatives for unsupported regex syntax
            $b4e3b093ae5606fa$exports(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
        } catch (error) {}
        return result;
    };
    for(var $7db9612b0f78b4b9$var$keys = $7db9612b0f78b4b9$require$getOwnPropertyNames($7db9612b0f78b4b9$var$NativeRegExp), $7db9612b0f78b4b9$var$index = 0; $7db9612b0f78b4b9$var$keys.length > $7db9612b0f78b4b9$var$index;)$bf49694bd512ae5c$exports($7db9612b0f78b4b9$var$RegExpWrapper, $7db9612b0f78b4b9$var$NativeRegExp, $7db9612b0f78b4b9$var$keys[$7db9612b0f78b4b9$var$index++]);
    $7db9612b0f78b4b9$var$RegExpPrototype.constructor = $7db9612b0f78b4b9$var$RegExpWrapper;
    $7db9612b0f78b4b9$var$RegExpWrapper.prototype = $7db9612b0f78b4b9$var$RegExpPrototype;
    $a5378e288f28a3de$exports($1cca30410cf11b53$exports, 'RegExp', $7db9612b0f78b4b9$var$RegExpWrapper, {
        constructor: true
    });
}
// https://tc39.es/ecma262/#sec-get-regexp-@@species
$8d29cdfa1a37667d$exports('RegExp');


'use strict';

var $1c5f4705a7e166a5$exports = {};
'use strict';








var $1c5f4705a7e166a5$require$getInternalState = $1f4f460c9ddf95ba$exports.get;


var $1c5f4705a7e166a5$var$nativeReplace = $310c440ce6020a4b$exports('native-string-replace', String.prototype.replace);
var $1c5f4705a7e166a5$var$nativeExec = RegExp.prototype.exec;
var $1c5f4705a7e166a5$var$patchedExec = $1c5f4705a7e166a5$var$nativeExec;
var $1c5f4705a7e166a5$var$charAt = $966303461c07e127$exports(''.charAt);
var $1c5f4705a7e166a5$var$indexOf = $966303461c07e127$exports(''.indexOf);
var $1c5f4705a7e166a5$var$replace = $966303461c07e127$exports(''.replace);
var $1c5f4705a7e166a5$var$stringSlice = $966303461c07e127$exports(''.slice);
var $1c5f4705a7e166a5$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $6dd48e140907213f$exports($1c5f4705a7e166a5$var$nativeExec, re1, 'a');
    $6dd48e140907213f$exports($1c5f4705a7e166a5$var$nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $1c5f4705a7e166a5$var$UNSUPPORTED_Y = $a7d146820b3b8ae3$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $1c5f4705a7e166a5$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $1c5f4705a7e166a5$var$PATCH = $1c5f4705a7e166a5$var$UPDATES_LAST_INDEX_WRONG || $1c5f4705a7e166a5$var$NPCG_INCLUDED || $1c5f4705a7e166a5$var$UNSUPPORTED_Y || $3905a0e25b44a4cc$exports || $63551198a3745407$exports;
if ($1c5f4705a7e166a5$var$PATCH) $1c5f4705a7e166a5$var$patchedExec = function exec(string) {
    var re = this;
    var state = $1c5f4705a7e166a5$require$getInternalState(re);
    var str = $cc1f216aa7e44c59$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $6dd48e140907213f$exports($1c5f4705a7e166a5$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $1c5f4705a7e166a5$var$UNSUPPORTED_Y && re.sticky;
    var flags = $6dd48e140907213f$exports($36a0e40f840023fd$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $1c5f4705a7e166a5$var$replace(flags, 'y', '');
        if ($1c5f4705a7e166a5$var$indexOf(flags, 'g') === -1) flags += 'g';
        strCopy = $1c5f4705a7e166a5$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $1c5f4705a7e166a5$var$charAt(str, re.lastIndex - 1) !== '\n')) {
            source = '(?: ' + source + ')';
            strCopy = ' ' + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if ($1c5f4705a7e166a5$var$NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    if ($1c5f4705a7e166a5$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $6dd48e140907213f$exports($1c5f4705a7e166a5$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $1c5f4705a7e166a5$var$stringSlice(match.input, charsAdded);
            match[0] = $1c5f4705a7e166a5$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($1c5f4705a7e166a5$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($1c5f4705a7e166a5$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $6dd48e140907213f$exports($1c5f4705a7e166a5$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $cfd63855ca92cd7c$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$1c5f4705a7e166a5$exports = $1c5f4705a7e166a5$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$ca66147c52f1c36f$exports({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== $1c5f4705a7e166a5$exports
}, {
    exec: $1c5f4705a7e166a5$exports
});


'use strict';




// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($ce6ba28f66317609$exports && !$306f7ba6eea8d5cb$exports.correct) {
    $ae34d1f2f4f59697$exports(RegExp.prototype, 'flags', {
        configurable: true,
        get: $36a0e40f840023fd$exports
    });
    $306f7ba6eea8d5cb$exports.correct = true;
}


'use strict';
var $36ddd4c4a517e2d6$exports = {};
'use strict';

var $36ddd4c4a517e2d6$var$FunctionPrototype = Function.prototype;
var $36ddd4c4a517e2d6$var$apply = $36ddd4c4a517e2d6$var$FunctionPrototype.apply;
var $36ddd4c4a517e2d6$var$call = $36ddd4c4a517e2d6$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$36ddd4c4a517e2d6$exports = typeof Reflect == 'object' && Reflect.apply || ($a1a957feecabdd81$exports ? $36ddd4c4a517e2d6$var$call.bind($36ddd4c4a517e2d6$var$apply) : function() {
    return $36ddd4c4a517e2d6$var$call.apply($36ddd4c4a517e2d6$var$apply, arguments);
});




var $2a60274b33b64c4d$exports = {};
'use strict';







var $2a60274b33b64c4d$var$SPECIES = $2f02eb6a25cfaf08$exports('species');
var $2a60274b33b64c4d$var$RegExpPrototype = RegExp.prototype;
$2a60274b33b64c4d$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $2f02eb6a25cfaf08$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$10beeae1ca6f1357$exports(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$10beeae1ca6f1357$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$2a60274b33b64c4d$var$SPECIES] = function() {
                return re;
            };
            re.flags = '';
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]('');
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $1c5f4705a7e166a5$exports || $exec === $2a60274b33b64c4d$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: $6dd48e140907213f$exports(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: $6dd48e140907213f$exports(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $a5378e288f28a3de$exports(String.prototype, KEY, methods[0]);
        $a5378e288f28a3de$exports($2a60274b33b64c4d$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $b4e3b093ae5606fa$exports($2a60274b33b64c4d$var$RegExpPrototype[SYMBOL], 'sham', true);
};










var $1ccd1cb6286a6040$exports = {};
'use strict';
var $63ce28df052c8c19$exports = {};
'use strict';




var $63ce28df052c8c19$var$charAt = $966303461c07e127$exports(''.charAt);
var $63ce28df052c8c19$var$charCodeAt = $966303461c07e127$exports(''.charCodeAt);
var $63ce28df052c8c19$var$stringSlice = $966303461c07e127$exports(''.slice);
var $63ce28df052c8c19$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $cc1f216aa7e44c59$exports($8fd6426c81bfca55$exports($this));
        var position = $9f3eb545512efe9e$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $63ce28df052c8c19$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $63ce28df052c8c19$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $63ce28df052c8c19$var$charAt(S, position) : first : CONVERT_TO_STRING ? $63ce28df052c8c19$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$63ce28df052c8c19$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $63ce28df052c8c19$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $63ce28df052c8c19$var$createMethod(true)
};


var $1ccd1cb6286a6040$require$charAt = $63ce28df052c8c19$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$1ccd1cb6286a6040$exports = function(S, index, unicode) {
    return index + (unicode ? $1ccd1cb6286a6040$require$charAt(S, index).length : 1);
};



var $771aa137ff641b5d$exports = {};
'use strict';


var $771aa137ff641b5d$var$floor = Math.floor;
var $771aa137ff641b5d$var$charAt = $966303461c07e127$exports(''.charAt);
var $771aa137ff641b5d$var$replace = $966303461c07e127$exports(''.replace);
var $771aa137ff641b5d$var$stringSlice = $966303461c07e127$exports(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $771aa137ff641b5d$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $771aa137ff641b5d$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$771aa137ff641b5d$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $771aa137ff641b5d$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $3281447d22a40e21$exports(namedCaptures);
        symbols = $771aa137ff641b5d$var$SUBSTITUTION_SYMBOLS;
    }
    return $771aa137ff641b5d$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($771aa137ff641b5d$var$charAt(ch, 0)){
            case '$':
                return '$';
            case '&':
                return matched;
            case '`':
                return $771aa137ff641b5d$var$stringSlice(str, 0, position);
            case "'":
                return $771aa137ff641b5d$var$stringSlice(str, tailPos);
            case '<':
                capture = namedCaptures[$771aa137ff641b5d$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $771aa137ff641b5d$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $771aa137ff641b5d$var$charAt(ch, 1) : captures[f - 1] + $771aa137ff641b5d$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? '' : capture;
    });
};



var $e2b62e79ee126797$exports = {};
'use strict';





var $e2b62e79ee126797$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$e2b62e79ee126797$exports = function(R, S) {
    var exec = R.exec;
    if ($66733457c42e4bfd$exports(exec)) {
        var result = $6dd48e140907213f$exports(exec, R, S);
        if (result !== null) $c7d52dd23854385b$exports(result);
        return result;
    }
    if ($11458573e8c84e00$exports(R) === 'RegExp') return $6dd48e140907213f$exports($1c5f4705a7e166a5$exports, R, S);
    throw new $e2b62e79ee126797$var$$TypeError('RegExp#exec called on incompatible receiver');
};



var $7f9855ba2906b55f$var$REPLACE = $2f02eb6a25cfaf08$exports('replace');
var $7f9855ba2906b55f$var$max = Math.max;
var $7f9855ba2906b55f$var$min = Math.min;
var $7f9855ba2906b55f$var$concat = $966303461c07e127$exports([].concat);
var $7f9855ba2906b55f$var$push = $966303461c07e127$exports([].push);
var $7f9855ba2906b55f$var$stringIndexOf = $966303461c07e127$exports(''.indexOf);
var $7f9855ba2906b55f$var$stringSlice = $966303461c07e127$exports(''.slice);
var $7f9855ba2906b55f$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $7f9855ba2906b55f$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $7f9855ba2906b55f$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$7f9855ba2906b55f$var$REPLACE]) return /./[$7f9855ba2906b55f$var$REPLACE]('a', '$0') === '';
    return false;
}();
var $7f9855ba2906b55f$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$10beeae1ca6f1357$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return ''.replace(re, '$<a>') !== '7';
});
// @@replace logic
$2a60274b33b64c4d$exports('replace', function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $7f9855ba2906b55f$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $8fd6426c81bfca55$exports(this);
            var replacer = $96a478191b33f4fa$exports(searchValue) ? $cb7d485ba5a2e30b$exports(searchValue, $7f9855ba2906b55f$var$REPLACE) : undefined;
            return replacer ? $6dd48e140907213f$exports(replacer, searchValue, O, replaceValue) : $6dd48e140907213f$exports(nativeReplace, $cc1f216aa7e44c59$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $c7d52dd23854385b$exports(this);
            var S = $cc1f216aa7e44c59$exports(string);
            if (typeof replaceValue == 'string' && $7f9855ba2906b55f$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $7f9855ba2906b55f$var$stringIndexOf(replaceValue, '$<') === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $66733457c42e4bfd$exports(replaceValue);
            if (!functionalReplace) replaceValue = $cc1f216aa7e44c59$exports(replaceValue);
            var flags = $cc1f216aa7e44c59$exports($3b8fa5b93677d7ee$exports(rx));
            var global = $7f9855ba2906b55f$var$stringIndexOf(flags, 'g') !== -1;
            var fullUnicode;
            if (global) {
                fullUnicode = $7f9855ba2906b55f$var$stringIndexOf(flags, 'u') !== -1;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $e2b62e79ee126797$exports(rx, S);
                if (result === null) break;
                $7f9855ba2906b55f$var$push(results, result);
                if (!global) break;
                var matchStr = $cc1f216aa7e44c59$exports(result[0]);
                if (matchStr === '') rx.lastIndex = $1ccd1cb6286a6040$exports(S, $462654e2015d596f$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $cc1f216aa7e44c59$exports(result[0]);
                var position = $7f9855ba2906b55f$var$max($7f9855ba2906b55f$var$min($9f3eb545512efe9e$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$7f9855ba2906b55f$var$push(captures, $7f9855ba2906b55f$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $7f9855ba2906b55f$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $7f9855ba2906b55f$var$push(replacerArgs, namedCaptures);
                    replacement = $cc1f216aa7e44c59$exports($36ddd4c4a517e2d6$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $771aa137ff641b5d$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $7f9855ba2906b55f$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $7f9855ba2906b55f$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$7f9855ba2906b55f$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$7f9855ba2906b55f$var$REPLACE_KEEPS_$0 || $7f9855ba2906b55f$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


'use strict';

var $7cab0bc6ccd883da$exports = {};
'use strict';



var $fddbc550555bd5df$exports = {};
'use strict';
// a string of all valid unicode whitespaces
$fddbc550555bd5df$exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";


var $7cab0bc6ccd883da$var$replace = $966303461c07e127$exports(''.replace);
var $7cab0bc6ccd883da$var$ltrim = RegExp('^[' + $fddbc550555bd5df$exports + ']+');
var $7cab0bc6ccd883da$var$rtrim = RegExp('(^|[^' + $fddbc550555bd5df$exports + '])[' + $fddbc550555bd5df$exports + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $7cab0bc6ccd883da$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $cc1f216aa7e44c59$exports($8fd6426c81bfca55$exports($this));
        if (TYPE & 1) string = $7cab0bc6ccd883da$var$replace(string, $7cab0bc6ccd883da$var$ltrim, '');
        if (TYPE & 2) string = $7cab0bc6ccd883da$var$replace(string, $7cab0bc6ccd883da$var$rtrim, '$1');
        return string;
    };
};
$7cab0bc6ccd883da$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $7cab0bc6ccd883da$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $7cab0bc6ccd883da$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $7cab0bc6ccd883da$var$createMethod(3)
};


var $f8c1f4555e5406f5$require$$trim = $7cab0bc6ccd883da$exports.trim;
var $c998c560c851a326$exports = {};
'use strict';

var $c998c560c851a326$require$PROPER_FUNCTION_NAME = $c5158caaca2f8ecd$exports.PROPER;


var $c998c560c851a326$var$non = '\u200B\u0085\u180E';
// check that a method works with the correct list
// of whitespaces and has a correct name
$c998c560c851a326$exports = function(METHOD_NAME) {
    return $10beeae1ca6f1357$exports(function() {
        return !!$fddbc550555bd5df$exports[METHOD_NAME]() || $c998c560c851a326$var$non[METHOD_NAME]() !== $c998c560c851a326$var$non || $c998c560c851a326$require$PROPER_FUNCTION_NAME && $fddbc550555bd5df$exports[METHOD_NAME].name !== METHOD_NAME;
    });
};


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$ca66147c52f1c36f$exports({
    target: 'String',
    proto: true,
    forced: $c998c560c851a326$exports('trim')
}, {
    trim: function trim() {
        return $f8c1f4555e5406f5$require$$trim(this);
    }
});


'use strict';
'use strict';

var $71fe9598fc9a6c74$exports = {};
'use strict';

var $71fe9598fc9a6c74$require$$trimEnd = $7cab0bc6ccd883da$exports.end;

// `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
$71fe9598fc9a6c74$exports = $c998c560c851a326$exports('trimEnd') ? function trimEnd() {
    return $71fe9598fc9a6c74$require$$trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd;


// `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$ca66147c52f1c36f$exports({
    target: 'String',
    proto: true,
    name: 'trimEnd',
    forced: ''.trimRight !== $71fe9598fc9a6c74$exports
}, {
    trimRight: $71fe9598fc9a6c74$exports
});




// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$ca66147c52f1c36f$exports({
    target: 'String',
    proto: true,
    name: 'trimEnd',
    forced: ''.trimEnd !== $71fe9598fc9a6c74$exports
}, {
    trimEnd: $71fe9598fc9a6c74$exports
});


'use strict';
'use strict';

var $77a5d9f6555d7618$exports = {};
'use strict';

var $77a5d9f6555d7618$require$$trimStart = $7cab0bc6ccd883da$exports.start;

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
$77a5d9f6555d7618$exports = $c998c560c851a326$exports('trimStart') ? function trimStart() {
    return $77a5d9f6555d7618$require$$trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;


// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$ca66147c52f1c36f$exports({
    target: 'String',
    proto: true,
    name: 'trimStart',
    forced: ''.trimLeft !== $77a5d9f6555d7618$exports
}, {
    trimLeft: $77a5d9f6555d7618$exports
});




// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$ca66147c52f1c36f$exports({
    target: 'String',
    proto: true,
    name: 'trimStart',
    forced: ''.trimStart !== $77a5d9f6555d7618$exports
}, {
    trimStart: $77a5d9f6555d7618$exports
});


'use strict';
var $67ad8f399169bb71$exports = {};
'use strict';




var $3fe80a5d8228691b$exports = {};
'use strict';


var $d26a0d8e71e915a0$exports = {};
'use strict';

var $d26a0d8e71e915a0$var$ITERATOR = $2f02eb6a25cfaf08$exports('iterator');
var $d26a0d8e71e915a0$var$SAFE_CLOSING = false;
try {
    var $d26a0d8e71e915a0$var$called = 0;
    var $d26a0d8e71e915a0$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$d26a0d8e71e915a0$var$called++
            };
        },
        'return': function() {
            $d26a0d8e71e915a0$var$SAFE_CLOSING = true;
        }
    };
    $d26a0d8e71e915a0$var$iteratorWithReturn[$d26a0d8e71e915a0$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($d26a0d8e71e915a0$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$d26a0d8e71e915a0$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$d26a0d8e71e915a0$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$d26a0d8e71e915a0$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $bde2f33e37224979$exports = {};
'use strict';

















var $bde2f33e37224979$var$enforceInternalState = $1f4f460c9ddf95ba$exports.enforce;
var $bde2f33e37224979$var$getInternalState = $1f4f460c9ddf95ba$exports.get;
var $bde2f33e37224979$var$Int8Array = $1cca30410cf11b53$exports.Int8Array;
var $bde2f33e37224979$var$Int8ArrayPrototype = $bde2f33e37224979$var$Int8Array && $bde2f33e37224979$var$Int8Array.prototype;
var $bde2f33e37224979$var$Uint8ClampedArray = $1cca30410cf11b53$exports.Uint8ClampedArray;
var $bde2f33e37224979$var$Uint8ClampedArrayPrototype = $bde2f33e37224979$var$Uint8ClampedArray && $bde2f33e37224979$var$Uint8ClampedArray.prototype;
var $bde2f33e37224979$var$TypedArray = $bde2f33e37224979$var$Int8Array && $93253fe4514fc36d$exports($bde2f33e37224979$var$Int8Array);
var $bde2f33e37224979$var$TypedArrayPrototype = $bde2f33e37224979$var$Int8ArrayPrototype && $93253fe4514fc36d$exports($bde2f33e37224979$var$Int8ArrayPrototype);
var $bde2f33e37224979$var$ObjectPrototype = Object.prototype;
var $bde2f33e37224979$var$TypeError = $1cca30410cf11b53$exports.TypeError;
var $bde2f33e37224979$var$TO_STRING_TAG = $2f02eb6a25cfaf08$exports('toStringTag');
var $bde2f33e37224979$var$TYPED_ARRAY_TAG = $4d94c21d38bd74cf$exports('TYPED_ARRAY_TAG');
var $bde2f33e37224979$var$TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS = $c46b487bfa01a5ea$exports && !!$60e5bf26176fe7cd$exports && $39673a197979f5e7$exports($1cca30410cf11b53$exports.opera) !== 'Opera';
var $bde2f33e37224979$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $bde2f33e37224979$var$NAME, $bde2f33e37224979$var$Constructor, $bde2f33e37224979$var$Prototype;
var $bde2f33e37224979$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $bde2f33e37224979$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $bde2f33e37224979$var$isView = function isView(it) {
    if (!$96a478191b33f4fa$exports(it)) return false;
    var klass = $39673a197979f5e7$exports(it);
    return klass === 'DataView' || $1d9d3902a50a2fcd$exports($bde2f33e37224979$var$TypedArrayConstructorsList, klass) || $1d9d3902a50a2fcd$exports($bde2f33e37224979$var$BigIntArrayConstructorsList, klass);
};
var $bde2f33e37224979$var$getTypedArrayConstructor = function(it) {
    var proto = $93253fe4514fc36d$exports(it);
    if (!$96a478191b33f4fa$exports(proto)) return;
    var state = $bde2f33e37224979$var$getInternalState(proto);
    return state && $1d9d3902a50a2fcd$exports(state, $bde2f33e37224979$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$bde2f33e37224979$var$TYPED_ARRAY_CONSTRUCTOR] : $bde2f33e37224979$var$getTypedArrayConstructor(proto);
};
var $bde2f33e37224979$var$isTypedArray = function(it) {
    if (!$96a478191b33f4fa$exports(it)) return false;
    var klass = $39673a197979f5e7$exports(it);
    return $1d9d3902a50a2fcd$exports($bde2f33e37224979$var$TypedArrayConstructorsList, klass) || $1d9d3902a50a2fcd$exports($bde2f33e37224979$var$BigIntArrayConstructorsList, klass);
};
var $bde2f33e37224979$var$aTypedArray = function(it) {
    if ($bde2f33e37224979$var$isTypedArray(it)) return it;
    throw new $bde2f33e37224979$var$TypeError('Target is not a typed array');
};
var $bde2f33e37224979$var$aTypedArrayConstructor = function(C) {
    if ($66733457c42e4bfd$exports(C) && (!$60e5bf26176fe7cd$exports || $05d64d70d0804181$exports($bde2f33e37224979$var$TypedArray, C))) return C;
    throw new $bde2f33e37224979$var$TypeError($624baa4627a5b446$exports(C) + ' is not a typed array constructor');
};
var $bde2f33e37224979$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$ce6ba28f66317609$exports) return;
    if (forced) for(var ARRAY in $bde2f33e37224979$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $1cca30410cf11b53$exports[ARRAY];
        if (TypedArrayConstructor && $1d9d3902a50a2fcd$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$bde2f33e37224979$var$TypedArrayPrototype[KEY] || forced) $a5378e288f28a3de$exports($bde2f33e37224979$var$TypedArrayPrototype, KEY, forced ? property : $bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS && $bde2f33e37224979$var$Int8ArrayPrototype[KEY] || property, options);
};
var $bde2f33e37224979$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$ce6ba28f66317609$exports) return;
    if ($60e5bf26176fe7cd$exports) {
        if (forced) for(ARRAY in $bde2f33e37224979$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $1cca30410cf11b53$exports[ARRAY];
            if (TypedArrayConstructor && $1d9d3902a50a2fcd$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$bde2f33e37224979$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $a5378e288f28a3de$exports($bde2f33e37224979$var$TypedArray, KEY, forced ? property : $bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS && $bde2f33e37224979$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $bde2f33e37224979$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $1cca30410cf11b53$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $a5378e288f28a3de$exports(TypedArrayConstructor, KEY, property);
    }
};
for($bde2f33e37224979$var$NAME in $bde2f33e37224979$var$TypedArrayConstructorsList){
    $bde2f33e37224979$var$Constructor = $1cca30410cf11b53$exports[$bde2f33e37224979$var$NAME];
    $bde2f33e37224979$var$Prototype = $bde2f33e37224979$var$Constructor && $bde2f33e37224979$var$Constructor.prototype;
    if ($bde2f33e37224979$var$Prototype) $bde2f33e37224979$var$enforceInternalState($bde2f33e37224979$var$Prototype)[$bde2f33e37224979$var$TYPED_ARRAY_CONSTRUCTOR] = $bde2f33e37224979$var$Constructor;
    else $bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($bde2f33e37224979$var$NAME in $bde2f33e37224979$var$BigIntArrayConstructorsList){
    $bde2f33e37224979$var$Constructor = $1cca30410cf11b53$exports[$bde2f33e37224979$var$NAME];
    $bde2f33e37224979$var$Prototype = $bde2f33e37224979$var$Constructor && $bde2f33e37224979$var$Constructor.prototype;
    if ($bde2f33e37224979$var$Prototype) $bde2f33e37224979$var$enforceInternalState($bde2f33e37224979$var$Prototype)[$bde2f33e37224979$var$TYPED_ARRAY_CONSTRUCTOR] = $bde2f33e37224979$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS || !$66733457c42e4bfd$exports($bde2f33e37224979$var$TypedArray) || $bde2f33e37224979$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $bde2f33e37224979$var$TypedArray = function TypedArray() {
        throw new $bde2f33e37224979$var$TypeError('Incorrect invocation');
    };
    if ($bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($bde2f33e37224979$var$NAME in $bde2f33e37224979$var$TypedArrayConstructorsList)if ($1cca30410cf11b53$exports[$bde2f33e37224979$var$NAME]) $60e5bf26176fe7cd$exports($1cca30410cf11b53$exports[$bde2f33e37224979$var$NAME], $bde2f33e37224979$var$TypedArray);
    }
}
if (!$bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS || !$bde2f33e37224979$var$TypedArrayPrototype || $bde2f33e37224979$var$TypedArrayPrototype === $bde2f33e37224979$var$ObjectPrototype) {
    $bde2f33e37224979$var$TypedArrayPrototype = $bde2f33e37224979$var$TypedArray.prototype;
    if ($bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($bde2f33e37224979$var$NAME in $bde2f33e37224979$var$TypedArrayConstructorsList)if ($1cca30410cf11b53$exports[$bde2f33e37224979$var$NAME]) $60e5bf26176fe7cd$exports($1cca30410cf11b53$exports[$bde2f33e37224979$var$NAME].prototype, $bde2f33e37224979$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS && $93253fe4514fc36d$exports($bde2f33e37224979$var$Uint8ClampedArrayPrototype) !== $bde2f33e37224979$var$TypedArrayPrototype) $60e5bf26176fe7cd$exports($bde2f33e37224979$var$Uint8ClampedArrayPrototype, $bde2f33e37224979$var$TypedArrayPrototype);
if ($ce6ba28f66317609$exports && !$1d9d3902a50a2fcd$exports($bde2f33e37224979$var$TypedArrayPrototype, $bde2f33e37224979$var$TO_STRING_TAG)) {
    $bde2f33e37224979$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $ae34d1f2f4f59697$exports($bde2f33e37224979$var$TypedArrayPrototype, $bde2f33e37224979$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $96a478191b33f4fa$exports(this) ? this[$bde2f33e37224979$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($bde2f33e37224979$var$NAME in $bde2f33e37224979$var$TypedArrayConstructorsList)if ($1cca30410cf11b53$exports[$bde2f33e37224979$var$NAME]) $b4e3b093ae5606fa$exports($1cca30410cf11b53$exports[$bde2f33e37224979$var$NAME], $bde2f33e37224979$var$TYPED_ARRAY_TAG, $bde2f33e37224979$var$NAME);
}
$bde2f33e37224979$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $bde2f33e37224979$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $bde2f33e37224979$var$TYPED_ARRAY_TAG_REQUIRED && $bde2f33e37224979$var$TYPED_ARRAY_TAG,
    aTypedArray: $bde2f33e37224979$var$aTypedArray,
    aTypedArrayConstructor: $bde2f33e37224979$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $bde2f33e37224979$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $bde2f33e37224979$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $bde2f33e37224979$var$getTypedArrayConstructor,
    isView: $bde2f33e37224979$var$isView,
    isTypedArray: $bde2f33e37224979$var$isTypedArray,
    TypedArray: $bde2f33e37224979$var$TypedArray,
    TypedArrayPrototype: $bde2f33e37224979$var$TypedArrayPrototype
};


var $3fe80a5d8228691b$require$NATIVE_ARRAY_BUFFER_VIEWS = $bde2f33e37224979$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $3fe80a5d8228691b$var$ArrayBuffer = $1cca30410cf11b53$exports.ArrayBuffer;
var $3fe80a5d8228691b$var$Int8Array = $1cca30410cf11b53$exports.Int8Array;
$3fe80a5d8228691b$exports = !$3fe80a5d8228691b$require$NATIVE_ARRAY_BUFFER_VIEWS || !$10beeae1ca6f1357$exports(function() {
    $3fe80a5d8228691b$var$Int8Array(1);
}) || !$10beeae1ca6f1357$exports(function() {
    new $3fe80a5d8228691b$var$Int8Array(-1);
}) || !$d26a0d8e71e915a0$exports(function(iterable) {
    new $3fe80a5d8228691b$var$Int8Array();
    new $3fe80a5d8228691b$var$Int8Array(null);
    new $3fe80a5d8228691b$var$Int8Array(1.5);
    new $3fe80a5d8228691b$var$Int8Array(iterable);
}, true) || $10beeae1ca6f1357$exports(function() {
    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
    return new $3fe80a5d8228691b$var$Int8Array(new $3fe80a5d8228691b$var$ArrayBuffer(2), 1, undefined).length !== 1;
});







var $ab4e71d69398bedc$exports = {};
'use strict';

var $ab4e71d69398bedc$var$floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
$ab4e71d69398bedc$exports = Number.isInteger || function isInteger(it) {
    return !$96a478191b33f4fa$exports(it) && isFinite(it) && $ab4e71d69398bedc$var$floor(it) === it;
};




var $f7ae2ae6aa8003b0$exports = {};
'use strict';
var $5c5008bffd74f328$exports = {};
'use strict';

var $5c5008bffd74f328$var$$RangeError = RangeError;
$5c5008bffd74f328$exports = function(it) {
    var result = $9f3eb545512efe9e$exports(it);
    if (result < 0) throw new $5c5008bffd74f328$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $f7ae2ae6aa8003b0$var$$RangeError = RangeError;
$f7ae2ae6aa8003b0$exports = function(it, BYTES) {
    var offset = $5c5008bffd74f328$exports(it);
    if (offset % BYTES) throw new $f7ae2ae6aa8003b0$var$$RangeError('Wrong offset');
    return offset;
};


var $1d50d282fdb19c10$exports = {};
'use strict';
var $1d50d282fdb19c10$var$round = Math.round;
$1d50d282fdb19c10$exports = function(it) {
    var value = $1d50d282fdb19c10$var$round(it);
    return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};











var $67ad8f399169bb71$require$getOwnPropertyNames = $42f35ac27ca8991e$export$2d1720544b23b823;
var $e5f2748e9aa965cd$exports = {};
'use strict';








var $2e0bded6ba12b3ee$exports = {};
'use strict';

$2e0bded6ba12b3ee$exports = function(it) {
    var klass = $39673a197979f5e7$exports(it);
    return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};



var $e5f2748e9aa965cd$require$aTypedArrayConstructor = $bde2f33e37224979$exports.aTypedArrayConstructor;
var $2177f66b9efe812b$exports = {};
'use strict';

var $2177f66b9efe812b$var$$TypeError = TypeError;
// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
$2177f66b9efe812b$exports = function(argument) {
    var prim = $d47a7b24ae80b9f5$exports(argument, 'number');
    if (typeof prim == 'number') throw new $2177f66b9efe812b$var$$TypeError("Can't convert number to bigint");
    // eslint-disable-next-line es/no-bigint -- safe
    return BigInt(prim);
};


$e5f2748e9aa965cd$exports = function from(source /* , mapfn, thisArg */ ) {
    var C = $799ef19a1a3659da$exports(this);
    var O = $3281447d22a40e21$exports(source);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iteratorMethod = $44917bb2b551135b$exports(O);
    var i, length, result, thisIsBigIntArray, value, step, iterator, next;
    if (iteratorMethod && !$7da3fc42db2cd048$exports(iteratorMethod)) {
        iterator = $f9d5016d77a62d39$exports(O, iteratorMethod);
        next = iterator.next;
        O = [];
        while(!(step = $6dd48e140907213f$exports(next, iterator)).done)O.push(step.value);
    }
    if (mapping && argumentsLength > 2) mapfn = $2d52694feff5f895$exports(mapfn, arguments[2]);
    length = $ffd1deb5f4ba5f93$exports(O);
    result = new ($e5f2748e9aa965cd$require$aTypedArrayConstructor(C))(length);
    thisIsBigIntArray = $2e0bded6ba12b3ee$exports(result);
    for(i = 0; length > i; i++){
        value = mapping ? mapfn(O[i], i) : O[i];
        // FF30- typed arrays doesn't properly convert objects to typed array values
        result[i] = thisIsBigIntArray ? $2177f66b9efe812b$exports(value) : +value;
    }
    return result;
};


var $03c2ba416765d39a$exports = {};
'use strict';






var $03c2ba416765d39a$var$push = $966303461c07e127$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $03c2ba416765d39a$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $3281447d22a40e21$exports($this);
        var self = $2ca02031c916d962$exports(O);
        var length = $ffd1deb5f4ba5f93$exports(self);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $6eab3c345ba4bc77$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $03c2ba416765d39a$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $03c2ba416765d39a$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$03c2ba416765d39a$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $03c2ba416765d39a$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $03c2ba416765d39a$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $03c2ba416765d39a$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $03c2ba416765d39a$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $03c2ba416765d39a$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $03c2ba416765d39a$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $03c2ba416765d39a$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $03c2ba416765d39a$var$createMethod(7)
};


var $67ad8f399169bb71$require$forEach = $03c2ba416765d39a$exports.forEach;




var $3f8e47d9e44f7e68$exports = {};
'use strict';

$3f8e47d9e44f7e68$exports = function(Constructor, list, $length) {
    var index = 0;
    var length = arguments.length > 2 ? $length : $ffd1deb5f4ba5f93$exports(list);
    var result = new Constructor(length);
    while(length > index)result[index] = list[index++];
    return result;
};




var $67ad8f399169bb71$var$getInternalState = $1f4f460c9ddf95ba$exports.get;
var $67ad8f399169bb71$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $67ad8f399169bb71$var$enforceInternalState = $1f4f460c9ddf95ba$exports.enforce;
var $67ad8f399169bb71$var$nativeDefineProperty = $a334f8c362aafa38$export$2d1720544b23b823;
var $67ad8f399169bb71$var$nativeGetOwnPropertyDescriptor = $07309be0dc62a21a$export$2d1720544b23b823;
var $67ad8f399169bb71$var$RangeError = $1cca30410cf11b53$exports.RangeError;
var $67ad8f399169bb71$var$ArrayBuffer = $e81d46ec19751ad8$exports.ArrayBuffer;
var $67ad8f399169bb71$var$ArrayBufferPrototype = $67ad8f399169bb71$var$ArrayBuffer.prototype;
var $67ad8f399169bb71$var$DataView = $e81d46ec19751ad8$exports.DataView;
var $67ad8f399169bb71$var$NATIVE_ARRAY_BUFFER_VIEWS = $bde2f33e37224979$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $67ad8f399169bb71$var$TYPED_ARRAY_TAG = $bde2f33e37224979$exports.TYPED_ARRAY_TAG;
var $67ad8f399169bb71$var$TypedArray = $bde2f33e37224979$exports.TypedArray;
var $67ad8f399169bb71$var$TypedArrayPrototype = $bde2f33e37224979$exports.TypedArrayPrototype;
var $67ad8f399169bb71$var$isTypedArray = $bde2f33e37224979$exports.isTypedArray;
var $67ad8f399169bb71$var$BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var $67ad8f399169bb71$var$WRONG_LENGTH = 'Wrong length';
var $67ad8f399169bb71$var$addGetter = function(it, key) {
    $ae34d1f2f4f59697$exports(it, key, {
        configurable: true,
        get: function() {
            return $67ad8f399169bb71$var$getInternalState(this)[key];
        }
    });
};
var $67ad8f399169bb71$var$isArrayBuffer = function(it) {
    var klass;
    return $05d64d70d0804181$exports($67ad8f399169bb71$var$ArrayBufferPrototype, it) || (klass = $39673a197979f5e7$exports(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};
var $67ad8f399169bb71$var$isTypedArrayIndex = function(target, key) {
    return $67ad8f399169bb71$var$isTypedArray(target) && !$98a3ba51b30ebcfa$exports(key) && key in target && $ab4e71d69398bedc$exports(+key) && key >= 0;
};
var $67ad8f399169bb71$var$wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = $efaf6c0cd88f6b3c$exports(key);
    return $67ad8f399169bb71$var$isTypedArrayIndex(target, key) ? $b941c4cd0c3c4a09$exports(2, target[key]) : $67ad8f399169bb71$var$nativeGetOwnPropertyDescriptor(target, key);
};
var $67ad8f399169bb71$var$wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = $efaf6c0cd88f6b3c$exports(key);
    if ($67ad8f399169bb71$var$isTypedArrayIndex(target, key) && $96a478191b33f4fa$exports(descriptor) && $1d9d3902a50a2fcd$exports(descriptor, 'value') && !$1d9d3902a50a2fcd$exports(descriptor, 'get') && !$1d9d3902a50a2fcd$exports(descriptor, 'set') && !descriptor.configurable && (!$1d9d3902a50a2fcd$exports(descriptor, 'writable') || descriptor.writable) && (!$1d9d3902a50a2fcd$exports(descriptor, 'enumerable') || descriptor.enumerable)) {
        target[key] = descriptor.value;
        return target;
    }
    return $67ad8f399169bb71$var$nativeDefineProperty(target, key, descriptor);
};
if ($ce6ba28f66317609$exports) {
    if (!$67ad8f399169bb71$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        $07309be0dc62a21a$exports.f = $67ad8f399169bb71$var$wrappedGetOwnPropertyDescriptor;
        $a334f8c362aafa38$exports.f = $67ad8f399169bb71$var$wrappedDefineProperty;
        $67ad8f399169bb71$var$addGetter($67ad8f399169bb71$var$TypedArrayPrototype, 'buffer');
        $67ad8f399169bb71$var$addGetter($67ad8f399169bb71$var$TypedArrayPrototype, 'byteOffset');
        $67ad8f399169bb71$var$addGetter($67ad8f399169bb71$var$TypedArrayPrototype, 'byteLength');
        $67ad8f399169bb71$var$addGetter($67ad8f399169bb71$var$TypedArrayPrototype, 'length');
    }
    $ca66147c52f1c36f$exports({
        target: 'Object',
        stat: true,
        forced: !$67ad8f399169bb71$var$NATIVE_ARRAY_BUFFER_VIEWS
    }, {
        getOwnPropertyDescriptor: $67ad8f399169bb71$var$wrappedGetOwnPropertyDescriptor,
        defineProperty: $67ad8f399169bb71$var$wrappedDefineProperty
    });
    $67ad8f399169bb71$exports = function(TYPE, wrapper, CLAMPED) {
        var BYTES = TYPE.match(/\d+/)[0] / 8;
        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + TYPE;
        var SETTER = 'set' + TYPE;
        var NativeTypedArrayConstructor = $1cca30410cf11b53$exports[CONSTRUCTOR_NAME];
        var TypedArrayConstructor = NativeTypedArrayConstructor;
        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
        var exported = {};
        var getter = function(that, index) {
            var data = $67ad8f399169bb71$var$getInternalState(that);
            return data.view[GETTER](index * BYTES + data.byteOffset, true);
        };
        var setter = function(that, index, value) {
            var data = $67ad8f399169bb71$var$getInternalState(that);
            data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? $1d50d282fdb19c10$exports(value) : value, true);
        };
        var addElement = function(that, index) {
            $67ad8f399169bb71$var$nativeDefineProperty(that, index, {
                get: function() {
                    return getter(this, index);
                },
                set: function(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (!$67ad8f399169bb71$var$NATIVE_ARRAY_BUFFER_VIEWS) {
            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                $e75aa794ae249210$exports(that, TypedArrayConstructorPrototype);
                var index = 0;
                var byteOffset = 0;
                var buffer, byteLength, length;
                if (!$96a478191b33f4fa$exports(data)) {
                    length = $f8e63a566deab523$exports(data);
                    byteLength = length * BYTES;
                    buffer = new $67ad8f399169bb71$var$ArrayBuffer(byteLength);
                } else if ($67ad8f399169bb71$var$isArrayBuffer(data)) {
                    buffer = data;
                    byteOffset = $f7ae2ae6aa8003b0$exports(offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw new $67ad8f399169bb71$var$RangeError($67ad8f399169bb71$var$WRONG_LENGTH);
                        byteLength = $len - byteOffset;
                        if (byteLength < 0) throw new $67ad8f399169bb71$var$RangeError($67ad8f399169bb71$var$WRONG_LENGTH);
                    } else {
                        byteLength = $462654e2015d596f$exports($length) * BYTES;
                        if (byteLength + byteOffset > $len) throw new $67ad8f399169bb71$var$RangeError($67ad8f399169bb71$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($67ad8f399169bb71$var$isTypedArray(data)) return $3f8e47d9e44f7e68$exports(TypedArrayConstructor, data);
                else return $6dd48e140907213f$exports($e5f2748e9aa965cd$exports, TypedArrayConstructor, data);
                $67ad8f399169bb71$var$setInternalState(that, {
                    buffer: buffer,
                    byteOffset: byteOffset,
                    byteLength: byteLength,
                    length: length,
                    view: new $67ad8f399169bb71$var$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            if ($60e5bf26176fe7cd$exports) $60e5bf26176fe7cd$exports(TypedArrayConstructor, $67ad8f399169bb71$var$TypedArray);
            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = $cfd63855ca92cd7c$exports($67ad8f399169bb71$var$TypedArrayPrototype);
        } else if ($3fe80a5d8228691b$exports) {
            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                $e75aa794ae249210$exports(dummy, TypedArrayConstructorPrototype);
                return $b00bcd5177827a19$exports(function() {
                    if (!$96a478191b33f4fa$exports(data)) return new NativeTypedArrayConstructor($f8e63a566deab523$exports(data));
                    if ($67ad8f399169bb71$var$isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, $f7ae2ae6aa8003b0$exports(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, $f7ae2ae6aa8003b0$exports(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                    if ($67ad8f399169bb71$var$isTypedArray(data)) return $3f8e47d9e44f7e68$exports(TypedArrayConstructor, data);
                    return $6dd48e140907213f$exports($e5f2748e9aa965cd$exports, TypedArrayConstructor, data);
                }(), dummy, TypedArrayConstructor);
            });
            if ($60e5bf26176fe7cd$exports) $60e5bf26176fe7cd$exports(TypedArrayConstructor, $67ad8f399169bb71$var$TypedArray);
            $67ad8f399169bb71$require$forEach($67ad8f399169bb71$require$getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                if (!(key in TypedArrayConstructor)) $b4e3b093ae5606fa$exports(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
            });
            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
        }
        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) $b4e3b093ae5606fa$exports(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
        $67ad8f399169bb71$var$enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
        if ($67ad8f399169bb71$var$TYPED_ARRAY_TAG) $b4e3b093ae5606fa$exports(TypedArrayConstructorPrototype, $67ad8f399169bb71$var$TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
        var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;
        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
        $ca66147c52f1c36f$exports({
            global: true,
            constructor: true,
            forced: FORCED,
            sham: !$67ad8f399169bb71$var$NATIVE_ARRAY_BUFFER_VIEWS
        }, exported);
        if (!($67ad8f399169bb71$var$BYTES_PER_ELEMENT in TypedArrayConstructor)) $b4e3b093ae5606fa$exports(TypedArrayConstructor, $67ad8f399169bb71$var$BYTES_PER_ELEMENT, BYTES);
        if (!($67ad8f399169bb71$var$BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) $b4e3b093ae5606fa$exports(TypedArrayConstructorPrototype, $67ad8f399169bb71$var$BYTES_PER_ELEMENT, BYTES);
        $8d29cdfa1a37667d$exports(CONSTRUCTOR_NAME);
    };
} else $67ad8f399169bb71$exports = function() {};


// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$67ad8f399169bb71$exports('Float32', function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$67ad8f399169bb71$exports('Float64', function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$67ad8f399169bb71$exports('Int8', function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$67ad8f399169bb71$exports('Int16', function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$67ad8f399169bb71$exports('Int32', function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$67ad8f399169bb71$exports('Uint8', function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$67ad8f399169bb71$exports('Uint8', function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);


'use strict';

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$67ad8f399169bb71$exports('Uint16', function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$67ad8f399169bb71$exports('Uint32', function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';







var $8e234cea8256494e$var$aTypedArray = $bde2f33e37224979$exports.aTypedArray;
var $8e234cea8256494e$var$exportTypedArrayMethod = $bde2f33e37224979$exports.exportTypedArrayMethod;
var $8e234cea8256494e$var$slice = $966303461c07e127$exports(''.slice);
// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var $8e234cea8256494e$var$CONVERSION_BUG = $10beeae1ca6f1357$exports(function() {
    var count = 0;
    // eslint-disable-next-line es/no-typed-arrays -- safe
    new Int8Array(2).fill({
        valueOf: function() {
            return count++;
        }
    });
    return count !== 1;
});
// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
$8e234cea8256494e$var$exportTypedArrayMethod('fill', function fill(value /* , start, end */ ) {
    var length = arguments.length;
    $8e234cea8256494e$var$aTypedArray(this);
    var actualValue = $8e234cea8256494e$var$slice($39673a197979f5e7$exports(this), 0, 3) === 'Big' ? $2177f66b9efe812b$exports(value) : +value;
    return $6dd48e140907213f$exports($c4b8b4b807bbc363$exports, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, $8e234cea8256494e$var$CONVERSION_BUG);


'use strict';


var $53a371010349eb55$require$exportTypedArrayStaticMethod = $bde2f33e37224979$exports.exportTypedArrayStaticMethod;

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
$53a371010349eb55$require$exportTypedArrayStaticMethod('from', $e5f2748e9aa965cd$exports, $3fe80a5d8228691b$exports);


'use strict';


var $0caacea6b05f944d$var$aTypedArrayConstructor = $bde2f33e37224979$exports.aTypedArrayConstructor;
var $0caacea6b05f944d$var$exportTypedArrayStaticMethod = $bde2f33e37224979$exports.exportTypedArrayStaticMethod;
// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
$0caacea6b05f944d$var$exportTypedArrayStaticMethod('of', function of() {
    var index = 0;
    var length = arguments.length;
    var result = new ($0caacea6b05f944d$var$aTypedArrayConstructor(this))(length);
    while(length > index)result[index] = arguments[index++];
    return result;
}, $3fe80a5d8228691b$exports);


'use strict';







var $0b6b9d95fc276437$var$RangeError = $1cca30410cf11b53$exports.RangeError;
var $0b6b9d95fc276437$var$Int8Array = $1cca30410cf11b53$exports.Int8Array;
var $0b6b9d95fc276437$var$Int8ArrayPrototype = $0b6b9d95fc276437$var$Int8Array && $0b6b9d95fc276437$var$Int8Array.prototype;
var $0b6b9d95fc276437$var$$set = $0b6b9d95fc276437$var$Int8ArrayPrototype && $0b6b9d95fc276437$var$Int8ArrayPrototype.set;
var $0b6b9d95fc276437$var$aTypedArray = $bde2f33e37224979$exports.aTypedArray;
var $0b6b9d95fc276437$var$exportTypedArrayMethod = $bde2f33e37224979$exports.exportTypedArrayMethod;
var $0b6b9d95fc276437$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$10beeae1ca6f1357$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $6dd48e140907213f$exports($0b6b9d95fc276437$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $0b6b9d95fc276437$var$TO_OBJECT_BUG = $0b6b9d95fc276437$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $bde2f33e37224979$exports.NATIVE_ARRAY_BUFFER_VIEWS && $10beeae1ca6f1357$exports(function() {
    var array = new $0b6b9d95fc276437$var$Int8Array(2);
    array.set(1);
    array.set('2', 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$0b6b9d95fc276437$var$exportTypedArrayMethod('set', function set(arrayLike /* , offset */ ) {
    $0b6b9d95fc276437$var$aTypedArray(this);
    var offset = $f7ae2ae6aa8003b0$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $3281447d22a40e21$exports(arrayLike);
    if ($0b6b9d95fc276437$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $6dd48e140907213f$exports($0b6b9d95fc276437$var$$set, this, src, offset);
    var length = this.length;
    var len = $ffd1deb5f4ba5f93$exports(src);
    var index = 0;
    if (len + offset > length) throw new $0b6b9d95fc276437$var$RangeError('Wrong length');
    while(index < len)this[offset + index] = src[index++];
}, !$0b6b9d95fc276437$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $0b6b9d95fc276437$var$TO_OBJECT_BUG);


'use strict';










var $06e244e629e5f71d$var$aTypedArray = $bde2f33e37224979$exports.aTypedArray;
var $06e244e629e5f71d$var$exportTypedArrayMethod = $bde2f33e37224979$exports.exportTypedArrayMethod;
var $06e244e629e5f71d$var$Uint16Array = $1cca30410cf11b53$exports.Uint16Array;
var $06e244e629e5f71d$var$nativeSort = $06e244e629e5f71d$var$Uint16Array && $f587f14398031c29$exports($06e244e629e5f71d$var$Uint16Array.prototype.sort);
// WebKit
var $06e244e629e5f71d$var$ACCEPT_INCORRECT_ARGUMENTS = !!$06e244e629e5f71d$var$nativeSort && !($10beeae1ca6f1357$exports(function() {
    $06e244e629e5f71d$var$nativeSort(new $06e244e629e5f71d$var$Uint16Array(2), null);
}) && $10beeae1ca6f1357$exports(function() {
    $06e244e629e5f71d$var$nativeSort(new $06e244e629e5f71d$var$Uint16Array(2), {});
}));
var $06e244e629e5f71d$var$STABLE_SORT = !!$06e244e629e5f71d$var$nativeSort && !$10beeae1ca6f1357$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($cc9c540ab7776841$exports) return $cc9c540ab7776841$exports < 74;
    if ($c9ca29d7405627e5$exports) return $c9ca29d7405627e5$exports < 67;
    if ($b3eb7c58d85007c6$exports) return true;
    if ($af76fa95a3abaac9$exports) return $af76fa95a3abaac9$exports < 602;
    var array = new $06e244e629e5f71d$var$Uint16Array(516);
    var expected = Array(516);
    var index, mod;
    for(index = 0; index < 516; index++){
        mod = index % 4;
        array[index] = 515 - index;
        expected[index] = index - 2 * mod + 3;
    }
    $06e244e629e5f71d$var$nativeSort(array, function(a, b) {
        return (a / 4 | 0) - (b / 4 | 0);
    });
    for(index = 0; index < 516; index++){
        if (array[index] !== expected[index]) return true;
    }
});
var $06e244e629e5f71d$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (y !== y) return -1;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (x !== x) return 1;
        if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
        return x > y;
    };
};
// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
$06e244e629e5f71d$var$exportTypedArrayMethod('sort', function sort(comparefn) {
    if (comparefn !== undefined) $ac451d11dfa909df$exports(comparefn);
    if ($06e244e629e5f71d$var$STABLE_SORT) return $06e244e629e5f71d$var$nativeSort(this, comparefn);
    return $716434f03ef1b685$exports($06e244e629e5f71d$var$aTypedArray(this), $06e244e629e5f71d$var$getSortCompare(comparefn));
}, !$06e244e629e5f71d$var$STABLE_SORT || $06e244e629e5f71d$var$ACCEPT_INCORRECT_ARGUMENTS);


'use strict';
'use strict';
'use strict';








var $19cb5d897edb2112$exports = {};
'use strict';


// `InstallErrorCause` abstract operation
// https://tc39.es/ecma262/#sec-installerrorcause
$19cb5d897edb2112$exports = function(O, options) {
    if ($96a478191b33f4fa$exports(options) && 'cause' in options) $b4e3b093ae5606fa$exports(O, 'cause', options.cause);
};


var $2af8bca27d31cd85$exports = {};
'use strict';

var $eb39f323ef30be31$exports = {};
'use strict';

var $eb39f323ef30be31$var$$Error = Error;
var $eb39f323ef30be31$var$replace = $966303461c07e127$exports(''.replace);
var $eb39f323ef30be31$var$TEST = function(arg) {
    return String(new $eb39f323ef30be31$var$$Error(arg).stack);
}('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var $eb39f323ef30be31$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $eb39f323ef30be31$var$IS_V8_OR_CHAKRA_STACK = $eb39f323ef30be31$var$V8_OR_CHAKRA_STACK_ENTRY.test($eb39f323ef30be31$var$TEST);
$eb39f323ef30be31$exports = function(stack, dropEntries) {
    if ($eb39f323ef30be31$var$IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$eb39f323ef30be31$var$$Error.prepareStackTrace) while(dropEntries--)stack = $eb39f323ef30be31$var$replace(stack, $eb39f323ef30be31$var$V8_OR_CHAKRA_STACK_ENTRY, '');
    return stack;
};


var $a9b5c42e8cc15d86$exports = {};
'use strict';


$a9b5c42e8cc15d86$exports = !$10beeae1ca6f1357$exports(function() {
    var error = new Error('a');
    if (!('stack' in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, 'stack', $b941c4cd0c3c4a09$exports(1, 7));
    return error.stack !== 7;
});


// non-standard V8
// eslint-disable-next-line es/no-nonstandard-error-properties -- safe
var $2af8bca27d31cd85$var$captureStackTrace = Error.captureStackTrace;
$2af8bca27d31cd85$exports = function(error, C, stack, dropEntries) {
    if ($a9b5c42e8cc15d86$exports) {
        if ($2af8bca27d31cd85$var$captureStackTrace) $2af8bca27d31cd85$var$captureStackTrace(error, C);
        else $b4e3b093ae5606fa$exports(error, 'stack', $eb39f323ef30be31$exports(stack, dropEntries));
    }
};



var $4ee374e9a88cbe42$exports = {};
'use strict';

$4ee374e9a88cbe42$exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? '' : $default : $cc1f216aa7e44c59$exports(argument);
};



var $d4eab2a2d446bac9$var$TO_STRING_TAG = $2f02eb6a25cfaf08$exports('toStringTag');
var $d4eab2a2d446bac9$var$$Error = Error;
var $d4eab2a2d446bac9$var$push = [].push;
var $d4eab2a2d446bac9$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $05d64d70d0804181$exports($d4eab2a2d446bac9$var$AggregateErrorPrototype, this);
    var that;
    if ($60e5bf26176fe7cd$exports) that = $60e5bf26176fe7cd$exports(new $d4eab2a2d446bac9$var$$Error(), isInstance ? $93253fe4514fc36d$exports(this) : $d4eab2a2d446bac9$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $cfd63855ca92cd7c$exports($d4eab2a2d446bac9$var$AggregateErrorPrototype);
        $b4e3b093ae5606fa$exports(that, $d4eab2a2d446bac9$var$TO_STRING_TAG, 'Error');
    }
    if (message !== undefined) $b4e3b093ae5606fa$exports(that, 'message', $4ee374e9a88cbe42$exports(message));
    $2af8bca27d31cd85$exports(that, $d4eab2a2d446bac9$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $19cb5d897edb2112$exports(that, arguments[2]);
    var errorsArray = [];
    $a33355781d2bfa3d$exports(errors, $d4eab2a2d446bac9$var$push, {
        that: errorsArray
    });
    $b4e3b093ae5606fa$exports(that, 'errors', errorsArray);
    return that;
};
if ($60e5bf26176fe7cd$exports) $60e5bf26176fe7cd$exports($d4eab2a2d446bac9$var$$AggregateError, $d4eab2a2d446bac9$var$$Error);
else $ba431b68b50390cb$exports($d4eab2a2d446bac9$var$$AggregateError, $d4eab2a2d446bac9$var$$Error, {
    name: true
});
var $d4eab2a2d446bac9$var$AggregateErrorPrototype = $d4eab2a2d446bac9$var$$AggregateError.prototype = $cfd63855ca92cd7c$exports($d4eab2a2d446bac9$var$$Error.prototype, {
    constructor: $b941c4cd0c3c4a09$exports(1, $d4eab2a2d446bac9$var$$AggregateError),
    message: $b941c4cd0c3c4a09$exports(1, ''),
    name: $b941c4cd0c3c4a09$exports(1, 'AggregateError')
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$ca66147c52f1c36f$exports({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $d4eab2a2d446bac9$var$$AggregateError
});






'use strict';





// `Array.prototype.lastIndex` getter
// https://github.com/tc39/proposal-array-last
if ($ce6ba28f66317609$exports) {
    $ae34d1f2f4f59697$exports(Array.prototype, 'lastIndex', {
        configurable: true,
        get: function lastIndex() {
            var O = $3281447d22a40e21$exports(this);
            var len = $ffd1deb5f4ba5f93$exports(O);
            return len === 0 ? 0 : len - 1;
        }
    });
    $5fd67419be7a523c$exports('lastIndex');
}


'use strict';





// `Array.prototype.lastIndex` accessor
// https://github.com/tc39/proposal-array-last
if ($ce6ba28f66317609$exports) {
    $ae34d1f2f4f59697$exports(Array.prototype, 'lastItem', {
        configurable: true,
        get: function lastItem() {
            var O = $3281447d22a40e21$exports(this);
            var len = $ffd1deb5f4ba5f93$exports(O);
            return len === 0 ? undefined : O[len - 1];
        },
        set: function lastItem(value) {
            var O = $3281447d22a40e21$exports(this);
            var len = $ffd1deb5f4ba5f93$exports(O);
            return O[len === 0 ? 0 : len - 1] = value;
        }
    });
    $5fd67419be7a523c$exports('lastItem');
}


'use strict';


var $4802e4f27766a563$exports = {};
'use strict';
'use strict';
'use strict';
var $e5af86ced7084b74$exports = {};
'use strict';





var $409d78ee72a260e6$exports = {};
'use strict';






var $409d78ee72a260e6$require$defineProperty = $a334f8c362aafa38$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $d35be67ff0c29bbb$export$2d1720544b23b823;
'use strict';



var $d35be67ff0c29bbb$require$$getOwnPropertyNames = $42f35ac27ca8991e$export$2d1720544b23b823;

var $d35be67ff0c29bbb$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $d35be67ff0c29bbb$var$getWindowNames = function(it) {
    try {
        return $d35be67ff0c29bbb$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $7720efb2736da874$exports($d35be67ff0c29bbb$var$windowNames);
    }
};
$d35be67ff0c29bbb$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $d35be67ff0c29bbb$var$windowNames && $11458573e8c84e00$exports(it) === 'Window' ? $d35be67ff0c29bbb$var$getWindowNames(it) : $d35be67ff0c29bbb$require$$getOwnPropertyNames($c76b30b2095e794e$exports(it));
};


var $62a61a1e5df707d5$exports = {};
'use strict';



var $a10e2316e98f9e38$exports = {};
'use strict';

$a10e2316e98f9e38$exports = $10beeae1ca6f1357$exports(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $62a61a1e5df707d5$var$$isExtensible = Object.isExtensible;
var $62a61a1e5df707d5$var$FAILS_ON_PRIMITIVES = $10beeae1ca6f1357$exports(function() {
    $62a61a1e5df707d5$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$62a61a1e5df707d5$exports = $62a61a1e5df707d5$var$FAILS_ON_PRIMITIVES || $a10e2316e98f9e38$exports ? function isExtensible(it) {
    if (!$96a478191b33f4fa$exports(it)) return false;
    if ($a10e2316e98f9e38$exports && $11458573e8c84e00$exports(it) === 'ArrayBuffer') return false;
    return $62a61a1e5df707d5$var$$isExtensible ? $62a61a1e5df707d5$var$$isExtensible(it) : true;
} : $62a61a1e5df707d5$var$$isExtensible;



var $9972b896aaad11f7$exports = {};
'use strict';

$9972b896aaad11f7$exports = !$10beeae1ca6f1357$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});


var $409d78ee72a260e6$var$REQUIRED = false;
var $409d78ee72a260e6$var$METADATA = $4d94c21d38bd74cf$exports('meta');
var $409d78ee72a260e6$var$id = 0;
var $409d78ee72a260e6$var$setMetadata = function(it) {
    $409d78ee72a260e6$require$defineProperty(it, $409d78ee72a260e6$var$METADATA, {
        value: {
            objectID: 'O' + $409d78ee72a260e6$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $409d78ee72a260e6$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$96a478191b33f4fa$exports(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$1d9d3902a50a2fcd$exports(it, $409d78ee72a260e6$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$62a61a1e5df707d5$exports(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $409d78ee72a260e6$var$setMetadata(it);
    // return object ID
    }
    return it[$409d78ee72a260e6$var$METADATA].objectID;
};
var $409d78ee72a260e6$var$getWeakData = function(it, create) {
    if (!$1d9d3902a50a2fcd$exports(it, $409d78ee72a260e6$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$62a61a1e5df707d5$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $409d78ee72a260e6$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$409d78ee72a260e6$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $409d78ee72a260e6$var$onFreeze = function(it) {
    if ($9972b896aaad11f7$exports && $409d78ee72a260e6$var$REQUIRED && $62a61a1e5df707d5$exports(it) && !$1d9d3902a50a2fcd$exports(it, $409d78ee72a260e6$var$METADATA)) $409d78ee72a260e6$var$setMetadata(it);
    return it;
};
var $409d78ee72a260e6$var$enable = function() {
    $409d78ee72a260e6$var$meta.enable = function() {};
    $409d78ee72a260e6$var$REQUIRED = true;
    var getOwnPropertyNames = $42f35ac27ca8991e$export$2d1720544b23b823;
    var splice = $966303461c07e127$exports([].splice);
    var test = {};
    test[$409d78ee72a260e6$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $42f35ac27ca8991e$exports.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $409d78ee72a260e6$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $ca66147c52f1c36f$exports({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $d35be67ff0c29bbb$export$2d1720544b23b823
        });
    }
};
var $409d78ee72a260e6$var$meta = $409d78ee72a260e6$exports = {
    enable: $409d78ee72a260e6$var$enable,
    fastKey: $409d78ee72a260e6$var$fastKey,
    getWeakData: $409d78ee72a260e6$var$getWeakData,
    onFreeze: $409d78ee72a260e6$var$onFreeze
};
$15a8dc1e99b1ac8f$exports[$409d78ee72a260e6$var$METADATA] = true;











$e5af86ced7084b74$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = $1cca30410cf11b53$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $966303461c07e127$exports(NativePrototype[KEY]);
        $a5378e288f28a3de$exports(NativePrototype, KEY, KEY === 'add' ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === 'delete' ? function(key) {
            return IS_WEAK && !$96a478191b33f4fa$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'get' ? function get(key) {
            return IS_WEAK && !$96a478191b33f4fa$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'has' ? function has(key) {
            return IS_WEAK && !$96a478191b33f4fa$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $77d6726afe62b52c$exports(CONSTRUCTOR_NAME, !$66733457c42e4bfd$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$10beeae1ca6f1357$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $409d78ee72a260e6$exports.enable();
    } else if ($77d6726afe62b52c$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $10beeae1ca6f1357$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $d26a0d8e71e915a0$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $10beeae1ca6f1357$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $e75aa794ae249210$exports(dummy, NativePrototype);
                var that = $b00bcd5177827a19$exports(new NativeConstructor(), dummy, Constructor);
                if (!$fc561a35c297b392$exports(iterable)) $a33355781d2bfa3d$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $ca66147c52f1c36f$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $7fe02f462050b03b$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $85d9da1b5316bd8a$exports = {};
'use strict';







var $b5b00d4f6e90c0b3$exports = {};
'use strict';





var $5ddd45eb992f42ad$exports = {};
'use strict';
var $0b7bffb1b8b95ec6$exports = {};
'use strict';








var $0b7bffb1b8b95ec6$var$ITERATOR = $2f02eb6a25cfaf08$exports('iterator');
var $0b7bffb1b8b95ec6$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $0b7bffb1b8b95ec6$var$IteratorPrototype, $0b7bffb1b8b95ec6$var$PrototypeOfArrayIteratorPrototype, $0b7bffb1b8b95ec6$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $0b7bffb1b8b95ec6$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $0b7bffb1b8b95ec6$var$arrayIterator)) $0b7bffb1b8b95ec6$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $0b7bffb1b8b95ec6$var$PrototypeOfArrayIteratorPrototype = $93253fe4514fc36d$exports($93253fe4514fc36d$exports($0b7bffb1b8b95ec6$var$arrayIterator));
        if ($0b7bffb1b8b95ec6$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $0b7bffb1b8b95ec6$var$IteratorPrototype = $0b7bffb1b8b95ec6$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $0b7bffb1b8b95ec6$var$NEW_ITERATOR_PROTOTYPE = !$96a478191b33f4fa$exports($0b7bffb1b8b95ec6$var$IteratorPrototype) || $10beeae1ca6f1357$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $0b7bffb1b8b95ec6$var$IteratorPrototype[$0b7bffb1b8b95ec6$var$ITERATOR].call(test) !== test;
});
if ($0b7bffb1b8b95ec6$var$NEW_ITERATOR_PROTOTYPE) $0b7bffb1b8b95ec6$var$IteratorPrototype = {};
else if ($0f2d8b335bd97f65$exports) $0b7bffb1b8b95ec6$var$IteratorPrototype = $cfd63855ca92cd7c$exports($0b7bffb1b8b95ec6$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$66733457c42e4bfd$exports($0b7bffb1b8b95ec6$var$IteratorPrototype[$0b7bffb1b8b95ec6$var$ITERATOR])) $a5378e288f28a3de$exports($0b7bffb1b8b95ec6$var$IteratorPrototype, $0b7bffb1b8b95ec6$var$ITERATOR, function() {
    return this;
});
$0b7bffb1b8b95ec6$exports = {
    IteratorPrototype: $0b7bffb1b8b95ec6$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $0b7bffb1b8b95ec6$var$BUGGY_SAFARI_ITERATORS
};


var $5ddd45eb992f42ad$require$IteratorPrototype = $0b7bffb1b8b95ec6$exports.IteratorPrototype;




var $5ddd45eb992f42ad$var$returnThis = function() {
    return this;
};
$5ddd45eb992f42ad$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $cfd63855ca92cd7c$exports($5ddd45eb992f42ad$require$IteratorPrototype, {
        next: $b941c4cd0c3c4a09$exports(+!ENUMERABLE_NEXT, next)
    });
    $7fe02f462050b03b$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $45e5c1d92d8f6e7f$exports[TO_STRING_TAG] = $5ddd45eb992f42ad$var$returnThis;
    return IteratorConstructor;
};










var $b5b00d4f6e90c0b3$var$PROPER_FUNCTION_NAME = $c5158caaca2f8ecd$exports.PROPER;
var $b5b00d4f6e90c0b3$var$CONFIGURABLE_FUNCTION_NAME = $c5158caaca2f8ecd$exports.CONFIGURABLE;
var $b5b00d4f6e90c0b3$var$IteratorPrototype = $0b7bffb1b8b95ec6$exports.IteratorPrototype;
var $b5b00d4f6e90c0b3$var$BUGGY_SAFARI_ITERATORS = $0b7bffb1b8b95ec6$exports.BUGGY_SAFARI_ITERATORS;
var $b5b00d4f6e90c0b3$var$ITERATOR = $2f02eb6a25cfaf08$exports('iterator');
var $b5b00d4f6e90c0b3$var$KEYS = 'keys';
var $b5b00d4f6e90c0b3$var$VALUES = 'values';
var $b5b00d4f6e90c0b3$var$ENTRIES = 'entries';
var $b5b00d4f6e90c0b3$var$returnThis = function() {
    return this;
};
$b5b00d4f6e90c0b3$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $5ddd45eb992f42ad$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$b5b00d4f6e90c0b3$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $b5b00d4f6e90c0b3$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $b5b00d4f6e90c0b3$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $b5b00d4f6e90c0b3$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$b5b00d4f6e90c0b3$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$b5b00d4f6e90c0b3$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $93253fe4514fc36d$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$0f2d8b335bd97f65$exports && $93253fe4514fc36d$exports(CurrentIteratorPrototype) !== $b5b00d4f6e90c0b3$var$IteratorPrototype) {
                if ($60e5bf26176fe7cd$exports) $60e5bf26176fe7cd$exports(CurrentIteratorPrototype, $b5b00d4f6e90c0b3$var$IteratorPrototype);
                else if (!$66733457c42e4bfd$exports(CurrentIteratorPrototype[$b5b00d4f6e90c0b3$var$ITERATOR])) $a5378e288f28a3de$exports(CurrentIteratorPrototype, $b5b00d4f6e90c0b3$var$ITERATOR, $b5b00d4f6e90c0b3$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $7fe02f462050b03b$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($0f2d8b335bd97f65$exports) $45e5c1d92d8f6e7f$exports[TO_STRING_TAG] = $b5b00d4f6e90c0b3$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($b5b00d4f6e90c0b3$var$PROPER_FUNCTION_NAME && DEFAULT === $b5b00d4f6e90c0b3$var$VALUES && nativeIterator && nativeIterator.name !== $b5b00d4f6e90c0b3$var$VALUES) {
        if (!$0f2d8b335bd97f65$exports && $b5b00d4f6e90c0b3$var$CONFIGURABLE_FUNCTION_NAME) $b4e3b093ae5606fa$exports(IterablePrototype, 'name', $b5b00d4f6e90c0b3$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $6dd48e140907213f$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($b5b00d4f6e90c0b3$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($b5b00d4f6e90c0b3$var$KEYS),
            entries: getIterationMethod($b5b00d4f6e90c0b3$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($b5b00d4f6e90c0b3$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $a5378e288f28a3de$exports(IterablePrototype, KEY, methods[KEY]);
        } else $ca66147c52f1c36f$exports({
            target: NAME,
            proto: true,
            forced: $b5b00d4f6e90c0b3$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$0f2d8b335bd97f65$exports || FORCED) && IterablePrototype[$b5b00d4f6e90c0b3$var$ITERATOR] !== defaultIterator) $a5378e288f28a3de$exports(IterablePrototype, $b5b00d4f6e90c0b3$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $45e5c1d92d8f6e7f$exports[NAME] = defaultIterator;
    return methods;
};


var $1c0ff8cae751e86d$exports = {};
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$1c0ff8cae751e86d$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};





var $85d9da1b5316bd8a$require$fastKey = $409d78ee72a260e6$exports.fastKey;

var $85d9da1b5316bd8a$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $85d9da1b5316bd8a$var$internalStateGetterFor = $1f4f460c9ddf95ba$exports.getterFor;
$85d9da1b5316bd8a$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $e75aa794ae249210$exports(that, Prototype);
            $85d9da1b5316bd8a$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $cfd63855ca92cd7c$exports(null),
                first: null,
                last: null,
                size: 0
            });
            if (!$ce6ba28f66317609$exports) that.size = 0;
            if (!$fc561a35c297b392$exports(iterable)) $a33355781d2bfa3d$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $85d9da1b5316bd8a$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $85d9da1b5316bd8a$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: null,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($ce6ba28f66317609$exports) state.size++;
                else that.size++;
                // add to index
                if (index !== 'F') state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $85d9da1b5316bd8a$require$fastKey(key);
            var entry;
            if (index !== 'F') return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $6ca4ef67338bdded$exports(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = null;
                    entry = entry.next;
                }
                state.first = state.last = null;
                state.index = $cfd63855ca92cd7c$exports(null);
                if ($ce6ba28f66317609$exports) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            'delete': function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($ce6ba28f66317609$exports) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $6ca4ef67338bdded$exports(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($ce6ba28f66317609$exports) $ae34d1f2f4f59697$exports(Prototype, 'size', {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
        var getInternalCollectionState = $85d9da1b5316bd8a$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $85d9da1b5316bd8a$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $b5b00d4f6e90c0b3$exports(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $85d9da1b5316bd8a$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: null
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = null;
                return $1c0ff8cae751e86d$exports(undefined, true);
            }
            // return step by kind
            if (kind === 'keys') return $1c0ff8cae751e86d$exports(entry.key, false);
            if (kind === 'values') return $1c0ff8cae751e86d$exports(entry.value, false);
            return $1c0ff8cae751e86d$exports([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $8d29cdfa1a37667d$exports(CONSTRUCTOR_NAME);
    }
};


// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$e5af86ced7084b74$exports('Map', function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $85d9da1b5316bd8a$exports);




'use strict';
'use strict';






var $da0095f02dee98c0$exports = {};
'use strict';



var $da0095f02dee98c0$require$getWeakData = $409d78ee72a260e6$exports.getWeakData;








var $da0095f02dee98c0$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $da0095f02dee98c0$var$internalStateGetterFor = $1f4f460c9ddf95ba$exports.getterFor;
var $da0095f02dee98c0$var$find = $03c2ba416765d39a$exports.find;
var $da0095f02dee98c0$var$findIndex = $03c2ba416765d39a$exports.findIndex;
var $da0095f02dee98c0$var$splice = $966303461c07e127$exports([].splice);
var $da0095f02dee98c0$var$id = 0;
// fallback for uncaught frozen keys
var $da0095f02dee98c0$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $da0095f02dee98c0$var$UncaughtFrozenStore());
};
var $da0095f02dee98c0$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $da0095f02dee98c0$var$findUncaughtFrozen = function(store, key) {
    return $da0095f02dee98c0$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$da0095f02dee98c0$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $da0095f02dee98c0$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$da0095f02dee98c0$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $da0095f02dee98c0$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $da0095f02dee98c0$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $da0095f02dee98c0$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$da0095f02dee98c0$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $e75aa794ae249210$exports(that, Prototype);
            $da0095f02dee98c0$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $da0095f02dee98c0$var$id++,
                frozen: null
            });
            if (!$fc561a35c297b392$exports(iterable)) $a33355781d2bfa3d$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $da0095f02dee98c0$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $da0095f02dee98c0$require$getWeakData($c7d52dd23854385b$exports(key), true);
            if (data === true) $da0095f02dee98c0$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $6ca4ef67338bdded$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            'delete': function(key) {
                var state = getInternalState(this);
                if (!$96a478191b33f4fa$exports(key)) return false;
                var data = $da0095f02dee98c0$require$getWeakData(key);
                if (data === true) return $da0095f02dee98c0$var$uncaughtFrozenStore(state)['delete'](key);
                return data && $1d9d3902a50a2fcd$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$96a478191b33f4fa$exports(key)) return false;
                var data = $da0095f02dee98c0$require$getWeakData(key);
                if (data === true) return $da0095f02dee98c0$var$uncaughtFrozenStore(state).has(key);
                return data && $1d9d3902a50a2fcd$exports(data, state.id);
            }
        });
        $6ca4ef67338bdded$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($96a478191b33f4fa$exports(key)) {
                    var data = $da0095f02dee98c0$require$getWeakData(key);
                    if (data === true) return $da0095f02dee98c0$var$uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $68bd9fa0f224dcab$require$enforceInternalState = $1f4f460c9ddf95ba$exports.enforce;


var $68bd9fa0f224dcab$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $68bd9fa0f224dcab$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $68bd9fa0f224dcab$var$isExtensible = $68bd9fa0f224dcab$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $68bd9fa0f224dcab$var$isFrozen = $68bd9fa0f224dcab$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $68bd9fa0f224dcab$var$isSealed = $68bd9fa0f224dcab$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $68bd9fa0f224dcab$var$freeze = $68bd9fa0f224dcab$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $68bd9fa0f224dcab$var$seal = $68bd9fa0f224dcab$var$$Object.seal;
var $68bd9fa0f224dcab$var$IS_IE11 = !$1cca30410cf11b53$exports.ActiveXObject && 'ActiveXObject' in $1cca30410cf11b53$exports;
var $68bd9fa0f224dcab$var$InternalWeakMap;
var $68bd9fa0f224dcab$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $68bd9fa0f224dcab$var$$WeakMap = $e5af86ced7084b74$exports('WeakMap', $68bd9fa0f224dcab$var$wrapper, $da0095f02dee98c0$exports);
var $68bd9fa0f224dcab$var$WeakMapPrototype = $68bd9fa0f224dcab$var$$WeakMap.prototype;
var $68bd9fa0f224dcab$var$nativeSet = $966303461c07e127$exports($68bd9fa0f224dcab$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $68bd9fa0f224dcab$var$hasMSEdgeFreezingBug = function() {
    return $9972b896aaad11f7$exports && $10beeae1ca6f1357$exports(function() {
        var frozenArray = $68bd9fa0f224dcab$var$freeze([]);
        $68bd9fa0f224dcab$var$nativeSet(new $68bd9fa0f224dcab$var$$WeakMap(), frozenArray, 1);
        return !$68bd9fa0f224dcab$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($fd45195445cad199$exports) {
    if ($68bd9fa0f224dcab$var$IS_IE11) {
        $68bd9fa0f224dcab$var$InternalWeakMap = $da0095f02dee98c0$exports.getConstructor($68bd9fa0f224dcab$var$wrapper, 'WeakMap', true);
        $409d78ee72a260e6$exports.enable();
        var $68bd9fa0f224dcab$var$nativeDelete = $966303461c07e127$exports($68bd9fa0f224dcab$var$WeakMapPrototype['delete']);
        var $68bd9fa0f224dcab$var$nativeHas = $966303461c07e127$exports($68bd9fa0f224dcab$var$WeakMapPrototype.has);
        var $68bd9fa0f224dcab$var$nativeGet = $966303461c07e127$exports($68bd9fa0f224dcab$var$WeakMapPrototype.get);
        $6ca4ef67338bdded$exports($68bd9fa0f224dcab$var$WeakMapPrototype, {
            'delete': function(key) {
                if ($96a478191b33f4fa$exports(key) && !$68bd9fa0f224dcab$var$isExtensible(key)) {
                    var state = $68bd9fa0f224dcab$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $68bd9fa0f224dcab$var$InternalWeakMap();
                    return $68bd9fa0f224dcab$var$nativeDelete(this, key) || state.frozen['delete'](key);
                }
                return $68bd9fa0f224dcab$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($96a478191b33f4fa$exports(key) && !$68bd9fa0f224dcab$var$isExtensible(key)) {
                    var state = $68bd9fa0f224dcab$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $68bd9fa0f224dcab$var$InternalWeakMap();
                    return $68bd9fa0f224dcab$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $68bd9fa0f224dcab$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($96a478191b33f4fa$exports(key) && !$68bd9fa0f224dcab$var$isExtensible(key)) {
                    var state = $68bd9fa0f224dcab$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $68bd9fa0f224dcab$var$InternalWeakMap();
                    return $68bd9fa0f224dcab$var$nativeHas(this, key) ? $68bd9fa0f224dcab$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $68bd9fa0f224dcab$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($96a478191b33f4fa$exports(key) && !$68bd9fa0f224dcab$var$isExtensible(key)) {
                    var state = $68bd9fa0f224dcab$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $68bd9fa0f224dcab$var$InternalWeakMap();
                    $68bd9fa0f224dcab$var$nativeHas(this, key) ? $68bd9fa0f224dcab$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $68bd9fa0f224dcab$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($68bd9fa0f224dcab$var$hasMSEdgeFreezingBug()) $6ca4ef67338bdded$exports($68bd9fa0f224dcab$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($68bd9fa0f224dcab$var$isArray(key)) {
                if ($68bd9fa0f224dcab$var$isFrozen(key)) arrayIntegrityLevel = $68bd9fa0f224dcab$var$freeze;
                else if ($68bd9fa0f224dcab$var$isSealed(key)) arrayIntegrityLevel = $68bd9fa0f224dcab$var$seal;
            }
            $68bd9fa0f224dcab$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}







var $4802e4f27766a563$var$$Object = Object;
var $4802e4f27766a563$var$$TypeError = TypeError;
var $4802e4f27766a563$var$Map = $a262b772204f9131$exports('Map');
var $4802e4f27766a563$var$WeakMap = $a262b772204f9131$exports('WeakMap');
var $4802e4f27766a563$var$Node = function() {
    // keys
    this.object = null;
    this.symbol = null;
    // child nodes
    this.primitives = null;
    this.objectsByIndex = $cfd63855ca92cd7c$exports(null);
};
$4802e4f27766a563$var$Node.prototype.get = function(key, initializer) {
    return this[key] || (this[key] = initializer());
};
$4802e4f27766a563$var$Node.prototype.next = function(i, it, IS_OBJECT) {
    var store = IS_OBJECT ? this.objectsByIndex[i] || (this.objectsByIndex[i] = new $4802e4f27766a563$var$WeakMap()) : this.primitives || (this.primitives = new $4802e4f27766a563$var$Map());
    var entry = store.get(it);
    if (!entry) store.set(it, entry = new $4802e4f27766a563$var$Node());
    return entry;
};
var $4802e4f27766a563$var$root = new $4802e4f27766a563$var$Node();
$4802e4f27766a563$exports = function() {
    var active = $4802e4f27766a563$var$root;
    var length = arguments.length;
    var i, it;
    // for prevent leaking, start from objects
    for(i = 0; i < length; i++)if ($96a478191b33f4fa$exports(it = arguments[i])) active = active.next(i, it, true);
    if (this === $4802e4f27766a563$var$$Object && active === $4802e4f27766a563$var$root) throw new $4802e4f27766a563$var$$TypeError('Composite keys must contain a non-primitive component');
    for(i = 0; i < length; i++)if (!$96a478191b33f4fa$exports(it = arguments[i])) active = active.next(i, it, false);
    return active;
};




var $dd6df1621d49d915$var$$Object = Object;
var $dd6df1621d49d915$var$initializer = function() {
    var freeze = $a262b772204f9131$exports('Object', 'freeze');
    return freeze ? freeze($cfd63855ca92cd7c$exports(null)) : $cfd63855ca92cd7c$exports(null);
};
// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$ca66147c52f1c36f$exports({
    global: true,
    forced: true
}, {
    compositeKey: function compositeKey() {
        return $36ddd4c4a517e2d6$exports($4802e4f27766a563$exports, $dd6df1621d49d915$var$$Object, arguments).get('object', $dd6df1621d49d915$var$initializer);
    }
});


'use strict';




// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$ca66147c52f1c36f$exports({
    global: true,
    forced: true
}, {
    compositeSymbol: function compositeSymbol() {
        if (arguments.length === 1 && typeof arguments[0] == 'string') return $a262b772204f9131$exports('Symbol')['for'](arguments[0]);
        return $36ddd4c4a517e2d6$exports($4802e4f27766a563$exports, null, arguments).get('symbol', $a262b772204f9131$exports('Symbol'));
    }
});


'use strict';
'use strict';


// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$ca66147c52f1c36f$exports({
    global: true,
    forced: $1cca30410cf11b53$exports.globalThis !== $1cca30410cf11b53$exports
}, {
    globalThis: $1cca30410cf11b53$exports
});




'use strict';

var $b96d25da73f2a720$exports = {};
'use strict';
var $cd6632a6e9a7cab5$exports = {};
'use strict';

// eslint-disable-next-line es/no-map -- safe
var $cd6632a6e9a7cab5$var$MapPrototype = Map.prototype;
$cd6632a6e9a7cab5$exports = {
    // eslint-disable-next-line es/no-map -- safe
    Map: Map,
    set: $966303461c07e127$exports($cd6632a6e9a7cab5$var$MapPrototype.set),
    get: $966303461c07e127$exports($cd6632a6e9a7cab5$var$MapPrototype.get),
    has: $966303461c07e127$exports($cd6632a6e9a7cab5$var$MapPrototype.has),
    remove: $966303461c07e127$exports($cd6632a6e9a7cab5$var$MapPrototype['delete']),
    proto: $cd6632a6e9a7cab5$var$MapPrototype
};


var $b96d25da73f2a720$require$has = $cd6632a6e9a7cab5$exports.has;
// Perform ? RequireInternalSlot(M, [[MapData]])
$b96d25da73f2a720$exports = function(it) {
    $b96d25da73f2a720$require$has(it);
    return it;
};



var $810af99d6c8137bb$require$remove = $cd6632a6e9a7cab5$exports.remove;
// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $b96d25da73f2a720$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $810af99d6c8137bb$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


'use strict';



var $90d95a01603d826f$exports = {};
'use strict';

var $d34a2e93dc4521d0$exports = {};
'use strict';

$d34a2e93dc4521d0$exports = function(record, fn, ITERATOR_INSTEAD_OF_RECORD) {
    var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
    var next = record.next;
    var step, result;
    while(!(step = $6dd48e140907213f$exports(next, iterator)).done){
        result = fn(step.value);
        if (result !== undefined) return result;
    }
};



var $90d95a01603d826f$var$Map = $cd6632a6e9a7cab5$exports.Map;
var $90d95a01603d826f$var$MapPrototype = $cd6632a6e9a7cab5$exports.proto;
var $90d95a01603d826f$var$forEach = $966303461c07e127$exports($90d95a01603d826f$var$MapPrototype.forEach);
var $90d95a01603d826f$var$entries = $966303461c07e127$exports($90d95a01603d826f$var$MapPrototype.entries);
var $90d95a01603d826f$var$next = $90d95a01603d826f$var$entries(new $90d95a01603d826f$var$Map()).next;
$90d95a01603d826f$exports = function(map, fn, interruptible) {
    return interruptible ? $d34a2e93dc4521d0$exports({
        iterator: $90d95a01603d826f$var$entries(map),
        next: $90d95a01603d826f$var$next
    }, function(entry) {
        return fn(entry[1], entry[0]);
    }) : $90d95a01603d826f$var$forEach(map, fn);
};


// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $90d95a01603d826f$exports(map, function(value, key) {
            if (!boundFunction(value, key, map)) return false;
        }, true) !== false;
    }
});


'use strict';





var $934981ac2a7f0ee7$var$Map = $cd6632a6e9a7cab5$exports.Map;
var $934981ac2a7f0ee7$var$set = $cd6632a6e9a7cab5$exports.set;
// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $934981ac2a7f0ee7$var$Map();
        $90d95a01603d826f$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) $934981ac2a7f0ee7$var$set(newMap, key, value);
        });
        return newMap;
    }
});


'use strict';




// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $90d95a01603d826f$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});


'use strict';




// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    findKey: function findKey(callbackfn /* , thisArg */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $90d95a01603d826f$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});


'use strict';


var $75aeba2d80efbe23$exports = {};
'use strict';




$75aeba2d80efbe23$exports = function(C, adder, ENTRY) {
    return function from(source /* , mapFn, thisArg */ ) {
        var O = $3281447d22a40e21$exports(source);
        var length = arguments.length;
        var mapFn = length > 1 ? arguments[1] : undefined;
        var mapping = mapFn !== undefined;
        var boundFunction = mapping ? $2d52694feff5f895$exports(mapFn, length > 2 ? arguments[2] : undefined) : undefined;
        var result = new C();
        var n = 0;
        $a33355781d2bfa3d$exports(O, function(nextItem) {
            var entry = mapping ? boundFunction(nextItem, n++) : nextItem;
            if (ENTRY) adder(result, $c7d52dd23854385b$exports(entry)[0], entry[1]);
            else adder(result, entry);
        });
        return result;
    };
};


// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
$ca66147c52f1c36f$exports({
    target: 'Map',
    stat: true,
    forced: true
}, {
    from: $75aeba2d80efbe23$exports($cd6632a6e9a7cab5$exports.Map, $cd6632a6e9a7cab5$exports.set, true)
});


'use strict';
'use strict';








var $0ae585f8e32de291$var$Map = $cd6632a6e9a7cab5$exports.Map;
var $0ae585f8e32de291$var$has = $cd6632a6e9a7cab5$exports.has;
var $0ae585f8e32de291$var$get = $cd6632a6e9a7cab5$exports.get;
var $0ae585f8e32de291$var$set = $cd6632a6e9a7cab5$exports.set;
var $0ae585f8e32de291$var$push = $966303461c07e127$exports([].push);
// https://bugs.webkit.org/show_bug.cgi?id=271524
var $0ae585f8e32de291$var$DOES_NOT_WORK_WITH_PRIMITIVES = $0f2d8b335bd97f65$exports || $10beeae1ca6f1357$exports(function() {
    return $0ae585f8e32de291$var$Map.groupBy('ab', function(it) {
        return it;
    }).get('a').length !== 1;
});
// `Map.groupBy` method
// https://tc39.es/ecma262/#sec-map.groupby
$ca66147c52f1c36f$exports({
    target: 'Map',
    stat: true,
    forced: $0f2d8b335bd97f65$exports || $0ae585f8e32de291$var$DOES_NOT_WORK_WITH_PRIMITIVES
}, {
    groupBy: function groupBy(items, callbackfn) {
        $8fd6426c81bfca55$exports(items);
        $ac451d11dfa909df$exports(callbackfn);
        var map = new $0ae585f8e32de291$var$Map();
        var k = 0;
        $a33355781d2bfa3d$exports(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$0ae585f8e32de291$var$has(map, key)) $0ae585f8e32de291$var$set(map, key, [
                value
            ]);
            else $0ae585f8e32de291$var$push($0ae585f8e32de291$var$get(map, key), value);
        });
        return map;
    }
});




'use strict';

var $0ee0a960cbbd484a$exports = {};
'use strict';
// `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero
$0ee0a960cbbd484a$exports = function(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y || x !== x && y !== y;
};




// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    includes: function includes(searchElement) {
        return $90d95a01603d826f$exports($b96d25da73f2a720$exports(this), function(value) {
            if ($0ee0a960cbbd484a$exports(value, searchElement)) return true;
        }, true) === true;
    }
});


'use strict';






var $2e8e41d3b7cc1b27$require$Map = $cd6632a6e9a7cab5$exports.Map;
// `Map.keyBy` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    stat: true,
    forced: true
}, {
    keyBy: function keyBy(iterable, keyDerivative) {
        var C = $66733457c42e4bfd$exports(this) ? this : $2e8e41d3b7cc1b27$require$Map;
        var newMap = new C();
        $ac451d11dfa909df$exports(keyDerivative);
        var setter = $ac451d11dfa909df$exports(newMap.set);
        $a33355781d2bfa3d$exports(iterable, function(element) {
            $6dd48e140907213f$exports(setter, newMap, keyDerivative(element), element);
        });
        return newMap;
    }
});


'use strict';



// `Map.prototype.keyOf` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    keyOf: function keyOf(searchElement) {
        var result = $90d95a01603d826f$exports($b96d25da73f2a720$exports(this), function(value, key) {
            if (value === searchElement) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});


'use strict';





var $21eb5d7841ba0905$var$Map = $cd6632a6e9a7cab5$exports.Map;
var $21eb5d7841ba0905$var$set = $cd6632a6e9a7cab5$exports.set;
// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    mapKeys: function mapKeys(callbackfn /* , thisArg */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $21eb5d7841ba0905$var$Map();
        $90d95a01603d826f$exports(map, function(value, key) {
            $21eb5d7841ba0905$var$set(newMap, boundFunction(value, key, map), value);
        });
        return newMap;
    }
});


'use strict';





var $3231e32cc9c706a4$var$Map = $cd6632a6e9a7cab5$exports.Map;
var $3231e32cc9c706a4$var$set = $cd6632a6e9a7cab5$exports.set;
// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    mapValues: function mapValues(callbackfn /* , thisArg */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $3231e32cc9c706a4$var$Map();
        $90d95a01603d826f$exports(map, function(value, key) {
            $3231e32cc9c706a4$var$set(newMap, key, boundFunction(value, key, map));
        });
        return newMap;
    }
});


'use strict';




var $9bea139ce0c36eea$require$set = $cd6632a6e9a7cab5$exports.set;
// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    arity: 1,
    forced: true
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    merge: function merge(iterable /* ...iterables */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var argumentsLength = arguments.length;
        var i = 0;
        while(i < argumentsLength)$a33355781d2bfa3d$exports(arguments[i++], function(key, value) {
            $9bea139ce0c36eea$require$set(map, key, value);
        }, {
            AS_ENTRIES: true
        });
        return map;
    }
});


'use strict';


var $9ec416a1e1fa2338$exports = {};
'use strict';

// https://tc39.github.io/proposal-setmap-offrom/
$9ec416a1e1fa2338$exports = function(C, adder, ENTRY) {
    return function of() {
        var result = new C();
        var length = arguments.length;
        for(var index = 0; index < length; index++){
            var entry = arguments[index];
            if (ENTRY) adder(result, $c7d52dd23854385b$exports(entry)[0], entry[1]);
            else adder(result, entry);
        }
        return result;
    };
};


// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
$ca66147c52f1c36f$exports({
    target: 'Map',
    stat: true,
    forced: true
}, {
    of: $9ec416a1e1fa2338$exports($cd6632a6e9a7cab5$exports.Map, $cd6632a6e9a7cab5$exports.set, true)
});


'use strict';




var $0eb73c6b7acf525d$var$$TypeError = TypeError;
// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $ac451d11dfa909df$exports(callbackfn);
        $90d95a01603d826f$exports(map, function(value, key) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, key, map);
        });
        if (noInitial) throw new $0eb73c6b7acf525d$var$$TypeError('Reduce of empty map with no initial value');
        return accumulator;
    }
});


'use strict';




// `Map.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $90d95a01603d826f$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return true;
        }, true) === true;
    }
});


'use strict';




var $0589bf844368bd45$var$$TypeError = TypeError;
var $0589bf844368bd45$var$get = $cd6632a6e9a7cab5$exports.get;
var $0589bf844368bd45$var$has = $cd6632a6e9a7cab5$exports.has;
var $0589bf844368bd45$var$set = $cd6632a6e9a7cab5$exports.set;
// `Map.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    update: function update(key, callback /* , thunk */ ) {
        var map = $b96d25da73f2a720$exports(this);
        var length = arguments.length;
        $ac451d11dfa909df$exports(callback);
        var isPresentInMap = $0589bf844368bd45$var$has(map, key);
        if (!isPresentInMap && length < 3) throw new $0589bf844368bd45$var$$TypeError('Updating absent value');
        var value = isPresentInMap ? $0589bf844368bd45$var$get(map, key) : $ac451d11dfa909df$exports(length > 2 ? arguments[2] : undefined)(key, map);
        $0589bf844368bd45$var$set(map, key, callback(value, key, map));
        return map;
    }
});


'use strict';

var $7c8c1dd8b6f49596$exports = {};
'use strict';
var $1dc35f39f72cd1cf$exports = {};
'use strict';
var $1dc35f39f72cd1cf$var$$TypeError = TypeError;
$1dc35f39f72cd1cf$exports = function(argument) {
    if (typeof argument == 'number') return argument;
    throw new $1dc35f39f72cd1cf$var$$TypeError('Argument is not a number');
};


var $7c8c1dd8b6f49596$var$$min = Math.min;
var $7c8c1dd8b6f49596$var$$max = Math.max;
$7c8c1dd8b6f49596$exports = function clamp(value, min, max) {
    return $7c8c1dd8b6f49596$var$$min($7c8c1dd8b6f49596$var$$max($1dc35f39f72cd1cf$exports(value), $1dc35f39f72cd1cf$exports(min)), $1dc35f39f72cd1cf$exports(max));
};


// TODO: Remove from `core-js@4`
// `Math.clamp` method
// https://github.com/tc39/proposal-math-clamp
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    clamp: $7c8c1dd8b6f49596$exports
});


'use strict';

// `Math.DEG_PER_RAD` constant
// https://rwaldron.github.io/proposal-math-extensions/
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    DEG_PER_RAD: Math.PI / 180
});


'use strict';

var $2b9a7e78163bdc3e$var$RAD_PER_DEG = 180 / Math.PI;
// `Math.degrees` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    degrees: function degrees(radians) {
        return radians * $2b9a7e78163bdc3e$var$RAD_PER_DEG;
    }
});


'use strict';

var $6dc2f50e3e3356d0$exports = {};
'use strict';
// `Math.scale` method implementation
// https://rwaldron.github.io/proposal-math-extensions/
$6dc2f50e3e3356d0$exports = function scale(x, inLow, inHigh, outLow, outHigh) {
    var nx = +x;
    var nInLow = +inLow;
    var nInHigh = +inHigh;
    var nOutLow = +outLow;
    var nOutHigh = +outHigh;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (nx !== nx || nInLow !== nInLow || nInHigh !== nInHigh || nOutLow !== nOutLow || nOutHigh !== nOutHigh) return NaN;
    if (nx === Infinity || nx === -Infinity) return nx;
    return (nx - nInLow) * (nOutHigh - nOutLow) / (nInHigh - nInLow) + nOutLow;
};



// `Math.fscale` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
        return $18b20c7125f37382$exports($6dc2f50e3e3356d0$exports(x, inLow, inHigh, outLow, outHigh));
    }
});


'use strict';

// `Math.iaddh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    iaddh: function iaddh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
});


'use strict';

// `Math.imulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    imulh: function imulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >> 16;
        var v1 = $v >> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
});


'use strict';

// `Math.isubh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    isubh: function isubh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
});


'use strict';

// `Math.RAD_PER_DEG` constant
// https://rwaldron.github.io/proposal-math-extensions/
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    RAD_PER_DEG: 180 / Math.PI
});


'use strict';

var $90d190cd13a81ee5$var$DEG_PER_RAD = Math.PI / 180;
// `Math.radians` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    radians: function radians(degrees) {
        return degrees * $90d190cd13a81ee5$var$DEG_PER_RAD;
    }
});


'use strict';


// `Math.scale` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    scale: $6dc2f50e3e3356d0$exports
});


'use strict';


var $81bd5a69f6f903f2$exports = {};
'use strict';

var $81bd5a69f6f903f2$var$globalIsFinite = $1cca30410cf11b53$exports.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
$81bd5a69f6f903f2$exports = Number.isFinite || function isFinite(it) {
    return typeof it == 'number' && $81bd5a69f6f903f2$var$globalIsFinite(it);
};





var $bc1575f531d17c0c$var$SEEDED_RANDOM = 'Seeded Random';
var $bc1575f531d17c0c$var$SEEDED_RANDOM_GENERATOR = $bc1575f531d17c0c$var$SEEDED_RANDOM + ' Generator';
var $bc1575f531d17c0c$var$SEED_TYPE_ERROR = 'Math.seededPRNG() argument should have a "seed" field with a finite value.';
var $bc1575f531d17c0c$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $bc1575f531d17c0c$var$getInternalState = $1f4f460c9ddf95ba$exports.getterFor($bc1575f531d17c0c$var$SEEDED_RANDOM_GENERATOR);
var $bc1575f531d17c0c$var$$TypeError = TypeError;
var $bc1575f531d17c0c$var$$SeededRandomGenerator = $5ddd45eb992f42ad$exports(function SeededRandomGenerator(seed) {
    $bc1575f531d17c0c$var$setInternalState(this, {
        type: $bc1575f531d17c0c$var$SEEDED_RANDOM_GENERATOR,
        seed: seed % 2147483647
    });
}, $bc1575f531d17c0c$var$SEEDED_RANDOM, function next() {
    var state = $bc1575f531d17c0c$var$getInternalState(this);
    var seed = state.seed = (state.seed * 1103515245 + 12345) % 2147483647;
    return $1c0ff8cae751e86d$exports((seed & 1073741823) / 1073741823, false);
});
// `Math.seededPRNG` method
// https://github.com/tc39/proposal-seeded-random
// based on https://github.com/tc39/proposal-seeded-random/blob/78b8258835b57fc2100d076151ab506bc3202ae6/demo.html
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    seededPRNG: function seededPRNG(it) {
        var seed = $c7d52dd23854385b$exports(it).seed;
        if (!$81bd5a69f6f903f2$exports(seed)) throw new $bc1575f531d17c0c$var$$TypeError($bc1575f531d17c0c$var$SEED_TYPE_ERROR);
        return new $bc1575f531d17c0c$var$$SeededRandomGenerator(seed);
    }
});


'use strict';

// `Math.signbit` method
// https://github.com/tc39/proposal-Math.signbit
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    signbit: function signbit(x) {
        var n = +x;
        // eslint-disable-next-line no-self-compare -- NaN check
        return n === n && n === 0 ? 1 / n === -Infinity : n < 0;
    }
});


'use strict';

// `Math.umulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    umulh: function umulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >>> 16;
        var v1 = $v >>> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
});


'use strict';



var $fec179d9da4bc930$var$INVALID_NUMBER_REPRESENTATION = 'Invalid number representation';
var $fec179d9da4bc930$var$INVALID_RADIX = 'Invalid radix';
var $fec179d9da4bc930$var$$RangeError = RangeError;
var $fec179d9da4bc930$var$$SyntaxError = SyntaxError;
var $fec179d9da4bc930$var$$TypeError = TypeError;
var $fec179d9da4bc930$var$$parseInt = parseInt;
var $fec179d9da4bc930$var$pow = Math.pow;
var $fec179d9da4bc930$var$valid = /^[\d.a-z]+$/;
var $fec179d9da4bc930$var$charAt = $966303461c07e127$exports(''.charAt);
var $fec179d9da4bc930$var$exec = $966303461c07e127$exports($fec179d9da4bc930$var$valid.exec);
var $fec179d9da4bc930$var$numberToString = $966303461c07e127$exports(1.1.toString);
var $fec179d9da4bc930$var$stringSlice = $966303461c07e127$exports(''.slice);
var $fec179d9da4bc930$var$split = $966303461c07e127$exports(''.split);
// `Number.fromString` method
// https://github.com/tc39/proposal-number-fromstring
$ca66147c52f1c36f$exports({
    target: 'Number',
    stat: true,
    forced: true
}, {
    fromString: function fromString(string, radix) {
        var sign = 1;
        if (typeof string != 'string') throw new $fec179d9da4bc930$var$$TypeError($fec179d9da4bc930$var$INVALID_NUMBER_REPRESENTATION);
        if (!string.length) throw new $fec179d9da4bc930$var$$SyntaxError($fec179d9da4bc930$var$INVALID_NUMBER_REPRESENTATION);
        if ($fec179d9da4bc930$var$charAt(string, 0) === '-') {
            sign = -1;
            string = $fec179d9da4bc930$var$stringSlice(string, 1);
            if (!string.length) throw new $fec179d9da4bc930$var$$SyntaxError($fec179d9da4bc930$var$INVALID_NUMBER_REPRESENTATION);
        }
        var R = radix === undefined ? 10 : $9f3eb545512efe9e$exports(radix);
        if (R < 2 || R > 36) throw new $fec179d9da4bc930$var$$RangeError($fec179d9da4bc930$var$INVALID_RADIX);
        if (!$fec179d9da4bc930$var$exec($fec179d9da4bc930$var$valid, string)) throw new $fec179d9da4bc930$var$$SyntaxError($fec179d9da4bc930$var$INVALID_NUMBER_REPRESENTATION);
        var parts = $fec179d9da4bc930$var$split(string, '.');
        var mathNum = $fec179d9da4bc930$var$$parseInt(parts[0], R);
        if (parts.length > 1) mathNum += $fec179d9da4bc930$var$$parseInt(parts[1], R) / $fec179d9da4bc930$var$pow(R, parts[1].length);
        if (R === 10 && $fec179d9da4bc930$var$numberToString(mathNum, R) !== string) throw new $fec179d9da4bc930$var$$SyntaxError($fec179d9da4bc930$var$INVALID_NUMBER_REPRESENTATION);
        return sign * mathNum;
    }
});


'use strict';
'use strict';














var $fb984e250adcea76$exports = {};
'use strict';
$fb984e250adcea76$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};




var $302cc91f17812590$var$$$OBSERVABLE = $2f02eb6a25cfaf08$exports('observable');
var $302cc91f17812590$var$OBSERVABLE = 'Observable';
var $302cc91f17812590$var$SUBSCRIPTION = 'Subscription';
var $302cc91f17812590$var$SUBSCRIPTION_OBSERVER = 'SubscriptionObserver';
var $302cc91f17812590$var$getterFor = $1f4f460c9ddf95ba$exports.getterFor;
var $302cc91f17812590$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $302cc91f17812590$var$getObservableInternalState = $302cc91f17812590$var$getterFor($302cc91f17812590$var$OBSERVABLE);
var $302cc91f17812590$var$getSubscriptionInternalState = $302cc91f17812590$var$getterFor($302cc91f17812590$var$SUBSCRIPTION);
var $302cc91f17812590$var$getSubscriptionObserverInternalState = $302cc91f17812590$var$getterFor($302cc91f17812590$var$SUBSCRIPTION_OBSERVER);
var $302cc91f17812590$var$SubscriptionState = function(observer) {
    this.observer = $c7d52dd23854385b$exports(observer);
    this.cleanup = null;
    this.subscriptionObserver = null;
};
$302cc91f17812590$var$SubscriptionState.prototype = {
    type: $302cc91f17812590$var$SUBSCRIPTION,
    clean: function() {
        var cleanup = this.cleanup;
        if (cleanup) {
            this.cleanup = null;
            try {
                cleanup();
            } catch (error) {
                $fb984e250adcea76$exports(error);
            }
        }
    },
    close: function() {
        if (!$ce6ba28f66317609$exports) {
            var subscription = this.facade;
            var subscriptionObserver = this.subscriptionObserver;
            subscription.closed = true;
            if (subscriptionObserver) subscriptionObserver.closed = true;
        }
        this.observer = null;
    },
    isClosed: function() {
        return this.observer === null;
    }
};
var $302cc91f17812590$var$Subscription = function(observer, subscriber) {
    var subscriptionState = $302cc91f17812590$var$setInternalState(this, new $302cc91f17812590$var$SubscriptionState(observer));
    var start;
    if (!$ce6ba28f66317609$exports) this.closed = false;
    try {
        if (start = $cb7d485ba5a2e30b$exports(observer, 'start')) $6dd48e140907213f$exports(start, observer, this);
    } catch (error) {
        $fb984e250adcea76$exports(error);
    }
    if (subscriptionState.isClosed()) return;
    var subscriptionObserver = subscriptionState.subscriptionObserver = new $302cc91f17812590$var$SubscriptionObserver(subscriptionState);
    try {
        var cleanup = subscriber(subscriptionObserver);
        var subscription = cleanup;
        if (!$fc561a35c297b392$exports(cleanup)) subscriptionState.cleanup = $66733457c42e4bfd$exports(cleanup.unsubscribe) ? function() {
            subscription.unsubscribe();
        } : $ac451d11dfa909df$exports(cleanup);
    } catch (error) {
        subscriptionObserver.error(error);
        return;
    }
    if (subscriptionState.isClosed()) subscriptionState.clean();
};
$302cc91f17812590$var$Subscription.prototype = $6ca4ef67338bdded$exports({}, {
    unsubscribe: function unsubscribe() {
        var subscriptionState = $302cc91f17812590$var$getSubscriptionInternalState(this);
        if (!subscriptionState.isClosed()) {
            subscriptionState.close();
            subscriptionState.clean();
        }
    }
});
if ($ce6ba28f66317609$exports) $ae34d1f2f4f59697$exports($302cc91f17812590$var$Subscription.prototype, 'closed', {
    configurable: true,
    get: function closed() {
        return $302cc91f17812590$var$getSubscriptionInternalState(this).isClosed();
    }
});
var $302cc91f17812590$var$SubscriptionObserver = function(subscriptionState) {
    $302cc91f17812590$var$setInternalState(this, {
        type: $302cc91f17812590$var$SUBSCRIPTION_OBSERVER,
        subscriptionState: subscriptionState
    });
    if (!$ce6ba28f66317609$exports) this.closed = false;
};
$302cc91f17812590$var$SubscriptionObserver.prototype = $6ca4ef67338bdded$exports({}, {
    next: function next(value) {
        var subscriptionState = $302cc91f17812590$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            try {
                var nextMethod = $cb7d485ba5a2e30b$exports(observer, 'next');
                if (nextMethod) $6dd48e140907213f$exports(nextMethod, observer, value);
            } catch (error) {
                $fb984e250adcea76$exports(error);
            }
        }
    },
    error: function error(value) {
        var subscriptionState = $302cc91f17812590$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var errorMethod = $cb7d485ba5a2e30b$exports(observer, 'error');
                if (errorMethod) $6dd48e140907213f$exports(errorMethod, observer, value);
                else $fb984e250adcea76$exports(value);
            } catch (err) {
                $fb984e250adcea76$exports(err);
            }
            subscriptionState.clean();
        }
    },
    complete: function complete() {
        var subscriptionState = $302cc91f17812590$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var completeMethod = $cb7d485ba5a2e30b$exports(observer, 'complete');
                if (completeMethod) $6dd48e140907213f$exports(completeMethod, observer);
            } catch (error) {
                $fb984e250adcea76$exports(error);
            }
            subscriptionState.clean();
        }
    }
});
if ($ce6ba28f66317609$exports) $ae34d1f2f4f59697$exports($302cc91f17812590$var$SubscriptionObserver.prototype, 'closed', {
    configurable: true,
    get: function closed() {
        return $302cc91f17812590$var$getSubscriptionObserverInternalState(this).subscriptionState.isClosed();
    }
});
var $302cc91f17812590$var$$Observable = function Observable(subscriber) {
    $e75aa794ae249210$exports(this, $302cc91f17812590$var$ObservablePrototype);
    $302cc91f17812590$var$setInternalState(this, {
        type: $302cc91f17812590$var$OBSERVABLE,
        subscriber: $ac451d11dfa909df$exports(subscriber)
    });
};
var $302cc91f17812590$var$ObservablePrototype = $302cc91f17812590$var$$Observable.prototype;
$6ca4ef67338bdded$exports($302cc91f17812590$var$ObservablePrototype, {
    subscribe: function subscribe(observer) {
        var length = arguments.length;
        return new $302cc91f17812590$var$Subscription($66733457c42e4bfd$exports(observer) ? {
            next: observer,
            error: length > 1 ? arguments[1] : undefined,
            complete: length > 2 ? arguments[2] : undefined
        } : $96a478191b33f4fa$exports(observer) ? observer : {}, $302cc91f17812590$var$getObservableInternalState(this).subscriber);
    }
});
$a5378e288f28a3de$exports($302cc91f17812590$var$ObservablePrototype, $302cc91f17812590$var$$$OBSERVABLE, function() {
    return this;
});
$ca66147c52f1c36f$exports({
    global: true,
    constructor: true,
    forced: true
}, {
    Observable: $302cc91f17812590$var$$Observable
});
$8d29cdfa1a37667d$exports($302cc91f17812590$var$OBSERVABLE);


'use strict';









var $a3fe2ce63e22aa49$var$$$OBSERVABLE = $2f02eb6a25cfaf08$exports('observable');
// `Observable.from` method
// https://github.com/tc39/proposal-observable
$ca66147c52f1c36f$exports({
    target: 'Observable',
    stat: true,
    forced: true
}, {
    from: function from(x) {
        var C = $d81cf5a9f1de1452$exports(this) ? this : $a262b772204f9131$exports('Observable');
        var observableMethod = $cb7d485ba5a2e30b$exports($c7d52dd23854385b$exports(x), $a3fe2ce63e22aa49$var$$$OBSERVABLE);
        if (observableMethod) {
            var observable = $c7d52dd23854385b$exports($6dd48e140907213f$exports(observableMethod, x));
            return observable.constructor === C ? observable : new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        var iterator = $f9d5016d77a62d39$exports(x);
        return new C(function(observer) {
            $a33355781d2bfa3d$exports(iterator, function(it, stop) {
                observer.next(it);
                if (observer.closed) return stop();
            }, {
                IS_ITERATOR: true,
                INTERRUPTED: true
            });
            observer.complete();
        });
    }
});


'use strict';



var $b9c66ff97ae5dd56$var$Array = $a262b772204f9131$exports('Array');
// `Observable.of` method
// https://github.com/tc39/proposal-observable
$ca66147c52f1c36f$exports({
    target: 'Observable',
    stat: true,
    forced: true
}, {
    of: function of() {
        var C = $d81cf5a9f1de1452$exports(this) ? this : $a262b772204f9131$exports('Observable');
        var length = arguments.length;
        var items = $b9c66ff97ae5dd56$var$Array(length);
        var index = 0;
        while(index < length)items[index] = arguments[index++];
        return new C(function(observer) {
            for(var i = 0; i < length; i++){
                observer.next(items[i]);
                if (observer.closed) return;
            }
            observer.complete();
        });
    }
});




'use strict';
'use strict';




var $c5732305179d309a$exports = {};
'use strict';
$c5732305179d309a$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};



var $8633e0bd4ba4e588$exports = {};
'use strict';


var $4533bc1279bc9a8e$exports = {};
'use strict';






var $fa54dc94d54c733d$exports = {};
'use strict';



var $fa54dc94d54c733d$var$userAgentStartsWith = function(string) {
    return $bcca79ca01f4b5fb$exports.slice(0, string.length) === string;
};
$fa54dc94d54c733d$exports = function() {
    if ($fa54dc94d54c733d$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($fa54dc94d54c733d$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($fa54dc94d54c733d$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($fa54dc94d54c733d$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($1cca30410cf11b53$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($1cca30410cf11b53$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($11458573e8c84e00$exports($1cca30410cf11b53$exports.process) === 'process') return 'NODE';
    if ($1cca30410cf11b53$exports.window && $1cca30410cf11b53$exports.document) return 'BROWSER';
    return 'REST';
}();




var $4533bc1279bc9a8e$var$NativePromisePrototype = $829d0cfc1679e6db$exports && $829d0cfc1679e6db$exports.prototype;
var $4533bc1279bc9a8e$var$SPECIES = $2f02eb6a25cfaf08$exports('species');
var $4533bc1279bc9a8e$var$SUBCLASSING = false;
var $4533bc1279bc9a8e$var$NATIVE_PROMISE_REJECTION_EVENT = $66733457c42e4bfd$exports($1cca30410cf11b53$exports.PromiseRejectionEvent);
var $4533bc1279bc9a8e$var$FORCED_PROMISE_CONSTRUCTOR = $77d6726afe62b52c$exports('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $12069b4949848a4e$exports($829d0cfc1679e6db$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($829d0cfc1679e6db$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $cc9c540ab7776841$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($0f2d8b335bd97f65$exports && !($4533bc1279bc9a8e$var$NativePromisePrototype['catch'] && $4533bc1279bc9a8e$var$NativePromisePrototype['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$cc9c540ab7776841$exports || $cc9c540ab7776841$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $829d0cfc1679e6db$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$4533bc1279bc9a8e$var$SPECIES] = FakePromise;
        $4533bc1279bc9a8e$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$4533bc1279bc9a8e$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($fa54dc94d54c733d$exports === 'BROWSER' || $fa54dc94d54c733d$exports === 'DENO') && !$4533bc1279bc9a8e$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$4533bc1279bc9a8e$exports = {
    CONSTRUCTOR: $4533bc1279bc9a8e$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $4533bc1279bc9a8e$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $4533bc1279bc9a8e$var$SUBCLASSING
};


var $8633e0bd4ba4e588$require$FORCED_PROMISE_CONSTRUCTOR = $4533bc1279bc9a8e$exports.CONSTRUCTOR;
$8633e0bd4ba4e588$exports = $8633e0bd4ba4e588$require$FORCED_PROMISE_CONSTRUCTOR || !$d26a0d8e71e915a0$exports(function(iterable) {
    $829d0cfc1679e6db$exports.all(iterable).then(undefined, function() {});
});


// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$ca66147c52f1c36f$exports({
    target: 'Promise',
    stat: true,
    forced: $8633e0bd4ba4e588$exports
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $f491a36e63b3b535$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $c5732305179d309a$exports(function() {
            var promiseResolve = $ac451d11dfa909df$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $a33355781d2bfa3d$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $6dd48e140907213f$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'fulfilled',
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'rejected',
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});




'use strict';
'use strict';








var $e319e95e365178f5$var$PROMISE_ANY_ERROR = 'No one promise resolved';
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$ca66147c52f1c36f$exports({
    target: 'Promise',
    stat: true,
    forced: $8633e0bd4ba4e588$exports
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $a262b772204f9131$exports('AggregateError');
        var capability = $f491a36e63b3b535$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $c5732305179d309a$exports(function() {
            var promiseResolve = $ac451d11dfa909df$exports(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $a33355781d2bfa3d$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $6dd48e140907213f$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $e319e95e365178f5$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $e319e95e365178f5$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});




'use strict';
'use strict';







var $b2fb78a24eb1faea$var$Promise = $1cca30410cf11b53$exports.Promise;
var $b2fb78a24eb1faea$var$ACCEPT_ARGUMENTS = false;
// Avoiding the use of polyfills of the previous iteration of this proposal
// that does not accept arguments of the callback
var $b2fb78a24eb1faea$var$FORCED = !$b2fb78a24eb1faea$var$Promise || !$b2fb78a24eb1faea$var$Promise['try'] || $c5732305179d309a$exports(function() {
    $b2fb78a24eb1faea$var$Promise['try'](function(argument) {
        $b2fb78a24eb1faea$var$ACCEPT_ARGUMENTS = argument === 8;
    }, 8);
}).error || !$b2fb78a24eb1faea$var$ACCEPT_ARGUMENTS;
// `Promise.try` method
// https://tc39.es/ecma262/#sec-promise.try
$ca66147c52f1c36f$exports({
    target: 'Promise',
    stat: true,
    forced: $b2fb78a24eb1faea$var$FORCED
}, {
    'try': function(callbackfn /* , ...args */ ) {
        var args = arguments.length > 1 ? $7720efb2736da874$exports(arguments, 1) : [];
        var promiseCapability = $f491a36e63b3b535$export$2d1720544b23b823(this);
        var result = $c5732305179d309a$exports(function() {
            return $36ddd4c4a517e2d6$exports($ac451d11dfa909df$exports(callbackfn), undefined, args);
        });
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});




'use strict';

var $47eccb7bd486fb94$exports = {};
'use strict';





var $47eccb7bd486fb94$var$Map = $a262b772204f9131$exports('Map');
var $47eccb7bd486fb94$var$WeakMap = $a262b772204f9131$exports('WeakMap');
var $47eccb7bd486fb94$var$push = $966303461c07e127$exports([].push);
var $47eccb7bd486fb94$var$metadata = $310c440ce6020a4b$exports('metadata');
var $47eccb7bd486fb94$var$store = $47eccb7bd486fb94$var$metadata.store || ($47eccb7bd486fb94$var$metadata.store = new $47eccb7bd486fb94$var$WeakMap());
var $47eccb7bd486fb94$var$getOrCreateMetadataMap = function(target, targetKey, create) {
    var targetMetadata = $47eccb7bd486fb94$var$store.get(target);
    if (!targetMetadata) {
        if (!create) return;
        $47eccb7bd486fb94$var$store.set(target, targetMetadata = new $47eccb7bd486fb94$var$Map());
    }
    var keyMetadata = targetMetadata.get(targetKey);
    if (!keyMetadata) {
        if (!create) return;
        targetMetadata.set(targetKey, keyMetadata = new $47eccb7bd486fb94$var$Map());
    }
    return keyMetadata;
};
var $47eccb7bd486fb94$var$ordinaryHasOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $47eccb7bd486fb94$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var $47eccb7bd486fb94$var$ordinaryGetOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $47eccb7bd486fb94$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var $47eccb7bd486fb94$var$ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P) {
    $47eccb7bd486fb94$var$getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var $47eccb7bd486fb94$var$ordinaryOwnMetadataKeys = function(target, targetKey) {
    var metadataMap = $47eccb7bd486fb94$var$getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function(_, key) {
        $47eccb7bd486fb94$var$push(keys, key);
    });
    return keys;
};
var $47eccb7bd486fb94$var$toMetadataKey = function(it) {
    return it === undefined || typeof it == 'symbol' ? it : String(it);
};
$47eccb7bd486fb94$exports = {
    store: $47eccb7bd486fb94$var$store,
    getMap: $47eccb7bd486fb94$var$getOrCreateMetadataMap,
    has: $47eccb7bd486fb94$var$ordinaryHasOwnMetadata,
    get: $47eccb7bd486fb94$var$ordinaryGetOwnMetadata,
    set: $47eccb7bd486fb94$var$ordinaryDefineOwnMetadata,
    keys: $47eccb7bd486fb94$var$ordinaryOwnMetadataKeys,
    toKey: $47eccb7bd486fb94$var$toMetadataKey
};



var $d1eefed0905939df$var$toMetadataKey = $47eccb7bd486fb94$exports.toKey;
var $d1eefed0905939df$var$ordinaryDefineOwnMetadata = $47eccb7bd486fb94$exports.set;
// `Reflect.defineMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca66147c52f1c36f$exports({
    target: 'Reflect',
    stat: true
}, {
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target /* , targetKey */ ) {
        var targetKey = arguments.length < 4 ? undefined : $d1eefed0905939df$var$toMetadataKey(arguments[3]);
        $d1eefed0905939df$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $c7d52dd23854385b$exports(target), targetKey);
    }
});


'use strict';



var $2c72ba9e868c76a3$var$toMetadataKey = $47eccb7bd486fb94$exports.toKey;
var $2c72ba9e868c76a3$var$getOrCreateMetadataMap = $47eccb7bd486fb94$exports.getMap;
var $2c72ba9e868c76a3$var$store = $47eccb7bd486fb94$exports.store;
// `Reflect.deleteMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca66147c52f1c36f$exports({
    target: 'Reflect',
    stat: true
}, {
    deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $2c72ba9e868c76a3$var$toMetadataKey(arguments[2]);
        var metadataMap = $2c72ba9e868c76a3$var$getOrCreateMetadataMap($c7d52dd23854385b$exports(target), targetKey, false);
        if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = $2c72ba9e868c76a3$var$store.get(target);
        targetMetadata['delete'](targetKey);
        return !!targetMetadata.size || $2c72ba9e868c76a3$var$store['delete'](target);
    }
});


'use strict';




var $508177ecb1df43f7$var$ordinaryHasOwnMetadata = $47eccb7bd486fb94$exports.has;
var $508177ecb1df43f7$var$ordinaryGetOwnMetadata = $47eccb7bd486fb94$exports.get;
var $508177ecb1df43f7$var$toMetadataKey = $47eccb7bd486fb94$exports.toKey;
var $508177ecb1df43f7$var$ordinaryGetMetadata = function(MetadataKey, O, P) {
    var hasOwn = $508177ecb1df43f7$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return $508177ecb1df43f7$var$ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = $93253fe4514fc36d$exports(O);
    return parent !== null ? $508177ecb1df43f7$var$ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};
// `Reflect.getMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca66147c52f1c36f$exports({
    target: 'Reflect',
    stat: true
}, {
    getMetadata: function getMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $508177ecb1df43f7$var$toMetadataKey(arguments[2]);
        return $508177ecb1df43f7$var$ordinaryGetMetadata(metadataKey, $c7d52dd23854385b$exports(target), targetKey);
    }
});


'use strict';





var $d12f6ee5e3faeeb3$exports = {};
'use strict';







var $d12f6ee5e3faeeb3$var$Map = $cd6632a6e9a7cab5$exports.Map;
var $d12f6ee5e3faeeb3$var$mapHas = $cd6632a6e9a7cab5$exports.has;
var $d12f6ee5e3faeeb3$var$mapSet = $cd6632a6e9a7cab5$exports.set;
var $d12f6ee5e3faeeb3$var$push = $966303461c07e127$exports([].push);
// `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique
$d12f6ee5e3faeeb3$exports = function uniqueBy(resolver) {
    var that = $3281447d22a40e21$exports(this);
    var length = $ffd1deb5f4ba5f93$exports(that);
    var result = [];
    var map = new $d12f6ee5e3faeeb3$var$Map();
    var resolverFunction = !$fc561a35c297b392$exports(resolver) ? $ac451d11dfa909df$exports(resolver) : function(value) {
        return value;
    };
    var index, item, key;
    for(index = 0; index < length; index++){
        item = that[index];
        key = resolverFunction(item);
        if (!$d12f6ee5e3faeeb3$var$mapHas(map, key)) $d12f6ee5e3faeeb3$var$mapSet(map, key, item);
    }
    $90d95a01603d826f$exports(map, function(value) {
        $d12f6ee5e3faeeb3$var$push(result, value);
    });
    return result;
};


var $617c68709f5e0294$var$arrayUniqueBy = $966303461c07e127$exports($d12f6ee5e3faeeb3$exports);
var $617c68709f5e0294$var$concat = $966303461c07e127$exports([].concat);
var $617c68709f5e0294$var$ordinaryOwnMetadataKeys = $47eccb7bd486fb94$exports.keys;
var $617c68709f5e0294$var$toMetadataKey = $47eccb7bd486fb94$exports.toKey;
var $617c68709f5e0294$var$ordinaryMetadataKeys = function(O, P) {
    var oKeys = $617c68709f5e0294$var$ordinaryOwnMetadataKeys(O, P);
    var parent = $93253fe4514fc36d$exports(O);
    if (parent === null) return oKeys;
    var pKeys = $617c68709f5e0294$var$ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? $617c68709f5e0294$var$arrayUniqueBy($617c68709f5e0294$var$concat(oKeys, pKeys)) : pKeys : oKeys;
};
// `Reflect.getMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$ca66147c52f1c36f$exports({
    target: 'Reflect',
    stat: true
}, {
    getMetadataKeys: function getMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $617c68709f5e0294$var$toMetadataKey(arguments[1]);
        return $617c68709f5e0294$var$ordinaryMetadataKeys($c7d52dd23854385b$exports(target), targetKey);
    }
});


'use strict';



var $08f4fb11ff00335f$var$ordinaryGetOwnMetadata = $47eccb7bd486fb94$exports.get;
var $08f4fb11ff00335f$var$toMetadataKey = $47eccb7bd486fb94$exports.toKey;
// `Reflect.getOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca66147c52f1c36f$exports({
    target: 'Reflect',
    stat: true
}, {
    getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $08f4fb11ff00335f$var$toMetadataKey(arguments[2]);
        return $08f4fb11ff00335f$var$ordinaryGetOwnMetadata(metadataKey, $c7d52dd23854385b$exports(target), targetKey);
    }
});


'use strict';



var $cd028e24c4269d2b$var$ordinaryOwnMetadataKeys = $47eccb7bd486fb94$exports.keys;
var $cd028e24c4269d2b$var$toMetadataKey = $47eccb7bd486fb94$exports.toKey;
// `Reflect.getOwnMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$ca66147c52f1c36f$exports({
    target: 'Reflect',
    stat: true
}, {
    getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $cd028e24c4269d2b$var$toMetadataKey(arguments[1]);
        return $cd028e24c4269d2b$var$ordinaryOwnMetadataKeys($c7d52dd23854385b$exports(target), targetKey);
    }
});


'use strict';




var $499451943f846406$var$ordinaryHasOwnMetadata = $47eccb7bd486fb94$exports.has;
var $499451943f846406$var$toMetadataKey = $47eccb7bd486fb94$exports.toKey;
var $499451943f846406$var$ordinaryHasMetadata = function(MetadataKey, O, P) {
    var hasOwn = $499451943f846406$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = $93253fe4514fc36d$exports(O);
    return parent !== null ? $499451943f846406$var$ordinaryHasMetadata(MetadataKey, parent, P) : false;
};
// `Reflect.hasMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca66147c52f1c36f$exports({
    target: 'Reflect',
    stat: true
}, {
    hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $499451943f846406$var$toMetadataKey(arguments[2]);
        return $499451943f846406$var$ordinaryHasMetadata(metadataKey, $c7d52dd23854385b$exports(target), targetKey);
    }
});


'use strict';



var $501f501bff8bec8b$var$ordinaryHasOwnMetadata = $47eccb7bd486fb94$exports.has;
var $501f501bff8bec8b$var$toMetadataKey = $47eccb7bd486fb94$exports.toKey;
// `Reflect.hasOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca66147c52f1c36f$exports({
    target: 'Reflect',
    stat: true
}, {
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $501f501bff8bec8b$var$toMetadataKey(arguments[2]);
        return $501f501bff8bec8b$var$ordinaryHasOwnMetadata(metadataKey, $c7d52dd23854385b$exports(target), targetKey);
    }
});


'use strict';



var $7c6c47ccf64f723c$var$toMetadataKey = $47eccb7bd486fb94$exports.toKey;
var $7c6c47ccf64f723c$var$ordinaryDefineOwnMetadata = $47eccb7bd486fb94$exports.set;
// `Reflect.metadata` method
// https://github.com/rbuckton/reflect-metadata
$ca66147c52f1c36f$exports({
    target: 'Reflect',
    stat: true
}, {
    metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, key) {
            $7c6c47ccf64f723c$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $c7d52dd23854385b$exports(target), $7c6c47ccf64f723c$var$toMetadataKey(key));
        };
    }
});


'use strict';

var $6013ceb4c3355aec$exports = {};
'use strict';
var $dd531d8569926e90$exports = {};
'use strict';

// eslint-disable-next-line es/no-set -- safe
var $dd531d8569926e90$var$SetPrototype = Set.prototype;
$dd531d8569926e90$exports = {
    // eslint-disable-next-line es/no-set -- safe
    Set: Set,
    add: $966303461c07e127$exports($dd531d8569926e90$var$SetPrototype.add),
    has: $966303461c07e127$exports($dd531d8569926e90$var$SetPrototype.has),
    remove: $966303461c07e127$exports($dd531d8569926e90$var$SetPrototype['delete']),
    proto: $dd531d8569926e90$var$SetPrototype
};


var $6013ceb4c3355aec$require$has = $dd531d8569926e90$exports.has;
// Perform ? RequireInternalSlot(M, [[SetData]])
$6013ceb4c3355aec$exports = function(it) {
    $6013ceb4c3355aec$require$has(it);
    return it;
};



var $9f3f29f5a8dff53c$require$add = $dd531d8569926e90$exports.add;
// `Set.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    addAll: function addAll() {
        var set = $6013ceb4c3355aec$exports(this);
        for(var k = 0, len = arguments.length; k < len; k++)$9f3f29f5a8dff53c$require$add(set, arguments[k]);
        return set;
    }
});


'use strict';



var $d11904f7a990d9b8$require$remove = $dd531d8569926e90$exports.remove;
// `Set.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $6013ceb4c3355aec$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $d11904f7a990d9b8$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


'use strict';


var $7b89b8b8a75db4c3$exports = {};
'use strict';


var $042100e298c69897$exports = {};
'use strict';





var $042100e298c69897$var$ITERATOR = $2f02eb6a25cfaf08$exports('iterator');
var $042100e298c69897$var$$Object = Object;
$042100e298c69897$exports = function(it) {
    if ($fc561a35c297b392$exports(it)) return false;
    var O = $042100e298c69897$var$$Object(it);
    return O[$042100e298c69897$var$ITERATOR] !== undefined || '@@iterator' in O || $1d9d3902a50a2fcd$exports($45e5c1d92d8f6e7f$exports, $39673a197979f5e7$exports(O));
};



var $7b89b8b8a75db4c3$var$Set = $a262b772204f9131$exports('Set');
var $7b89b8b8a75db4c3$var$isSetLike = function(it) {
    return $96a478191b33f4fa$exports(it) && typeof it.size == 'number' && $66733457c42e4bfd$exports(it.has) && $66733457c42e4bfd$exports(it.keys);
};
// fallback old -> new set methods proposal arguments
$7b89b8b8a75db4c3$exports = function(it) {
    if ($7b89b8b8a75db4c3$var$isSetLike(it)) return it;
    return $042100e298c69897$exports(it) ? new $7b89b8b8a75db4c3$var$Set(it) : it;
};


var $7b646c8d03b4a8a8$exports = {};
'use strict';


var $a40f583aef777826$exports = {};
'use strict';

var $394074b14d681722$exports = {};
'use strict';



var $394074b14d681722$var$Set = $dd531d8569926e90$exports.Set;
var $394074b14d681722$var$SetPrototype = $dd531d8569926e90$exports.proto;
var $394074b14d681722$var$forEach = $966303461c07e127$exports($394074b14d681722$var$SetPrototype.forEach);
var $394074b14d681722$var$keys = $966303461c07e127$exports($394074b14d681722$var$SetPrototype.keys);
var $394074b14d681722$var$next = $394074b14d681722$var$keys(new $394074b14d681722$var$Set()).next;
$394074b14d681722$exports = function(set, fn, interruptible) {
    return interruptible ? $d34a2e93dc4521d0$exports({
        iterator: $394074b14d681722$var$keys(set),
        next: $394074b14d681722$var$next
    }, fn) : $394074b14d681722$var$forEach(set, fn);
};


var $a40f583aef777826$var$Set = $dd531d8569926e90$exports.Set;
var $a40f583aef777826$var$add = $dd531d8569926e90$exports.add;
$a40f583aef777826$exports = function(set) {
    var result = new $a40f583aef777826$var$Set();
    $394074b14d681722$exports(set, function(it) {
        $a40f583aef777826$var$add(result, it);
    });
    return result;
};


var $42b5768a404da748$exports = {};
'use strict';


$42b5768a404da748$exports = $77aa6ef82c147863$exports($dd531d8569926e90$exports.proto, 'size', 'get') || function(set) {
    return set.size;
};


var $7d7bf01e775844ee$exports = {};
'use strict';




var $e80e9ad7a9b31387$exports = {};
'use strict';
// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/ecma262/#sec-getiteratordirect
$e80e9ad7a9b31387$exports = function(obj) {
    return {
        iterator: obj,
        next: obj.next,
        done: false
    };
};


var $7d7bf01e775844ee$var$INVALID_SIZE = 'Invalid size';
var $7d7bf01e775844ee$var$$RangeError = RangeError;
var $7d7bf01e775844ee$var$$TypeError = TypeError;
var $7d7bf01e775844ee$var$max = Math.max;
var $7d7bf01e775844ee$var$SetRecord = function(set, intSize) {
    this.set = set;
    this.size = $7d7bf01e775844ee$var$max(intSize, 0);
    this.has = $ac451d11dfa909df$exports(set.has);
    this.keys = $ac451d11dfa909df$exports(set.keys);
};
$7d7bf01e775844ee$var$SetRecord.prototype = {
    getIterator: function() {
        return $e80e9ad7a9b31387$exports($c7d52dd23854385b$exports($6dd48e140907213f$exports(this.keys, this.set)));
    },
    includes: function(it) {
        return $6dd48e140907213f$exports(this.has, this.set, it);
    }
};
// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
$7d7bf01e775844ee$exports = function(obj) {
    $c7d52dd23854385b$exports(obj);
    var numSize = +obj.size;
    // NOTE: If size is undefined, then numSize will be NaN
    // eslint-disable-next-line no-self-compare -- NaN check
    if (numSize !== numSize) throw new $7d7bf01e775844ee$var$$TypeError($7d7bf01e775844ee$var$INVALID_SIZE);
    var intSize = $9f3eb545512efe9e$exports(numSize);
    if (intSize < 0) throw new $7d7bf01e775844ee$var$$RangeError($7d7bf01e775844ee$var$INVALID_SIZE);
    return new $7d7bf01e775844ee$var$SetRecord(obj, intSize);
};




var $7b646c8d03b4a8a8$var$has = $dd531d8569926e90$exports.has;
var $7b646c8d03b4a8a8$var$remove = $dd531d8569926e90$exports.remove;
// `Set.prototype.difference` method
// https://tc39.es/ecma262/#sec-set.prototype.difference
$7b646c8d03b4a8a8$exports = function difference(other) {
    var O = $6013ceb4c3355aec$exports(this);
    var otherRec = $7d7bf01e775844ee$exports(other);
    var result = $a40f583aef777826$exports(O);
    if ($42b5768a404da748$exports(O) <= otherRec.size) $394074b14d681722$exports(O, function(e) {
        if (otherRec.includes(e)) $7b646c8d03b4a8a8$var$remove(result, e);
    });
    else $d34a2e93dc4521d0$exports(otherRec.getIterator(), function(e) {
        if ($7b646c8d03b4a8a8$var$has(result, e)) $7b646c8d03b4a8a8$var$remove(result, e);
    });
    return result;
};


// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    difference: function difference(other) {
        return $6dd48e140907213f$exports($7b646c8d03b4a8a8$exports, this, $7b89b8b8a75db4c3$exports(other));
    }
});


'use strict';




// `Set.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var set = $6013ceb4c3355aec$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $394074b14d681722$exports(set, function(value) {
            if (!boundFunction(value, value, set)) return false;
        }, true) !== false;
    }
});


'use strict';





var $136a3aa4502632dc$var$Set = $dd531d8569926e90$exports.Set;
var $136a3aa4502632dc$var$add = $dd531d8569926e90$exports.add;
// `Set.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var set = $6013ceb4c3355aec$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newSet = new $136a3aa4502632dc$var$Set();
        $394074b14d681722$exports(set, function(value) {
            if (boundFunction(value, value, set)) $136a3aa4502632dc$var$add(newSet, value);
        });
        return newSet;
    }
});


'use strict';




// `Set.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var set = $6013ceb4c3355aec$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $394074b14d681722$exports(set, function(value) {
            if (boundFunction(value, value, set)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});


'use strict';



// `Set.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
$ca66147c52f1c36f$exports({
    target: 'Set',
    stat: true,
    forced: true
}, {
    from: $75aeba2d80efbe23$exports($dd531d8569926e90$exports.Set, $dd531d8569926e90$exports.add, false)
});


'use strict';



var $ab8e1411caaf9680$exports = {};
'use strict';






var $ab8e1411caaf9680$var$Set = $dd531d8569926e90$exports.Set;
var $ab8e1411caaf9680$var$add = $dd531d8569926e90$exports.add;
var $ab8e1411caaf9680$var$has = $dd531d8569926e90$exports.has;
// `Set.prototype.intersection` method
// https://tc39.es/ecma262/#sec-set.prototype.intersection
$ab8e1411caaf9680$exports = function intersection(other) {
    var O = $6013ceb4c3355aec$exports(this);
    var otherRec = $7d7bf01e775844ee$exports(other);
    var result = new $ab8e1411caaf9680$var$Set();
    if ($42b5768a404da748$exports(O) > otherRec.size) $d34a2e93dc4521d0$exports(otherRec.getIterator(), function(e) {
        if ($ab8e1411caaf9680$var$has(O, e)) $ab8e1411caaf9680$var$add(result, e);
    });
    else $394074b14d681722$exports(O, function(e) {
        if (otherRec.includes(e)) $ab8e1411caaf9680$var$add(result, e);
    });
    return result;
};


// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    intersection: function intersection(other) {
        return $6dd48e140907213f$exports($ab8e1411caaf9680$exports, this, $7b89b8b8a75db4c3$exports(other));
    }
});


'use strict';



var $669d667cc6d31cac$exports = {};
'use strict';


var $669d667cc6d31cac$require$has = $dd531d8569926e90$exports.has;





// `Set.prototype.isDisjointFrom` method
// https://tc39.es/ecma262/#sec-set.prototype.isdisjointfrom
$669d667cc6d31cac$exports = function isDisjointFrom(other) {
    var O = $6013ceb4c3355aec$exports(this);
    var otherRec = $7d7bf01e775844ee$exports(other);
    if ($42b5768a404da748$exports(O) <= otherRec.size) return $394074b14d681722$exports(O, function(e) {
        if (otherRec.includes(e)) return false;
    }, true) !== false;
    var iterator = otherRec.getIterator();
    return $d34a2e93dc4521d0$exports(iterator, function(e) {
        if ($669d667cc6d31cac$require$has(O, e)) return $970ad60dab2ac818$exports(iterator, 'normal', false);
    }) !== false;
};


// `Set.prototype.isDisjointFrom` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    isDisjointFrom: function isDisjointFrom(other) {
        return $6dd48e140907213f$exports($669d667cc6d31cac$exports, this, $7b89b8b8a75db4c3$exports(other));
    }
});


'use strict';



var $8d76cc11f2b2efb0$exports = {};
'use strict';




// `Set.prototype.isSubsetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issubsetof
$8d76cc11f2b2efb0$exports = function isSubsetOf(other) {
    var O = $6013ceb4c3355aec$exports(this);
    var otherRec = $7d7bf01e775844ee$exports(other);
    if ($42b5768a404da748$exports(O) > otherRec.size) return false;
    return $394074b14d681722$exports(O, function(e) {
        if (!otherRec.includes(e)) return false;
    }, true) !== false;
};


// `Set.prototype.isSubsetOf` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    isSubsetOf: function isSubsetOf(other) {
        return $6dd48e140907213f$exports($8d76cc11f2b2efb0$exports, this, $7b89b8b8a75db4c3$exports(other));
    }
});


'use strict';



var $b99c29bb11ab7c9f$exports = {};
'use strict';


var $b99c29bb11ab7c9f$require$has = $dd531d8569926e90$exports.has;




// `Set.prototype.isSupersetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issupersetof
$b99c29bb11ab7c9f$exports = function isSupersetOf(other) {
    var O = $6013ceb4c3355aec$exports(this);
    var otherRec = $7d7bf01e775844ee$exports(other);
    if ($42b5768a404da748$exports(O) < otherRec.size) return false;
    var iterator = otherRec.getIterator();
    return $d34a2e93dc4521d0$exports(iterator, function(e) {
        if (!$b99c29bb11ab7c9f$require$has(O, e)) return $970ad60dab2ac818$exports(iterator, 'normal', false);
    }) !== false;
};


// `Set.prototype.isSupersetOf` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    isSupersetOf: function isSupersetOf(other) {
        return $6dd48e140907213f$exports($b99c29bb11ab7c9f$exports, this, $7b89b8b8a75db4c3$exports(other));
    }
});


'use strict';





var $c48012677f166d18$var$arrayJoin = $966303461c07e127$exports([].join);
var $c48012677f166d18$var$push = $966303461c07e127$exports([].push);
// `Set.prototype.join` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    join: function join(separator) {
        var set = $6013ceb4c3355aec$exports(this);
        var sep = separator === undefined ? ',' : $cc1f216aa7e44c59$exports(separator);
        var array = [];
        $394074b14d681722$exports(set, function(value) {
            $c48012677f166d18$var$push(array, value);
        });
        return $c48012677f166d18$var$arrayJoin(array, sep);
    }
});


'use strict';





var $bd2bf27fd4413dc7$var$Set = $dd531d8569926e90$exports.Set;
var $bd2bf27fd4413dc7$var$add = $dd531d8569926e90$exports.add;
// `Set.prototype.map` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        var set = $6013ceb4c3355aec$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newSet = new $bd2bf27fd4413dc7$var$Set();
        $394074b14d681722$exports(set, function(value) {
            $bd2bf27fd4413dc7$var$add(newSet, boundFunction(value, value, set));
        });
        return newSet;
    }
});


'use strict';



// `Set.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
$ca66147c52f1c36f$exports({
    target: 'Set',
    stat: true,
    forced: true
}, {
    of: $9ec416a1e1fa2338$exports($dd531d8569926e90$exports.Set, $dd531d8569926e90$exports.add, false)
});


'use strict';




var $6d3bd5a9d52118cf$var$$TypeError = TypeError;
// `Set.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var set = $6013ceb4c3355aec$exports(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $ac451d11dfa909df$exports(callbackfn);
        $394074b14d681722$exports(set, function(value) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, value, set);
        });
        if (noInitial) throw new $6d3bd5a9d52118cf$var$$TypeError('Reduce of empty set with no initial value');
        return accumulator;
    }
});


'use strict';




// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var set = $6013ceb4c3355aec$exports(this);
        var boundFunction = $2d52694feff5f895$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $394074b14d681722$exports(set, function(value) {
            if (boundFunction(value, value, set)) return true;
        }, true) === true;
    }
});


'use strict';



var $77887dde46434af4$exports = {};
'use strict';





var $77887dde46434af4$var$add = $dd531d8569926e90$exports.add;
var $77887dde46434af4$var$has = $dd531d8569926e90$exports.has;
var $77887dde46434af4$var$remove = $dd531d8569926e90$exports.remove;
// `Set.prototype.symmetricDifference` method
// https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
$77887dde46434af4$exports = function symmetricDifference(other) {
    var O = $6013ceb4c3355aec$exports(this);
    var keysIter = $7d7bf01e775844ee$exports(other).getIterator();
    var result = $a40f583aef777826$exports(O);
    $d34a2e93dc4521d0$exports(keysIter, function(e) {
        if ($77887dde46434af4$var$has(O, e)) $77887dde46434af4$var$remove(result, e);
        else $77887dde46434af4$var$add(result, e);
    });
    return result;
};


// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    symmetricDifference: function symmetricDifference(other) {
        return $6dd48e140907213f$exports($77887dde46434af4$exports, this, $7b89b8b8a75db4c3$exports(other));
    }
});


'use strict';



var $2d7d2c5556edffd8$exports = {};
'use strict';


var $2d7d2c5556edffd8$require$add = $dd531d8569926e90$exports.add;



// `Set.prototype.union` method
// https://tc39.es/ecma262/#sec-set.prototype.union
$2d7d2c5556edffd8$exports = function union(other) {
    var O = $6013ceb4c3355aec$exports(this);
    var keysIter = $7d7bf01e775844ee$exports(other).getIterator();
    var result = $a40f583aef777826$exports(O);
    $d34a2e93dc4521d0$exports(keysIter, function(it) {
        $2d7d2c5556edffd8$require$add(result, it);
    });
    return result;
};


// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca66147c52f1c36f$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    union: function union(other) {
        return $6dd48e140907213f$exports($2d7d2c5556edffd8$exports, this, $7b89b8b8a75db4c3$exports(other));
    }
});


'use strict';


var $372dfa95acbbceec$require$charAt = $63ce28df052c8c19$exports.charAt;



// `String.prototype.at` method
// https://github.com/mathiasbynens/String.prototype.at
$ca66147c52f1c36f$exports({
    target: 'String',
    proto: true,
    forced: true
}, {
    at: function at(index) {
        var S = $cc1f216aa7e44c59$exports($8fd6426c81bfca55$exports(this));
        var len = S.length;
        var relativeIndex = $9f3eb545512efe9e$exports(index);
        var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
        return k < 0 || k >= len ? undefined : $372dfa95acbbceec$require$charAt(S, k);
    }
});


'use strict';







var $89c3adf6718c9c34$var$codeAt = $63ce28df052c8c19$exports.codeAt;
var $89c3adf6718c9c34$var$charAt = $63ce28df052c8c19$exports.charAt;
var $89c3adf6718c9c34$var$STRING_ITERATOR = 'String Iterator';
var $89c3adf6718c9c34$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $89c3adf6718c9c34$var$getInternalState = $1f4f460c9ddf95ba$exports.getterFor($89c3adf6718c9c34$var$STRING_ITERATOR);
// TODO: unify with String#@@iterator
var $89c3adf6718c9c34$var$$StringIterator = $5ddd45eb992f42ad$exports(function StringIterator(string) {
    $89c3adf6718c9c34$var$setInternalState(this, {
        type: $89c3adf6718c9c34$var$STRING_ITERATOR,
        string: string,
        index: 0
    });
}, 'String', function next() {
    var state = $89c3adf6718c9c34$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $1c0ff8cae751e86d$exports(undefined, true);
    point = $89c3adf6718c9c34$var$charAt(string, index);
    state.index += point.length;
    return $1c0ff8cae751e86d$exports({
        codePoint: $89c3adf6718c9c34$var$codeAt(point, 0),
        position: index
    }, false);
});
// `String.prototype.codePoints` method
// https://github.com/tc39/proposal-string-prototype-codepoints
$ca66147c52f1c36f$exports({
    target: 'String',
    proto: true,
    forced: true
}, {
    codePoints: function codePoints() {
        return new $89c3adf6718c9c34$var$$StringIterator($cc1f216aa7e44c59$exports($8fd6426c81bfca55$exports(this)));
    }
});


'use strict';
'use strict';






















var $9247de2c126d9e1b$var$MATCH_ALL = $2f02eb6a25cfaf08$exports('matchAll');
var $9247de2c126d9e1b$var$REGEXP_STRING = 'RegExp String';
var $9247de2c126d9e1b$var$REGEXP_STRING_ITERATOR = $9247de2c126d9e1b$var$REGEXP_STRING + ' Iterator';
var $9247de2c126d9e1b$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $9247de2c126d9e1b$var$getInternalState = $1f4f460c9ddf95ba$exports.getterFor($9247de2c126d9e1b$var$REGEXP_STRING_ITERATOR);
var $9247de2c126d9e1b$var$RegExpPrototype = RegExp.prototype;
var $9247de2c126d9e1b$var$$TypeError = TypeError;
var $9247de2c126d9e1b$var$stringIndexOf = $f587f14398031c29$exports(''.indexOf);
var $9247de2c126d9e1b$var$nativeMatchAll = $f587f14398031c29$exports(''.matchAll);
var $9247de2c126d9e1b$var$WORKS_WITH_NON_GLOBAL_REGEX = !!$9247de2c126d9e1b$var$nativeMatchAll && !$10beeae1ca6f1357$exports(function() {
    $9247de2c126d9e1b$var$nativeMatchAll('a', /./);
});
var $9247de2c126d9e1b$var$$RegExpStringIterator = $5ddd45eb992f42ad$exports(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
    $9247de2c126d9e1b$var$setInternalState(this, {
        type: $9247de2c126d9e1b$var$REGEXP_STRING_ITERATOR,
        regexp: regexp,
        string: string,
        global: $global,
        unicode: fullUnicode,
        done: false
    });
}, $9247de2c126d9e1b$var$REGEXP_STRING, function next() {
    var state = $9247de2c126d9e1b$var$getInternalState(this);
    if (state.done) return $1c0ff8cae751e86d$exports(undefined, true);
    var R = state.regexp;
    var S = state.string;
    var match = $e2b62e79ee126797$exports(R, S);
    if (match === null) {
        state.done = true;
        return $1c0ff8cae751e86d$exports(undefined, true);
    }
    if (state.global) {
        if ($cc1f216aa7e44c59$exports(match[0]) === '') R.lastIndex = $1ccd1cb6286a6040$exports(S, $462654e2015d596f$exports(R.lastIndex), state.unicode);
        return $1c0ff8cae751e86d$exports(match, false);
    }
    state.done = true;
    return $1c0ff8cae751e86d$exports(match, false);
});
var $9247de2c126d9e1b$var$$matchAll = function(string) {
    var R = $c7d52dd23854385b$exports(this);
    var S = $cc1f216aa7e44c59$exports(string);
    var C = $04bcffad7dfc75d7$exports(R, RegExp);
    var flags = $cc1f216aa7e44c59$exports($3b8fa5b93677d7ee$exports(R));
    var matcher, $global, fullUnicode;
    matcher = new C(C === RegExp ? R.source : R, flags);
    $global = !!~$9247de2c126d9e1b$var$stringIndexOf(flags, 'g');
    fullUnicode = !!~$9247de2c126d9e1b$var$stringIndexOf(flags, 'u');
    matcher.lastIndex = $462654e2015d596f$exports(R.lastIndex);
    return new $9247de2c126d9e1b$var$$RegExpStringIterator(matcher, S, $global, fullUnicode);
};
// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$ca66147c52f1c36f$exports({
    target: 'String',
    proto: true,
    forced: $9247de2c126d9e1b$var$WORKS_WITH_NON_GLOBAL_REGEX
}, {
    matchAll: function matchAll(regexp) {
        var O = $8fd6426c81bfca55$exports(this);
        var flags, S, matcher, rx;
        if ($96a478191b33f4fa$exports(regexp)) {
            if ($ee87bb9f21e79629$exports(regexp)) {
                flags = $cc1f216aa7e44c59$exports($8fd6426c81bfca55$exports($3b8fa5b93677d7ee$exports(regexp)));
                if (!~$9247de2c126d9e1b$var$stringIndexOf(flags, 'g')) throw new $9247de2c126d9e1b$var$$TypeError('`.matchAll` does not allow non-global regexes');
            }
            if ($9247de2c126d9e1b$var$WORKS_WITH_NON_GLOBAL_REGEX) return $9247de2c126d9e1b$var$nativeMatchAll(O, regexp);
            matcher = $cb7d485ba5a2e30b$exports(regexp, $9247de2c126d9e1b$var$MATCH_ALL);
            if (matcher === undefined && $0f2d8b335bd97f65$exports && $11458573e8c84e00$exports(regexp) === 'RegExp') matcher = $9247de2c126d9e1b$var$$matchAll;
            if (matcher) return $6dd48e140907213f$exports(matcher, regexp, O);
        } else if ($9247de2c126d9e1b$var$WORKS_WITH_NON_GLOBAL_REGEX) return $9247de2c126d9e1b$var$nativeMatchAll(O, regexp);
        S = $cc1f216aa7e44c59$exports(O);
        rx = new RegExp(regexp, 'g');
        return $0f2d8b335bd97f65$exports ? $6dd48e140907213f$exports($9247de2c126d9e1b$var$$matchAll, rx, S) : rx[$9247de2c126d9e1b$var$MATCH_ALL](S);
    }
});
$0f2d8b335bd97f65$exports || $9247de2c126d9e1b$var$MATCH_ALL in $9247de2c126d9e1b$var$RegExpPrototype || $a5378e288f28a3de$exports($9247de2c126d9e1b$var$RegExpPrototype, $9247de2c126d9e1b$var$MATCH_ALL, $9247de2c126d9e1b$var$$matchAll);




'use strict';
'use strict';













var $fdefc8214673e7b7$var$REPLACE = $2f02eb6a25cfaf08$exports('replace');
var $fdefc8214673e7b7$var$$TypeError = TypeError;
var $fdefc8214673e7b7$var$indexOf = $966303461c07e127$exports(''.indexOf);
var $fdefc8214673e7b7$var$replace = $966303461c07e127$exports(''.replace);
var $fdefc8214673e7b7$var$stringSlice = $966303461c07e127$exports(''.slice);
var $fdefc8214673e7b7$var$max = Math.max;
// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$ca66147c52f1c36f$exports({
    target: 'String',
    proto: true
}, {
    replaceAll: function replaceAll(searchValue, replaceValue) {
        var O = $8fd6426c81bfca55$exports(this);
        var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, position, replacement;
        var endOfLastMatch = 0;
        var result = '';
        if ($96a478191b33f4fa$exports(searchValue)) {
            IS_REG_EXP = $ee87bb9f21e79629$exports(searchValue);
            if (IS_REG_EXP) {
                flags = $cc1f216aa7e44c59$exports($8fd6426c81bfca55$exports($3b8fa5b93677d7ee$exports(searchValue)));
                if (!~$fdefc8214673e7b7$var$indexOf(flags, 'g')) throw new $fdefc8214673e7b7$var$$TypeError('`.replaceAll` does not allow non-global regexes');
            }
            replacer = $cb7d485ba5a2e30b$exports(searchValue, $fdefc8214673e7b7$var$REPLACE);
            if (replacer) return $6dd48e140907213f$exports(replacer, searchValue, O, replaceValue);
            if ($0f2d8b335bd97f65$exports && IS_REG_EXP) return $fdefc8214673e7b7$var$replace($cc1f216aa7e44c59$exports(O), searchValue, replaceValue);
        }
        string = $cc1f216aa7e44c59$exports(O);
        searchString = $cc1f216aa7e44c59$exports(searchValue);
        functionalReplace = $66733457c42e4bfd$exports(replaceValue);
        if (!functionalReplace) replaceValue = $cc1f216aa7e44c59$exports(replaceValue);
        searchLength = searchString.length;
        advanceBy = $fdefc8214673e7b7$var$max(1, searchLength);
        position = $fdefc8214673e7b7$var$indexOf(string, searchString);
        while(position !== -1){
            replacement = functionalReplace ? $cc1f216aa7e44c59$exports(replaceValue(searchString, position, string)) : $771aa137ff641b5d$exports(searchString, string, position, [], undefined, replaceValue);
            result += $fdefc8214673e7b7$var$stringSlice(string, endOfLastMatch, position) + replacement;
            endOfLastMatch = position + searchLength;
            position = position + advanceBy > string.length ? -1 : $fdefc8214673e7b7$var$indexOf(string, searchString, position + advanceBy);
        }
        if (endOfLastMatch < string.length) result += $fdefc8214673e7b7$var$stringSlice(string, endOfLastMatch);
        return result;
    }
});




'use strict';
'use strict';



var $9c2b6f689d1dc6ee$require$defineProperty = $a334f8c362aafa38$export$2d1720544b23b823;

var $9c2b6f689d1dc6ee$require$getOwnPropertyDescriptor = $07309be0dc62a21a$export$2d1720544b23b823;
var $9c2b6f689d1dc6ee$var$Symbol = $1cca30410cf11b53$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$84249ed0242ebe31$exports('dispose');
if ($9c2b6f689d1dc6ee$var$Symbol) {
    var $9c2b6f689d1dc6ee$var$descriptor = $9c2b6f689d1dc6ee$require$getOwnPropertyDescriptor($9c2b6f689d1dc6ee$var$Symbol, 'dispose');
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($9c2b6f689d1dc6ee$var$descriptor.enumerable && $9c2b6f689d1dc6ee$var$descriptor.configurable && $9c2b6f689d1dc6ee$var$descriptor.writable) $9c2b6f689d1dc6ee$require$defineProperty($9c2b6f689d1dc6ee$var$Symbol, 'dispose', {
        value: $9c2b6f689d1dc6ee$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}




'use strict';

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$84249ed0242ebe31$exports('observable');


'use strict';

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$84249ed0242ebe31$exports('patternMatch');


'use strict';

var $eed4e205509c8f0f$exports = {};
'use strict';
var $0f57c32d1e6812ec$exports = {};
'use strict';

// eslint-disable-next-line es/no-weak-map -- safe
var $0f57c32d1e6812ec$var$WeakMapPrototype = WeakMap.prototype;
$0f57c32d1e6812ec$exports = {
    // eslint-disable-next-line es/no-weak-map -- safe
    WeakMap: WeakMap,
    set: $966303461c07e127$exports($0f57c32d1e6812ec$var$WeakMapPrototype.set),
    get: $966303461c07e127$exports($0f57c32d1e6812ec$var$WeakMapPrototype.get),
    has: $966303461c07e127$exports($0f57c32d1e6812ec$var$WeakMapPrototype.has),
    remove: $966303461c07e127$exports($0f57c32d1e6812ec$var$WeakMapPrototype['delete'])
};


var $eed4e205509c8f0f$require$has = $0f57c32d1e6812ec$exports.has;
// Perform ? RequireInternalSlot(M, [[WeakMapData]])
$eed4e205509c8f0f$exports = function(it) {
    $eed4e205509c8f0f$require$has(it);
    return it;
};



var $d6c324df63c69f1e$require$remove = $0f57c32d1e6812ec$exports.remove;
// `WeakMap.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'WeakMap',
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $eed4e205509c8f0f$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $d6c324df63c69f1e$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


'use strict';



// `WeakMap.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
$ca66147c52f1c36f$exports({
    target: 'WeakMap',
    stat: true,
    forced: true
}, {
    from: $75aeba2d80efbe23$exports($0f57c32d1e6812ec$exports.WeakMap, $0f57c32d1e6812ec$exports.set, true)
});


'use strict';



// `WeakMap.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
$ca66147c52f1c36f$exports({
    target: 'WeakMap',
    stat: true,
    forced: true
}, {
    of: $9ec416a1e1fa2338$exports($0f57c32d1e6812ec$exports.WeakMap, $0f57c32d1e6812ec$exports.set, true)
});


'use strict';

var $be55ae342b388b27$exports = {};
'use strict';
var $56abc19daea8964a$exports = {};
'use strict';

// eslint-disable-next-line es/no-weak-set -- safe
var $56abc19daea8964a$var$WeakSetPrototype = WeakSet.prototype;
$56abc19daea8964a$exports = {
    // eslint-disable-next-line es/no-weak-set -- safe
    WeakSet: WeakSet,
    add: $966303461c07e127$exports($56abc19daea8964a$var$WeakSetPrototype.add),
    has: $966303461c07e127$exports($56abc19daea8964a$var$WeakSetPrototype.has),
    remove: $966303461c07e127$exports($56abc19daea8964a$var$WeakSetPrototype['delete'])
};


var $be55ae342b388b27$require$has = $56abc19daea8964a$exports.has;
// Perform ? RequireInternalSlot(M, [[WeakSetData]])
$be55ae342b388b27$exports = function(it) {
    $be55ae342b388b27$require$has(it);
    return it;
};



var $a71e226d1645fb3e$require$add = $56abc19daea8964a$exports.add;
// `WeakSet.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'WeakSet',
    proto: true,
    real: true,
    forced: true
}, {
    addAll: function addAll() {
        var set = $be55ae342b388b27$exports(this);
        for(var k = 0, len = arguments.length; k < len; k++)$a71e226d1645fb3e$require$add(set, arguments[k]);
        return set;
    }
});


'use strict';



var $7b4e73c1eb697c27$require$remove = $56abc19daea8964a$exports.remove;
// `WeakSet.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca66147c52f1c36f$exports({
    target: 'WeakSet',
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $be55ae342b388b27$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $7b4e73c1eb697c27$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


'use strict';



// `WeakSet.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
$ca66147c52f1c36f$exports({
    target: 'WeakSet',
    stat: true,
    forced: true
}, {
    from: $75aeba2d80efbe23$exports($56abc19daea8964a$exports.WeakSet, $56abc19daea8964a$exports.add, false)
});


'use strict';



// `WeakSet.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
$ca66147c52f1c36f$exports({
    target: 'WeakSet',
    stat: true,
    forced: true
}, {
    of: $9ec416a1e1fa2338$exports($56abc19daea8964a$exports.WeakSet, $56abc19daea8964a$exports.add, false)
});


'use strict';

var $73e4174b9249e026$exports = {};
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$73e4174b9249e026$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $604386394475d328$exports = {};
'use strict';

var $604386394475d328$var$classList = $d0a57510c81c1621$exports('span').classList;
var $604386394475d328$var$DOMTokenListPrototype = $604386394475d328$var$classList && $604386394475d328$var$classList.constructor && $604386394475d328$var$classList.constructor.prototype;
$604386394475d328$exports = $604386394475d328$var$DOMTokenListPrototype === Object.prototype ? undefined : $604386394475d328$var$DOMTokenListPrototype;


var $f6583cb1afd54ea2$exports = {};
'use strict';





var $f6583cb1afd54ea2$require$defineProperty = $a334f8c362aafa38$export$2d1720544b23b823;




var $f6583cb1afd54ea2$var$ARRAY_ITERATOR = 'Array Iterator';
var $f6583cb1afd54ea2$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $f6583cb1afd54ea2$var$getInternalState = $1f4f460c9ddf95ba$exports.getterFor($f6583cb1afd54ea2$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$f6583cb1afd54ea2$exports = $b5b00d4f6e90c0b3$exports(Array, 'Array', function(iterated, kind) {
    $f6583cb1afd54ea2$var$setInternalState(this, {
        type: $f6583cb1afd54ea2$var$ARRAY_ITERATOR,
        target: $c76b30b2095e794e$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $f6583cb1afd54ea2$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $1c0ff8cae751e86d$exports(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $1c0ff8cae751e86d$exports(index, false);
        case 'values':
            return $1c0ff8cae751e86d$exports(target[index], false);
    }
    return $1c0ff8cae751e86d$exports([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $f6583cb1afd54ea2$var$values = $45e5c1d92d8f6e7f$exports.Arguments = $45e5c1d92d8f6e7f$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$5fd67419be7a523c$exports('keys');
$5fd67419be7a523c$exports('values');
$5fd67419be7a523c$exports('entries');
// V8 ~ Chrome 45- bug
if (!$0f2d8b335bd97f65$exports && $ce6ba28f66317609$exports && $f6583cb1afd54ea2$var$values.name !== 'values') try {
    $f6583cb1afd54ea2$require$defineProperty($f6583cb1afd54ea2$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}





var $f71950a550bf77f6$var$ITERATOR = $2f02eb6a25cfaf08$exports('iterator');
var $f71950a550bf77f6$var$ArrayValues = $f6583cb1afd54ea2$exports.values;
var $f71950a550bf77f6$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$f71950a550bf77f6$var$ITERATOR] !== $f71950a550bf77f6$var$ArrayValues) try {
            $b4e3b093ae5606fa$exports(CollectionPrototype, $f71950a550bf77f6$var$ITERATOR, $f71950a550bf77f6$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$f71950a550bf77f6$var$ITERATOR] = $f71950a550bf77f6$var$ArrayValues;
        }
        $7fe02f462050b03b$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($73e4174b9249e026$exports[COLLECTION_NAME]) for(var METHOD_NAME in $f6583cb1afd54ea2$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $f6583cb1afd54ea2$exports[METHOD_NAME]) try {
                $b4e3b093ae5606fa$exports(CollectionPrototype, METHOD_NAME, $f6583cb1afd54ea2$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $f6583cb1afd54ea2$exports[METHOD_NAME];
            }
        }
    }
};
for(var $f71950a550bf77f6$var$COLLECTION_NAME in $73e4174b9249e026$exports)$f71950a550bf77f6$var$handlePrototype($1cca30410cf11b53$exports[$f71950a550bf77f6$var$COLLECTION_NAME] && $1cca30410cf11b53$exports[$f71950a550bf77f6$var$COLLECTION_NAME].prototype, $f71950a550bf77f6$var$COLLECTION_NAME);
$f71950a550bf77f6$var$handlePrototype($604386394475d328$exports, 'DOMTokenList');


'use strict';
'use strict';


var $b7785baf2bb732e4$exports = {};
'use strict';









var $f59d8e2e21363a88$exports = {};
'use strict';
var $f59d8e2e21363a88$var$$TypeError = TypeError;
$f59d8e2e21363a88$exports = function(passed, required) {
    if (passed < required) throw new $f59d8e2e21363a88$var$$TypeError('Not enough arguments');
    return passed;
};


var $9dc0c03c8bb717a0$exports = {};
'use strict';

// eslint-disable-next-line redos/no-vulnerable -- safe
$9dc0c03c8bb717a0$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($bcca79ca01f4b5fb$exports);


var $823527c1fa6499d5$exports = {};
'use strict';

$823527c1fa6499d5$exports = $fa54dc94d54c733d$exports === 'NODE';


var $b7785baf2bb732e4$var$set = $1cca30410cf11b53$exports.setImmediate;
var $b7785baf2bb732e4$var$clear = $1cca30410cf11b53$exports.clearImmediate;
var $b7785baf2bb732e4$var$process = $1cca30410cf11b53$exports.process;
var $b7785baf2bb732e4$var$Dispatch = $1cca30410cf11b53$exports.Dispatch;
var $b7785baf2bb732e4$var$Function = $1cca30410cf11b53$exports.Function;
var $b7785baf2bb732e4$var$MessageChannel = $1cca30410cf11b53$exports.MessageChannel;
var $b7785baf2bb732e4$var$String = $1cca30410cf11b53$exports.String;
var $b7785baf2bb732e4$var$counter = 0;
var $b7785baf2bb732e4$var$queue = {};
var $b7785baf2bb732e4$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $b7785baf2bb732e4$var$$location, $b7785baf2bb732e4$var$defer, $b7785baf2bb732e4$var$channel, $b7785baf2bb732e4$var$port;
$10beeae1ca6f1357$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $b7785baf2bb732e4$var$$location = $1cca30410cf11b53$exports.location;
});
var $b7785baf2bb732e4$var$run = function(id) {
    if ($1d9d3902a50a2fcd$exports($b7785baf2bb732e4$var$queue, id)) {
        var fn = $b7785baf2bb732e4$var$queue[id];
        delete $b7785baf2bb732e4$var$queue[id];
        fn();
    }
};
var $b7785baf2bb732e4$var$runner = function(id) {
    return function() {
        $b7785baf2bb732e4$var$run(id);
    };
};
var $b7785baf2bb732e4$var$eventListener = function(event) {
    $b7785baf2bb732e4$var$run(event.data);
};
var $b7785baf2bb732e4$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $1cca30410cf11b53$exports.postMessage($b7785baf2bb732e4$var$String(id), $b7785baf2bb732e4$var$$location.protocol + '//' + $b7785baf2bb732e4$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$b7785baf2bb732e4$var$set || !$b7785baf2bb732e4$var$clear) {
    $b7785baf2bb732e4$var$set = function setImmediate(handler) {
        $f59d8e2e21363a88$exports(arguments.length, 1);
        var fn = $66733457c42e4bfd$exports(handler) ? handler : $b7785baf2bb732e4$var$Function(handler);
        var args = $7720efb2736da874$exports(arguments, 1);
        $b7785baf2bb732e4$var$queue[++$b7785baf2bb732e4$var$counter] = function() {
            $36ddd4c4a517e2d6$exports(fn, undefined, args);
        };
        $b7785baf2bb732e4$var$defer($b7785baf2bb732e4$var$counter);
        return $b7785baf2bb732e4$var$counter;
    };
    $b7785baf2bb732e4$var$clear = function clearImmediate(id) {
        delete $b7785baf2bb732e4$var$queue[id];
    };
    // Node.js 0.8-
    if ($823527c1fa6499d5$exports) $b7785baf2bb732e4$var$defer = function(id) {
        $b7785baf2bb732e4$var$process.nextTick($b7785baf2bb732e4$var$runner(id));
    };
    else if ($b7785baf2bb732e4$var$Dispatch && $b7785baf2bb732e4$var$Dispatch.now) $b7785baf2bb732e4$var$defer = function(id) {
        $b7785baf2bb732e4$var$Dispatch.now($b7785baf2bb732e4$var$runner(id));
    };
    else if ($b7785baf2bb732e4$var$MessageChannel && !$9dc0c03c8bb717a0$exports) {
        $b7785baf2bb732e4$var$channel = new $b7785baf2bb732e4$var$MessageChannel();
        $b7785baf2bb732e4$var$port = $b7785baf2bb732e4$var$channel.port2;
        $b7785baf2bb732e4$var$channel.port1.onmessage = $b7785baf2bb732e4$var$eventListener;
        $b7785baf2bb732e4$var$defer = $2d52694feff5f895$exports($b7785baf2bb732e4$var$port.postMessage, $b7785baf2bb732e4$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($1cca30410cf11b53$exports.addEventListener && $66733457c42e4bfd$exports($1cca30410cf11b53$exports.postMessage) && !$1cca30410cf11b53$exports.importScripts && $b7785baf2bb732e4$var$$location && $b7785baf2bb732e4$var$$location.protocol !== 'file:' && !$10beeae1ca6f1357$exports($b7785baf2bb732e4$var$globalPostMessageDefer)) {
        $b7785baf2bb732e4$var$defer = $b7785baf2bb732e4$var$globalPostMessageDefer;
        $1cca30410cf11b53$exports.addEventListener('message', $b7785baf2bb732e4$var$eventListener, false);
    // IE8-
    } else if ($b7785baf2bb732e4$var$ONREADYSTATECHANGE in $d0a57510c81c1621$exports('script')) $b7785baf2bb732e4$var$defer = function(id) {
        $797eb120e966f699$exports.appendChild($d0a57510c81c1621$exports('script'))[$b7785baf2bb732e4$var$ONREADYSTATECHANGE] = function() {
            $797eb120e966f699$exports.removeChild(this);
            $b7785baf2bb732e4$var$run(id);
        };
    };
    else $b7785baf2bb732e4$var$defer = function(id) {
        setTimeout($b7785baf2bb732e4$var$runner(id), 0);
    };
}
$b7785baf2bb732e4$exports = {
    set: $b7785baf2bb732e4$var$set,
    clear: $b7785baf2bb732e4$var$clear
};


var $db3041daba1bd95a$require$clearImmediate = $b7785baf2bb732e4$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$ca66147c52f1c36f$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $1cca30410cf11b53$exports.clearImmediate !== $db3041daba1bd95a$require$clearImmediate
}, {
    clearImmediate: $db3041daba1bd95a$require$clearImmediate
});


'use strict';



var $5f9c58f8d1c8f03a$require$setTask = $b7785baf2bb732e4$exports.set;
var $d8b657f8d50b1a98$exports = {};
'use strict';







var $d8b657f8d50b1a98$var$Function = $1cca30410cf11b53$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $d8b657f8d50b1a98$var$WRAP = /MSIE .\./.test($bcca79ca01f4b5fb$exports) || $fa54dc94d54c733d$exports === 'BUN' && function() {
    var version = $1cca30410cf11b53$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$d8b657f8d50b1a98$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $d8b657f8d50b1a98$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $f59d8e2e21363a88$exports(arguments.length, 1) > firstParamIndex;
        var fn = $66733457c42e4bfd$exports(handler) ? handler : $d8b657f8d50b1a98$var$Function(handler);
        var params = boundArgs ? $7720efb2736da874$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $36ddd4c4a517e2d6$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $5f9c58f8d1c8f03a$var$setImmediate = $1cca30410cf11b53$exports.setImmediate ? $d8b657f8d50b1a98$exports($5f9c58f8d1c8f03a$require$setTask, false) : $5f9c58f8d1c8f03a$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$ca66147c52f1c36f$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $1cca30410cf11b53$exports.setImmediate !== $5f9c58f8d1c8f03a$var$setImmediate
}, {
    setImmediate: $5f9c58f8d1c8f03a$var$setImmediate
});




'use strict';


var $48125fc58c212402$exports = {};
'use strict';

var $44dff64a2558bec6$exports = {};
'use strict';


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $44dff64a2558bec6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
$44dff64a2558bec6$exports = function(name) {
    if (!$ce6ba28f66317609$exports) return $1cca30410cf11b53$exports[name];
    var descriptor = $44dff64a2558bec6$var$getOwnPropertyDescriptor($1cca30410cf11b53$exports, name);
    return descriptor && descriptor.value;
};




var $48125fc58c212402$require$macrotask = $b7785baf2bb732e4$exports.set;
var $7a52a0b8fa621700$exports = {};
'use strict';
var $7a52a0b8fa621700$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$7a52a0b8fa621700$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
$7a52a0b8fa621700$exports = $7a52a0b8fa621700$var$Queue;



var $753b7d12b7d358fb$exports = {};
'use strict';

$753b7d12b7d358fb$exports = /ipad|iphone|ipod/i.test($bcca79ca01f4b5fb$exports) && typeof Pebble != 'undefined';


var $f219467c96ac2f26$exports = {};
'use strict';

$f219467c96ac2f26$exports = /web0s(?!.*chrome)/i.test($bcca79ca01f4b5fb$exports);



var $48125fc58c212402$var$MutationObserver = $1cca30410cf11b53$exports.MutationObserver || $1cca30410cf11b53$exports.WebKitMutationObserver;
var $48125fc58c212402$var$document = $1cca30410cf11b53$exports.document;
var $48125fc58c212402$var$process = $1cca30410cf11b53$exports.process;
var $48125fc58c212402$var$Promise = $1cca30410cf11b53$exports.Promise;
var $48125fc58c212402$var$microtask = $44dff64a2558bec6$exports('queueMicrotask');
var $48125fc58c212402$var$notify, $48125fc58c212402$var$toggle, $48125fc58c212402$var$node, $48125fc58c212402$var$promise, $48125fc58c212402$var$then;
// modern engines have queueMicrotask method
if (!$48125fc58c212402$var$microtask) {
    var $48125fc58c212402$var$queue = new $7a52a0b8fa621700$exports();
    var $48125fc58c212402$var$flush = function() {
        var parent, fn;
        if ($823527c1fa6499d5$exports && (parent = $48125fc58c212402$var$process.domain)) parent.exit();
        while(fn = $48125fc58c212402$var$queue.get())try {
            fn();
        } catch (error) {
            if ($48125fc58c212402$var$queue.head) $48125fc58c212402$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$9dc0c03c8bb717a0$exports && !$823527c1fa6499d5$exports && !$f219467c96ac2f26$exports && $48125fc58c212402$var$MutationObserver && $48125fc58c212402$var$document) {
        $48125fc58c212402$var$toggle = true;
        $48125fc58c212402$var$node = $48125fc58c212402$var$document.createTextNode('');
        new $48125fc58c212402$var$MutationObserver($48125fc58c212402$var$flush).observe($48125fc58c212402$var$node, {
            characterData: true
        });
        $48125fc58c212402$var$notify = function() {
            $48125fc58c212402$var$node.data = $48125fc58c212402$var$toggle = !$48125fc58c212402$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$753b7d12b7d358fb$exports && $48125fc58c212402$var$Promise && $48125fc58c212402$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $48125fc58c212402$var$promise = $48125fc58c212402$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $48125fc58c212402$var$promise.constructor = $48125fc58c212402$var$Promise;
        $48125fc58c212402$var$then = $2d52694feff5f895$exports($48125fc58c212402$var$promise.then, $48125fc58c212402$var$promise);
        $48125fc58c212402$var$notify = function() {
            $48125fc58c212402$var$then($48125fc58c212402$var$flush);
        };
    // Node.js without promises
    } else if ($823527c1fa6499d5$exports) $48125fc58c212402$var$notify = function() {
        $48125fc58c212402$var$process.nextTick($48125fc58c212402$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $48125fc58c212402$require$macrotask = $2d52694feff5f895$exports($48125fc58c212402$require$macrotask, $1cca30410cf11b53$exports);
        $48125fc58c212402$var$notify = function() {
            $48125fc58c212402$require$macrotask($48125fc58c212402$var$flush);
        };
    }
    $48125fc58c212402$var$microtask = function(fn) {
        if (!$48125fc58c212402$var$queue.head) $48125fc58c212402$var$notify();
        $48125fc58c212402$var$queue.add(fn);
    };
}
$48125fc58c212402$exports = $48125fc58c212402$var$microtask;






// Bun ~ 1.0.30 bug
// https://github.com/oven-sh/bun/issues/9249
var $2786e91e6ccd37bf$var$WRONG_ARITY = $10beeae1ca6f1357$exports(function() {
    // getOwnPropertyDescriptor for prevent experimental warning in Node 11
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return $ce6ba28f66317609$exports && Object.getOwnPropertyDescriptor($1cca30410cf11b53$exports, 'queueMicrotask').value.length !== 1;
});
// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$ca66147c52f1c36f$exports({
    global: true,
    enumerable: true,
    dontCallGetSet: true,
    forced: $2786e91e6ccd37bf$var$WRONG_ARITY
}, {
    queueMicrotask: function queueMicrotask(fn) {
        $f59d8e2e21363a88$exports(arguments.length, 1);
        $48125fc58c212402$exports($ac451d11dfa909df$exports(fn));
    }
});


'use strict';
'use strict';
'use strict';

var $9d398fcedab1c931$require$charAt = $63ce28df052c8c19$exports.charAt;




var $9d398fcedab1c931$var$STRING_ITERATOR = 'String Iterator';
var $9d398fcedab1c931$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $9d398fcedab1c931$var$getInternalState = $1f4f460c9ddf95ba$exports.getterFor($9d398fcedab1c931$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$b5b00d4f6e90c0b3$exports(String, 'String', function(iterated) {
    $9d398fcedab1c931$var$setInternalState(this, {
        type: $9d398fcedab1c931$var$STRING_ITERATOR,
        string: $cc1f216aa7e44c59$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $9d398fcedab1c931$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $1c0ff8cae751e86d$exports(undefined, true);
    point = $9d398fcedab1c931$require$charAt(string, index);
    state.index += point.length;
    return $1c0ff8cae751e86d$exports(point, false);
});




var $28c2cba1e1035c76$exports = {};
'use strict';




var $28c2cba1e1035c76$var$ITERATOR = $2f02eb6a25cfaf08$exports('iterator');
$28c2cba1e1035c76$exports = !$10beeae1ca6f1357$exports(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL('b?a=1&b=2&c=3', 'https://a');
    var params = url.searchParams;
    var params2 = new URLSearchParams('a=1&a=2&b=3');
    var result = '';
    url.pathname = 'c%20d';
    params.forEach(function(value, key) {
        params['delete']('b');
        result += key + value;
    });
    params2['delete']('a', 2);
    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    params2['delete']('b', undefined);
    return $0f2d8b335bd97f65$exports && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')) || !params.size && ($0f2d8b335bd97f65$exports || !$ce6ba28f66317609$exports) || !params.sort || url.href !== 'https://a/c%20d?a=1&c=3' || params.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !params[$28c2cba1e1035c76$var$ITERATOR] || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' || new URL("https://\u0442\u0435\u0441\u0442").host !== 'xn--e1aybc' || new URL("https://a#\u0431").hash !== '#%D0%B1' || result !== 'a1c3' || new URL('https://x', undefined).host !== 'x';
});









var $c38778d686268f09$exports = {};
'use strict';









// eslint-disable-next-line es/no-object-assign -- safe
var $c38778d686268f09$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $c38778d686268f09$var$defineProperty = Object.defineProperty;
var $c38778d686268f09$var$concat = $966303461c07e127$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$c38778d686268f09$exports = !$c38778d686268f09$var$$assign || $10beeae1ca6f1357$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($ce6ba28f66317609$exports && $c38778d686268f09$var$$assign({
        b: 1
    }, $c38778d686268f09$var$$assign($c38778d686268f09$var$defineProperty({}, 'a', {
        enumerable: true,
        get: function() {
            $c38778d686268f09$var$defineProperty(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $c38778d686268f09$var$$assign({}, A)[symbol] !== 7 || $1093d14884b34661$exports($c38778d686268f09$var$$assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = $3281447d22a40e21$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $93f684b8fcf2e660$export$2d1720544b23b823;
    var propertyIsEnumerable = $d83fa12b384925d6$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $2ca02031c916d962$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $c38778d686268f09$var$concat($1093d14884b34661$exports(S), getOwnPropertySymbols(S)) : $1093d14884b34661$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$ce6ba28f66317609$exports || $6dd48e140907213f$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $c38778d686268f09$var$$assign;


var $1491789629013d78$exports = {};
'use strict';



var $c642037f58a4a019$exports = {};
'use strict';


// call something on iterator step with safe closing on error
$c642037f58a4a019$exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($c7d52dd23854385b$exports(value)[0], value[1]) : fn(value);
    } catch (error) {
        $970ad60dab2ac818$exports(iterator, 'throw', error);
    }
};








var $1491789629013d78$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
$1491789629013d78$exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $3281447d22a40e21$exports(arrayLike);
    var IS_CONSTRUCTOR = $d81cf5a9f1de1452$exports(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $2d52694feff5f895$exports(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $44917bb2b551135b$exports(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $1491789629013d78$var$$Array && $7da3fc42db2cd048$exports(iteratorMethod))) {
        result = IS_CONSTRUCTOR ? new this() : [];
        iterator = $f9d5016d77a62d39$exports(O, iteratorMethod);
        next = iterator.next;
        for(; !(step = $6dd48e140907213f$exports(next, iterator)).done; index++){
            value = mapping ? $c642037f58a4a019$exports(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $6aba7e79cb797392$exports(result, index, value);
        }
    } else {
        length = $ffd1deb5f4ba5f93$exports(O);
        result = IS_CONSTRUCTOR ? new this(length) : $1491789629013d78$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $6aba7e79cb797392$exports(result, index, value);
        }
    }
    result.length = index;
    return result;
};




var $af392317059ba6ca$require$codeAt = $63ce28df052c8c19$exports.codeAt;
var $b02276690096b48b$exports = {};
'use strict';

var $b02276690096b48b$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var $b02276690096b48b$var$base = 36;
var $b02276690096b48b$var$tMin = 1;
var $b02276690096b48b$var$tMax = 26;
var $b02276690096b48b$var$skew = 38;
var $b02276690096b48b$var$damp = 700;
var $b02276690096b48b$var$initialBias = 72;
var $b02276690096b48b$var$initialN = 128; // 0x80
var $b02276690096b48b$var$delimiter = '-'; // '\x2D'
var $b02276690096b48b$var$regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var $b02276690096b48b$var$regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var $b02276690096b48b$var$OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var $b02276690096b48b$var$baseMinusTMin = $b02276690096b48b$var$base - $b02276690096b48b$var$tMin;
var $b02276690096b48b$var$$RangeError = RangeError;
var $b02276690096b48b$var$exec = $966303461c07e127$exports($b02276690096b48b$var$regexSeparators.exec);
var $b02276690096b48b$var$floor = Math.floor;
var $b02276690096b48b$var$fromCharCode = String.fromCharCode;
var $b02276690096b48b$var$charCodeAt = $966303461c07e127$exports(''.charCodeAt);
var $b02276690096b48b$var$join = $966303461c07e127$exports([].join);
var $b02276690096b48b$var$push = $966303461c07e127$exports([].push);
var $b02276690096b48b$var$replace = $966303461c07e127$exports(''.replace);
var $b02276690096b48b$var$split = $966303461c07e127$exports(''.split);
var $b02276690096b48b$var$toLowerCase = $966303461c07e127$exports(''.toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var $b02276690096b48b$var$ucs2decode = function(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = $b02276690096b48b$var$charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = $b02276690096b48b$var$charCodeAt(string, counter++);
            if ((extra & 0xFC00) === 0xDC00) $b02276690096b48b$var$push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                $b02276690096b48b$var$push(output, value);
                counter--;
            }
        } else $b02276690096b48b$var$push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var $b02276690096b48b$var$digitToBasic = function(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var $b02276690096b48b$var$adapt = function(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $b02276690096b48b$var$floor(delta / $b02276690096b48b$var$damp) : delta >> 1;
    delta += $b02276690096b48b$var$floor(delta / numPoints);
    while(delta > $b02276690096b48b$var$baseMinusTMin * $b02276690096b48b$var$tMax >> 1){
        delta = $b02276690096b48b$var$floor(delta / $b02276690096b48b$var$baseMinusTMin);
        k += $b02276690096b48b$var$base;
    }
    return $b02276690096b48b$var$floor(k + ($b02276690096b48b$var$baseMinusTMin + 1) * delta / (delta + $b02276690096b48b$var$skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var $b02276690096b48b$var$encode = function(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $b02276690096b48b$var$ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = $b02276690096b48b$var$initialN;
    var delta = 0;
    var bias = $b02276690096b48b$var$initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) $b02276690096b48b$var$push(output, $b02276690096b48b$var$fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) $b02276690096b48b$var$push(output, $b02276690096b48b$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = $b02276690096b48b$var$maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $b02276690096b48b$var$floor(($b02276690096b48b$var$maxInt - delta) / handledCPCountPlusOne)) throw new $b02276690096b48b$var$$RangeError($b02276690096b48b$var$OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > $b02276690096b48b$var$maxInt) throw new $b02276690096b48b$var$$RangeError($b02276690096b48b$var$OVERFLOW_ERROR);
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = $b02276690096b48b$var$base;
                while(true){
                    var t = k <= bias ? $b02276690096b48b$var$tMin : k >= bias + $b02276690096b48b$var$tMax ? $b02276690096b48b$var$tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = $b02276690096b48b$var$base - t;
                    $b02276690096b48b$var$push(output, $b02276690096b48b$var$fromCharCode($b02276690096b48b$var$digitToBasic(t + qMinusT % baseMinusT)));
                    q = $b02276690096b48b$var$floor(qMinusT / baseMinusT);
                    k += $b02276690096b48b$var$base;
                }
                $b02276690096b48b$var$push(output, $b02276690096b48b$var$fromCharCode($b02276690096b48b$var$digitToBasic(q)));
                bias = $b02276690096b48b$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return $b02276690096b48b$var$join(output, '');
};
$b02276690096b48b$exports = function(input) {
    var encoded = [];
    var labels = $b02276690096b48b$var$split($b02276690096b48b$var$replace($b02276690096b48b$var$toLowerCase(input), $b02276690096b48b$var$regexSeparators, '\u002E'), '.');
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        $b02276690096b48b$var$push(encoded, $b02276690096b48b$var$exec($b02276690096b48b$var$regexNonASCII, label) ? 'xn--' + $b02276690096b48b$var$encode(label) : label);
    }
    return $b02276690096b48b$var$join(encoded, '.');
};





var $fa9d7c1adad917ec$exports = {};
'use strict';

'use strict';



var $df284da2d164b1f6$var$$RangeError = RangeError;
var $df284da2d164b1f6$var$fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $df284da2d164b1f6$var$$fromCodePoint = String.fromCodePoint;
var $df284da2d164b1f6$var$join = $966303461c07e127$exports([].join);
// length should be 1, old FF problem
var $df284da2d164b1f6$var$INCORRECT_LENGTH = !!$df284da2d164b1f6$var$$fromCodePoint && $df284da2d164b1f6$var$$fromCodePoint.length !== 1;
// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$ca66147c52f1c36f$exports({
    target: 'String',
    stat: true,
    arity: 1,
    forced: $df284da2d164b1f6$var$INCORRECT_LENGTH
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function fromCodePoint(x) {
        var elements = [];
        var length = arguments.length;
        var i = 0;
        var code;
        while(length > i){
            code = +arguments[i++];
            if ($82ea8bcccff50613$exports(code, 0x10FFFF) !== code) throw new $df284da2d164b1f6$var$$RangeError(code + ' is not a valid code point');
            elements[i] = code < 0x10000 ? $df284da2d164b1f6$var$fromCharCode(code) : $df284da2d164b1f6$var$fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
        }
        return $df284da2d164b1f6$var$join(elements, '');
    }
});
































var $fa9d7c1adad917ec$var$ITERATOR = $2f02eb6a25cfaf08$exports('iterator');
var $fa9d7c1adad917ec$var$URL_SEARCH_PARAMS = 'URLSearchParams';
var $fa9d7c1adad917ec$var$URL_SEARCH_PARAMS_ITERATOR = $fa9d7c1adad917ec$var$URL_SEARCH_PARAMS + 'Iterator';
var $fa9d7c1adad917ec$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $fa9d7c1adad917ec$var$getInternalParamsState = $1f4f460c9ddf95ba$exports.getterFor($fa9d7c1adad917ec$var$URL_SEARCH_PARAMS);
var $fa9d7c1adad917ec$var$getInternalIteratorState = $1f4f460c9ddf95ba$exports.getterFor($fa9d7c1adad917ec$var$URL_SEARCH_PARAMS_ITERATOR);
var $fa9d7c1adad917ec$var$nativeFetch = $44dff64a2558bec6$exports('fetch');
var $fa9d7c1adad917ec$var$NativeRequest = $44dff64a2558bec6$exports('Request');
var $fa9d7c1adad917ec$var$Headers = $44dff64a2558bec6$exports('Headers');
var $fa9d7c1adad917ec$var$RequestPrototype = $fa9d7c1adad917ec$var$NativeRequest && $fa9d7c1adad917ec$var$NativeRequest.prototype;
var $fa9d7c1adad917ec$var$HeadersPrototype = $fa9d7c1adad917ec$var$Headers && $fa9d7c1adad917ec$var$Headers.prototype;
var $fa9d7c1adad917ec$var$TypeError = $1cca30410cf11b53$exports.TypeError;
var $fa9d7c1adad917ec$var$encodeURIComponent = $1cca30410cf11b53$exports.encodeURIComponent;
var $fa9d7c1adad917ec$var$fromCharCode = String.fromCharCode;
var $fa9d7c1adad917ec$var$fromCodePoint = $a262b772204f9131$exports('String', 'fromCodePoint');
var $fa9d7c1adad917ec$var$$parseInt = parseInt;
var $fa9d7c1adad917ec$var$charAt = $966303461c07e127$exports(''.charAt);
var $fa9d7c1adad917ec$var$join = $966303461c07e127$exports([].join);
var $fa9d7c1adad917ec$var$push = $966303461c07e127$exports([].push);
var $fa9d7c1adad917ec$var$replace = $966303461c07e127$exports(''.replace);
var $fa9d7c1adad917ec$var$shift = $966303461c07e127$exports([].shift);
var $fa9d7c1adad917ec$var$splice = $966303461c07e127$exports([].splice);
var $fa9d7c1adad917ec$var$split = $966303461c07e127$exports(''.split);
var $fa9d7c1adad917ec$var$stringSlice = $966303461c07e127$exports(''.slice);
var $fa9d7c1adad917ec$var$exec = $966303461c07e127$exports(/./.exec);
var $fa9d7c1adad917ec$var$plus = /\+/g;
var $fa9d7c1adad917ec$var$FALLBACK_REPLACER = '\uFFFD';
var $fa9d7c1adad917ec$var$VALID_HEX = /^[0-9a-f]+$/i;
var $fa9d7c1adad917ec$var$parseHexOctet = function(string, start) {
    var substr = $fa9d7c1adad917ec$var$stringSlice(string, start, start + 2);
    if (!$fa9d7c1adad917ec$var$exec($fa9d7c1adad917ec$var$VALID_HEX, substr)) return NaN;
    return $fa9d7c1adad917ec$var$$parseInt(substr, 16);
};
var $fa9d7c1adad917ec$var$getLeadingOnes = function(octet) {
    var count = 0;
    for(var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1)count++;
    return count;
};
var $fa9d7c1adad917ec$var$utf8Decode = function(octets) {
    var codePoint = null;
    switch(octets.length){
        case 1:
            codePoint = octets[0];
            break;
        case 2:
            codePoint = (octets[0] & 0x1F) << 6 | octets[1] & 0x3F;
            break;
        case 3:
            codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | octets[2] & 0x3F;
            break;
        case 4:
            codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | octets[3] & 0x3F;
            break;
    }
    return codePoint > 0x10FFFF ? null : codePoint;
};
var $fa9d7c1adad917ec$var$decode = function(input) {
    input = $fa9d7c1adad917ec$var$replace(input, $fa9d7c1adad917ec$var$plus, ' ');
    var length = input.length;
    var result = '';
    var i = 0;
    while(i < length){
        var decodedChar = $fa9d7c1adad917ec$var$charAt(input, i);
        if (decodedChar === '%') {
            if ($fa9d7c1adad917ec$var$charAt(input, i + 1) === '%' || i + 3 > length) {
                result += '%';
                i++;
                continue;
            }
            var octet = $fa9d7c1adad917ec$var$parseHexOctet(input, i + 1);
            // eslint-disable-next-line no-self-compare -- NaN check
            if (octet !== octet) {
                result += decodedChar;
                i++;
                continue;
            }
            i += 2;
            var byteSequenceLength = $fa9d7c1adad917ec$var$getLeadingOnes(octet);
            if (byteSequenceLength === 0) decodedChar = $fa9d7c1adad917ec$var$fromCharCode(octet);
            else {
                if (byteSequenceLength === 1 || byteSequenceLength > 4) {
                    result += $fa9d7c1adad917ec$var$FALLBACK_REPLACER;
                    i++;
                    continue;
                }
                var octets = [
                    octet
                ];
                var sequenceIndex = 1;
                while(sequenceIndex < byteSequenceLength){
                    i++;
                    if (i + 3 > length || $fa9d7c1adad917ec$var$charAt(input, i) !== '%') break;
                    var nextByte = $fa9d7c1adad917ec$var$parseHexOctet(input, i + 1);
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (nextByte !== nextByte) {
                        i += 3;
                        break;
                    }
                    if (nextByte > 191 || nextByte < 128) break;
                    $fa9d7c1adad917ec$var$push(octets, nextByte);
                    i += 2;
                    sequenceIndex++;
                }
                if (octets.length !== byteSequenceLength) {
                    result += $fa9d7c1adad917ec$var$FALLBACK_REPLACER;
                    continue;
                }
                var codePoint = $fa9d7c1adad917ec$var$utf8Decode(octets);
                if (codePoint === null) result += $fa9d7c1adad917ec$var$FALLBACK_REPLACER;
                else decodedChar = $fa9d7c1adad917ec$var$fromCodePoint(codePoint);
            }
        }
        result += decodedChar;
        i++;
    }
    return result;
};
var $fa9d7c1adad917ec$var$find = /[!'()~]|%20/g;
var $fa9d7c1adad917ec$var$replacements = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+'
};
var $fa9d7c1adad917ec$var$replacer = function(match) {
    return $fa9d7c1adad917ec$var$replacements[match];
};
var $fa9d7c1adad917ec$var$serialize = function(it) {
    return $fa9d7c1adad917ec$var$replace($fa9d7c1adad917ec$var$encodeURIComponent(it), $fa9d7c1adad917ec$var$find, $fa9d7c1adad917ec$var$replacer);
};
var $fa9d7c1adad917ec$var$URLSearchParamsIterator = $5ddd45eb992f42ad$exports(function Iterator(params, kind) {
    $fa9d7c1adad917ec$var$setInternalState(this, {
        type: $fa9d7c1adad917ec$var$URL_SEARCH_PARAMS_ITERATOR,
        target: $fa9d7c1adad917ec$var$getInternalParamsState(params).entries,
        index: 0,
        kind: kind
    });
}, $fa9d7c1adad917ec$var$URL_SEARCH_PARAMS, function next() {
    var state = $fa9d7c1adad917ec$var$getInternalIteratorState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $1c0ff8cae751e86d$exports(undefined, true);
    }
    var entry = target[index];
    switch(state.kind){
        case 'keys':
            return $1c0ff8cae751e86d$exports(entry.key, false);
        case 'values':
            return $1c0ff8cae751e86d$exports(entry.value, false);
    }
    return $1c0ff8cae751e86d$exports([
        entry.key,
        entry.value
    ], false);
}, true);
var $fa9d7c1adad917ec$var$URLSearchParamsState = function(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if ($96a478191b33f4fa$exports(init)) this.parseObject(init);
        else this.parseQuery(typeof init == 'string' ? $fa9d7c1adad917ec$var$charAt(init, 0) === '?' ? $fa9d7c1adad917ec$var$stringSlice(init, 1) : init : $cc1f216aa7e44c59$exports(init));
    }
};
$fa9d7c1adad917ec$var$URLSearchParamsState.prototype = {
    type: $fa9d7c1adad917ec$var$URL_SEARCH_PARAMS,
    bindURL: function(url) {
        this.url = url;
        this.update();
    },
    parseObject: function(object) {
        var entries = this.entries;
        var iteratorMethod = $44917bb2b551135b$exports(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = $f9d5016d77a62d39$exports(object, iteratorMethod);
            next = iterator.next;
            while(!(step = $6dd48e140907213f$exports(next, iterator)).done){
                entryIterator = $f9d5016d77a62d39$exports($c7d52dd23854385b$exports(step.value));
                entryNext = entryIterator.next;
                if ((first = $6dd48e140907213f$exports(entryNext, entryIterator)).done || (second = $6dd48e140907213f$exports(entryNext, entryIterator)).done || !$6dd48e140907213f$exports(entryNext, entryIterator).done) throw new $fa9d7c1adad917ec$var$TypeError('Expected sequence with length 2');
                $fa9d7c1adad917ec$var$push(entries, {
                    key: $cc1f216aa7e44c59$exports(first.value),
                    value: $cc1f216aa7e44c59$exports(second.value)
                });
            }
        } else for(var key in object)if ($1d9d3902a50a2fcd$exports(object, key)) $fa9d7c1adad917ec$var$push(entries, {
            key: key,
            value: $cc1f216aa7e44c59$exports(object[key])
        });
    },
    parseQuery: function(query) {
        if (query) {
            var entries = this.entries;
            var attributes = $fa9d7c1adad917ec$var$split(query, '&');
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = $fa9d7c1adad917ec$var$split(attribute, '=');
                    $fa9d7c1adad917ec$var$push(entries, {
                        key: $fa9d7c1adad917ec$var$decode($fa9d7c1adad917ec$var$shift(entry)),
                        value: $fa9d7c1adad917ec$var$decode($fa9d7c1adad917ec$var$join(entry, '='))
                    });
                }
            }
        }
    },
    serialize: function() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            $fa9d7c1adad917ec$var$push(result, $fa9d7c1adad917ec$var$serialize(entry.key) + '=' + $fa9d7c1adad917ec$var$serialize(entry.value));
        }
        return $fa9d7c1adad917ec$var$join(result, '&');
    },
    update: function() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var $fa9d7c1adad917ec$var$URLSearchParamsConstructor = function URLSearchParams() {
    $e75aa794ae249210$exports(this, $fa9d7c1adad917ec$var$URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var state = $fa9d7c1adad917ec$var$setInternalState(this, new $fa9d7c1adad917ec$var$URLSearchParamsState(init));
    if (!$ce6ba28f66317609$exports) this.size = state.entries.length;
};
var $fa9d7c1adad917ec$var$URLSearchParamsPrototype = $fa9d7c1adad917ec$var$URLSearchParamsConstructor.prototype;
$6ca4ef67338bdded$exports($fa9d7c1adad917ec$var$URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        var state = $fa9d7c1adad917ec$var$getInternalParamsState(this);
        $f59d8e2e21363a88$exports(arguments.length, 2);
        $fa9d7c1adad917ec$var$push(state.entries, {
            key: $cc1f216aa7e44c59$exports(name),
            value: $cc1f216aa7e44c59$exports(value)
        });
        if (!$ce6ba28f66317609$exports) this.length++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    'delete': function(name /* , value */ ) {
        var state = $fa9d7c1adad917ec$var$getInternalParamsState(this);
        var length = $f59d8e2e21363a88$exports(arguments.length, 1);
        var entries = state.entries;
        var key = $cc1f216aa7e44c59$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $cc1f216aa7e44c59$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index];
            if (entry.key === key && (value === undefined || entry.value === value)) {
                $fa9d7c1adad917ec$var$splice(entries, index, 1);
                if (value !== undefined) break;
            } else index++;
        }
        if (!$ce6ba28f66317609$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        var entries = $fa9d7c1adad917ec$var$getInternalParamsState(this).entries;
        $f59d8e2e21363a88$exports(arguments.length, 1);
        var key = $cc1f216aa7e44c59$exports(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        var entries = $fa9d7c1adad917ec$var$getInternalParamsState(this).entries;
        $f59d8e2e21363a88$exports(arguments.length, 1);
        var key = $cc1f216aa7e44c59$exports(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) $fa9d7c1adad917ec$var$push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name /* , value */ ) {
        var entries = $fa9d7c1adad917ec$var$getInternalParamsState(this).entries;
        var length = $f59d8e2e21363a88$exports(arguments.length, 1);
        var key = $cc1f216aa7e44c59$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $cc1f216aa7e44c59$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index++];
            if (entry.key === key && (value === undefined || entry.value === value)) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        var state = $fa9d7c1adad917ec$var$getInternalParamsState(this);
        $f59d8e2e21363a88$exports(arguments.length, 1);
        var entries = state.entries;
        var found = false;
        var key = $cc1f216aa7e44c59$exports(name);
        var val = $cc1f216aa7e44c59$exports(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) $fa9d7c1adad917ec$var$splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) $fa9d7c1adad917ec$var$push(entries, {
            key: key,
            value: val
        });
        if (!$ce6ba28f66317609$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = $fa9d7c1adad917ec$var$getInternalParamsState(this);
        $716434f03ef1b685$exports(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = $fa9d7c1adad917ec$var$getInternalParamsState(this).entries;
        var boundFunction = $2d52694feff5f895$exports(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new $fa9d7c1adad917ec$var$URLSearchParamsIterator(this, 'keys');
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new $fa9d7c1adad917ec$var$URLSearchParamsIterator(this, 'values');
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new $fa9d7c1adad917ec$var$URLSearchParamsIterator(this, 'entries');
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
$a5378e288f28a3de$exports($fa9d7c1adad917ec$var$URLSearchParamsPrototype, $fa9d7c1adad917ec$var$ITERATOR, $fa9d7c1adad917ec$var$URLSearchParamsPrototype.entries, {
    name: 'entries'
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
$a5378e288f28a3de$exports($fa9d7c1adad917ec$var$URLSearchParamsPrototype, 'toString', function toString() {
    return $fa9d7c1adad917ec$var$getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if ($ce6ba28f66317609$exports) $ae34d1f2f4f59697$exports($fa9d7c1adad917ec$var$URLSearchParamsPrototype, 'size', {
    get: function size() {
        return $fa9d7c1adad917ec$var$getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
});
$7fe02f462050b03b$exports($fa9d7c1adad917ec$var$URLSearchParamsConstructor, $fa9d7c1adad917ec$var$URL_SEARCH_PARAMS);
$ca66147c52f1c36f$exports({
    global: true,
    constructor: true,
    forced: !$28c2cba1e1035c76$exports
}, {
    URLSearchParams: $fa9d7c1adad917ec$var$URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!$28c2cba1e1035c76$exports && $66733457c42e4bfd$exports($fa9d7c1adad917ec$var$Headers)) {
    var $fa9d7c1adad917ec$var$headersHas = $966303461c07e127$exports($fa9d7c1adad917ec$var$HeadersPrototype.has);
    var $fa9d7c1adad917ec$var$headersSet = $966303461c07e127$exports($fa9d7c1adad917ec$var$HeadersPrototype.set);
    var $fa9d7c1adad917ec$var$wrapRequestOptions = function(init) {
        if ($96a478191b33f4fa$exports(init)) {
            var body = init.body;
            var headers;
            if ($39673a197979f5e7$exports(body) === $fa9d7c1adad917ec$var$URL_SEARCH_PARAMS) {
                headers = init.headers ? new $fa9d7c1adad917ec$var$Headers(init.headers) : new $fa9d7c1adad917ec$var$Headers();
                if (!$fa9d7c1adad917ec$var$headersHas(headers, 'content-type')) $fa9d7c1adad917ec$var$headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                return $cfd63855ca92cd7c$exports(init, {
                    body: $b941c4cd0c3c4a09$exports(0, $cc1f216aa7e44c59$exports(body)),
                    headers: $b941c4cd0c3c4a09$exports(0, headers)
                });
            }
        }
        return init;
    };
    if ($66733457c42e4bfd$exports($fa9d7c1adad917ec$var$nativeFetch)) $ca66147c52f1c36f$exports({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return $fa9d7c1adad917ec$var$nativeFetch(input, arguments.length > 1 ? $fa9d7c1adad917ec$var$wrapRequestOptions(arguments[1]) : {});
        }
    });
    if ($66733457c42e4bfd$exports($fa9d7c1adad917ec$var$NativeRequest)) {
        var $fa9d7c1adad917ec$var$RequestConstructor = function Request(input /* , init */ ) {
            $e75aa794ae249210$exports(this, $fa9d7c1adad917ec$var$RequestPrototype);
            return new $fa9d7c1adad917ec$var$NativeRequest(input, arguments.length > 1 ? $fa9d7c1adad917ec$var$wrapRequestOptions(arguments[1]) : {});
        };
        $fa9d7c1adad917ec$var$RequestPrototype.constructor = $fa9d7c1adad917ec$var$RequestConstructor;
        $fa9d7c1adad917ec$var$RequestConstructor.prototype = $fa9d7c1adad917ec$var$RequestPrototype;
        $ca66147c52f1c36f$exports({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: $fa9d7c1adad917ec$var$RequestConstructor
        });
    }
}
$fa9d7c1adad917ec$exports = {
    URLSearchParams: $fa9d7c1adad917ec$var$URLSearchParamsConstructor,
    getState: $fa9d7c1adad917ec$var$getInternalParamsState
};



var $af392317059ba6ca$var$setInternalState = $1f4f460c9ddf95ba$exports.set;
var $af392317059ba6ca$var$getInternalURLState = $1f4f460c9ddf95ba$exports.getterFor('URL');
var $af392317059ba6ca$var$URLSearchParams = $fa9d7c1adad917ec$exports.URLSearchParams;
var $af392317059ba6ca$var$getInternalSearchParamsState = $fa9d7c1adad917ec$exports.getState;
var $af392317059ba6ca$var$NativeURL = $1cca30410cf11b53$exports.URL;
var $af392317059ba6ca$var$TypeError = $1cca30410cf11b53$exports.TypeError;
var $af392317059ba6ca$var$parseInt = $1cca30410cf11b53$exports.parseInt;
var $af392317059ba6ca$var$floor = Math.floor;
var $af392317059ba6ca$var$pow = Math.pow;
var $af392317059ba6ca$var$charAt = $966303461c07e127$exports(''.charAt);
var $af392317059ba6ca$var$exec = $966303461c07e127$exports(/./.exec);
var $af392317059ba6ca$var$join = $966303461c07e127$exports([].join);
var $af392317059ba6ca$var$numberToString = $966303461c07e127$exports(1.1.toString);
var $af392317059ba6ca$var$pop = $966303461c07e127$exports([].pop);
var $af392317059ba6ca$var$push = $966303461c07e127$exports([].push);
var $af392317059ba6ca$var$replace = $966303461c07e127$exports(''.replace);
var $af392317059ba6ca$var$shift = $966303461c07e127$exports([].shift);
var $af392317059ba6ca$var$split = $966303461c07e127$exports(''.split);
var $af392317059ba6ca$var$stringSlice = $966303461c07e127$exports(''.slice);
var $af392317059ba6ca$var$toLowerCase = $966303461c07e127$exports(''.toLowerCase);
var $af392317059ba6ca$var$unshift = $966303461c07e127$exports([].unshift);
var $af392317059ba6ca$var$INVALID_AUTHORITY = 'Invalid authority';
var $af392317059ba6ca$var$INVALID_SCHEME = 'Invalid scheme';
var $af392317059ba6ca$var$INVALID_HOST = 'Invalid host';
var $af392317059ba6ca$var$INVALID_PORT = 'Invalid port';
var $af392317059ba6ca$var$ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var $af392317059ba6ca$var$ALPHANUMERIC = /[\d+-.a-z]/i;
var $af392317059ba6ca$var$DIGIT = /\d/;
var $af392317059ba6ca$var$HEX_START = /^0x/i;
var $af392317059ba6ca$var$OCT = /^[0-7]+$/;
var $af392317059ba6ca$var$DEC = /^\d+$/;
var $af392317059ba6ca$var$HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var $af392317059ba6ca$var$FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var $af392317059ba6ca$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var $af392317059ba6ca$var$LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var $af392317059ba6ca$var$TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var $af392317059ba6ca$var$TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ // eslint-disable-next-line no-unassigned-vars -- expected `undefined` value
var $af392317059ba6ca$var$EOF;
// https://url.spec.whatwg.org/#ipv4-number-parser
var $af392317059ba6ca$var$parseIPv4 = function(input) {
    var parts = $af392317059ba6ca$var$split(input, '.');
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] === '') parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part === '') return input;
        radix = 10;
        if (part.length > 1 && $af392317059ba6ca$var$charAt(part, 0) === '0') {
            radix = $af392317059ba6ca$var$exec($af392317059ba6ca$var$HEX_START, part) ? 16 : 8;
            part = $af392317059ba6ca$var$stringSlice(part, radix === 8 ? 1 : 2);
        }
        if (part === '') number = 0;
        else {
            if (!$af392317059ba6ca$var$exec(radix === 10 ? $af392317059ba6ca$var$DEC : radix === 8 ? $af392317059ba6ca$var$OCT : $af392317059ba6ca$var$HEX, part)) return input;
            number = $af392317059ba6ca$var$parseInt(part, radix);
        }
        $af392317059ba6ca$var$push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index === partsLength - 1) {
            if (number >= $af392317059ba6ca$var$pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = $af392317059ba6ca$var$pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * $af392317059ba6ca$var$pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var $af392317059ba6ca$var$parseIPv6 = function(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function() {
        return $af392317059ba6ca$var$charAt(input, pointer);
    };
    if (chr() === ':') {
        if ($af392317059ba6ca$var$charAt(input, 1) !== ':') return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex === 8) return;
        if (chr() === ':') {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && $af392317059ba6ca$var$exec($af392317059ba6ca$var$HEX, chr())){
            value = value * 16 + $af392317059ba6ca$var$parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() === '.') {
            if (length === 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() === '.' && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!$af392317059ba6ca$var$exec($af392317059ba6ca$var$DIGIT, chr())) return;
                while($af392317059ba6ca$var$exec($af392317059ba6ca$var$DIGIT, chr())){
                    number = $af392317059ba6ca$var$parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece === 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
            }
            if (numbersSeen !== 4) return;
            break;
        } else if (chr() === ':') {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex !== 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex !== 8) return;
    return address;
};
var $af392317059ba6ca$var$findLongestZeroSequence = function(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    return currLength > maxLength ? currStart : maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var $af392317059ba6ca$var$serializeHost = function(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == 'number') {
        result = [];
        for(index = 0; index < 4; index++){
            $af392317059ba6ca$var$unshift(result, host % 256);
            host = $af392317059ba6ca$var$floor(host / 256);
        }
        return $af392317059ba6ca$var$join(result, '.');
    }
    // ipv6
    if (typeof host == 'object') {
        result = '';
        compress = $af392317059ba6ca$var$findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ':' : '::';
                ignore0 = true;
            } else {
                result += $af392317059ba6ca$var$numberToString(host[index], 16);
                if (index < 7) result += ':';
            }
        }
        return '[' + result + ']';
    }
    return host;
};
var $af392317059ba6ca$var$C0ControlPercentEncodeSet = {};
var $af392317059ba6ca$var$fragmentPercentEncodeSet = $c38778d686268f09$exports({}, $af392317059ba6ca$var$C0ControlPercentEncodeSet, {
    ' ': 1,
    '"': 1,
    '<': 1,
    '>': 1,
    '`': 1
});
var $af392317059ba6ca$var$pathPercentEncodeSet = $c38778d686268f09$exports({}, $af392317059ba6ca$var$fragmentPercentEncodeSet, {
    '#': 1,
    '?': 1,
    '{': 1,
    '}': 1
});
var $af392317059ba6ca$var$userinfoPercentEncodeSet = $c38778d686268f09$exports({}, $af392317059ba6ca$var$pathPercentEncodeSet, {
    '/': 1,
    ':': 1,
    ';': 1,
    '=': 1,
    '@': 1,
    '[': 1,
    '\\': 1,
    ']': 1,
    '^': 1,
    '|': 1
});
var $af392317059ba6ca$var$percentEncode = function(chr, set) {
    var code = $af392317059ba6ca$require$codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !$1d9d3902a50a2fcd$exports(set, chr) ? chr : encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var $af392317059ba6ca$var$specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var $af392317059ba6ca$var$isWindowsDriveLetter = function(string, normalized) {
    var second;
    return string.length === 2 && $af392317059ba6ca$var$exec($af392317059ba6ca$var$ALPHA, $af392317059ba6ca$var$charAt(string, 0)) && ((second = $af392317059ba6ca$var$charAt(string, 1)) === ':' || !normalized && second === '|');
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var $af392317059ba6ca$var$startsWithWindowsDriveLetter = function(string) {
    var third;
    return string.length > 1 && $af392317059ba6ca$var$isWindowsDriveLetter($af392317059ba6ca$var$stringSlice(string, 0, 2)) && (string.length === 2 || (third = $af392317059ba6ca$var$charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var $af392317059ba6ca$var$isSingleDot = function(segment) {
    return segment === '.' || $af392317059ba6ca$var$toLowerCase(segment) === '%2e';
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var $af392317059ba6ca$var$isDoubleDot = function(segment) {
    segment = $af392317059ba6ca$var$toLowerCase(segment);
    return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};
// States:
var $af392317059ba6ca$var$SCHEME_START = {};
var $af392317059ba6ca$var$SCHEME = {};
var $af392317059ba6ca$var$NO_SCHEME = {};
var $af392317059ba6ca$var$SPECIAL_RELATIVE_OR_AUTHORITY = {};
var $af392317059ba6ca$var$PATH_OR_AUTHORITY = {};
var $af392317059ba6ca$var$RELATIVE = {};
var $af392317059ba6ca$var$RELATIVE_SLASH = {};
var $af392317059ba6ca$var$SPECIAL_AUTHORITY_SLASHES = {};
var $af392317059ba6ca$var$SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var $af392317059ba6ca$var$AUTHORITY = {};
var $af392317059ba6ca$var$HOST = {};
var $af392317059ba6ca$var$HOSTNAME = {};
var $af392317059ba6ca$var$PORT = {};
var $af392317059ba6ca$var$FILE = {};
var $af392317059ba6ca$var$FILE_SLASH = {};
var $af392317059ba6ca$var$FILE_HOST = {};
var $af392317059ba6ca$var$PATH_START = {};
var $af392317059ba6ca$var$PATH = {};
var $af392317059ba6ca$var$CANNOT_BE_A_BASE_URL_PATH = {};
var $af392317059ba6ca$var$QUERY = {};
var $af392317059ba6ca$var$FRAGMENT = {};
var $af392317059ba6ca$var$URLState = function(url, isBase, base) {
    var urlString = $cc1f216aa7e44c59$exports(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw new $af392317059ba6ca$var$TypeError(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new $af392317059ba6ca$var$URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw new $af392317059ba6ca$var$TypeError(failure);
        searchParams = $af392317059ba6ca$var$getInternalSearchParamsState(new $af392317059ba6ca$var$URLSearchParams());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
$af392317059ba6ca$var$URLState.prototype = {
    type: 'URL',
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || $af392317059ba6ca$var$SCHEME_START;
        var pointer = 0;
        var buffer = '';
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $cc1f216aa7e44c59$exports(input);
        if (!stateOverride) {
            url.scheme = '';
            url.username = '';
            url.password = '';
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = $af392317059ba6ca$var$replace(input, $af392317059ba6ca$var$LEADING_C0_CONTROL_OR_SPACE, '');
            input = $af392317059ba6ca$var$replace(input, $af392317059ba6ca$var$TRAILING_C0_CONTROL_OR_SPACE, '$1');
        }
        input = $af392317059ba6ca$var$replace(input, $af392317059ba6ca$var$TAB_AND_NEW_LINE, '');
        codePoints = $1491789629013d78$exports(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case $af392317059ba6ca$var$SCHEME_START:
                    if (chr && $af392317059ba6ca$var$exec($af392317059ba6ca$var$ALPHA, chr)) {
                        buffer += $af392317059ba6ca$var$toLowerCase(chr);
                        state = $af392317059ba6ca$var$SCHEME;
                    } else if (!stateOverride) {
                        state = $af392317059ba6ca$var$NO_SCHEME;
                        continue;
                    } else return $af392317059ba6ca$var$INVALID_SCHEME;
                    break;
                case $af392317059ba6ca$var$SCHEME:
                    if (chr && ($af392317059ba6ca$var$exec($af392317059ba6ca$var$ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) buffer += $af392317059ba6ca$var$toLowerCase(chr);
                    else if (chr === ':') {
                        if (stateOverride && (url.isSpecial() !== $1d9d3902a50a2fcd$exports($af392317059ba6ca$var$specialSchemes, buffer) || buffer === 'file' && (url.includesCredentials() || url.port !== null) || url.scheme === 'file' && !url.host)) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && $af392317059ba6ca$var$specialSchemes[url.scheme] === url.port) url.port = null;
                            return;
                        }
                        buffer = '';
                        if (url.scheme === 'file') state = $af392317059ba6ca$var$FILE;
                        else if (url.isSpecial() && base && base.scheme === url.scheme) state = $af392317059ba6ca$var$SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = $af392317059ba6ca$var$SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] === '/') {
                            state = $af392317059ba6ca$var$PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            $af392317059ba6ca$var$push(url.path, '');
                            state = $af392317059ba6ca$var$CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = '';
                        state = $af392317059ba6ca$var$NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return $af392317059ba6ca$var$INVALID_SCHEME;
                    break;
                case $af392317059ba6ca$var$NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr !== '#') return $af392317059ba6ca$var$INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr === '#') {
                        url.scheme = base.scheme;
                        url.path = $7720efb2736da874$exports(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        url.cannotBeABaseURL = true;
                        state = $af392317059ba6ca$var$FRAGMENT;
                        break;
                    }
                    state = base.scheme === 'file' ? $af392317059ba6ca$var$FILE : $af392317059ba6ca$var$RELATIVE;
                    continue;
                case $af392317059ba6ca$var$SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr === '/' && codePoints[pointer + 1] === '/') {
                        state = $af392317059ba6ca$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = $af392317059ba6ca$var$RELATIVE;
                        continue;
                    }
                    break;
                case $af392317059ba6ca$var$PATH_OR_AUTHORITY:
                    if (chr === '/') {
                        state = $af392317059ba6ca$var$AUTHORITY;
                        break;
                    } else {
                        state = $af392317059ba6ca$var$PATH;
                        continue;
                    }
                case $af392317059ba6ca$var$RELATIVE:
                    url.scheme = base.scheme;
                    if (chr === $af392317059ba6ca$var$EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $7720efb2736da874$exports(base.path);
                        url.query = base.query;
                    } else if (chr === '/' || chr === '\\' && url.isSpecial()) state = $af392317059ba6ca$var$RELATIVE_SLASH;
                    else if (chr === '?') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $7720efb2736da874$exports(base.path);
                        url.query = '';
                        state = $af392317059ba6ca$var$QUERY;
                    } else if (chr === '#') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $7720efb2736da874$exports(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        state = $af392317059ba6ca$var$FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $7720efb2736da874$exports(base.path);
                        url.path.length--;
                        state = $af392317059ba6ca$var$PATH;
                        continue;
                    }
                    break;
                case $af392317059ba6ca$var$RELATIVE_SLASH:
                    if (url.isSpecial() && (chr === '/' || chr === '\\')) state = $af392317059ba6ca$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr === '/') state = $af392317059ba6ca$var$AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = $af392317059ba6ca$var$PATH;
                        continue;
                    }
                    break;
                case $af392317059ba6ca$var$SPECIAL_AUTHORITY_SLASHES:
                    state = $af392317059ba6ca$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr !== '/' || $af392317059ba6ca$var$charAt(buffer, pointer + 1) !== '/') continue;
                    pointer++;
                    break;
                case $af392317059ba6ca$var$SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr !== '/' && chr !== '\\') {
                        state = $af392317059ba6ca$var$AUTHORITY;
                        continue;
                    }
                    break;
                case $af392317059ba6ca$var$AUTHORITY:
                    if (chr === '@') {
                        if (seenAt) buffer = '%40' + buffer;
                        seenAt = true;
                        bufferCodePoints = $1491789629013d78$exports(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint === ':' && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = $af392317059ba6ca$var$percentEncode(codePoint, $af392317059ba6ca$var$userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = '';
                    } else if (chr === $af392317059ba6ca$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (seenAt && buffer === '') return $af392317059ba6ca$var$INVALID_AUTHORITY;
                        pointer -= $1491789629013d78$exports(buffer).length + 1;
                        buffer = '';
                        state = $af392317059ba6ca$var$HOST;
                    } else buffer += chr;
                    break;
                case $af392317059ba6ca$var$HOST:
                case $af392317059ba6ca$var$HOSTNAME:
                    if (stateOverride && url.scheme === 'file') {
                        state = $af392317059ba6ca$var$FILE_HOST;
                        continue;
                    } else if (chr === ':' && !seenBracket) {
                        if (buffer === '') return $af392317059ba6ca$var$INVALID_HOST;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = $af392317059ba6ca$var$PORT;
                        if (stateOverride === $af392317059ba6ca$var$HOSTNAME) return;
                    } else if (chr === $af392317059ba6ca$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (url.isSpecial() && buffer === '') return $af392317059ba6ca$var$INVALID_HOST;
                        if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = $af392317059ba6ca$var$PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr === '[') seenBracket = true;
                        else if (chr === ']') seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case $af392317059ba6ca$var$PORT:
                    if ($af392317059ba6ca$var$exec($af392317059ba6ca$var$DIGIT, chr)) buffer += chr;
                    else if (chr === $af392317059ba6ca$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial() || stateOverride) {
                        if (buffer !== '') {
                            var port = $af392317059ba6ca$var$parseInt(buffer, 10);
                            if (port > 0xFFFF) return $af392317059ba6ca$var$INVALID_PORT;
                            url.port = url.isSpecial() && port === $af392317059ba6ca$var$specialSchemes[url.scheme] ? null : port;
                            buffer = '';
                        }
                        if (stateOverride) return;
                        state = $af392317059ba6ca$var$PATH_START;
                        continue;
                    } else return $af392317059ba6ca$var$INVALID_PORT;
                    break;
                case $af392317059ba6ca$var$FILE:
                    url.scheme = 'file';
                    if (chr === '/' || chr === '\\') state = $af392317059ba6ca$var$FILE_SLASH;
                    else if (base && base.scheme === 'file') switch(chr){
                        case $af392317059ba6ca$var$EOF:
                            url.host = base.host;
                            url.path = $7720efb2736da874$exports(base.path);
                            url.query = base.query;
                            break;
                        case '?':
                            url.host = base.host;
                            url.path = $7720efb2736da874$exports(base.path);
                            url.query = '';
                            state = $af392317059ba6ca$var$QUERY;
                            break;
                        case '#':
                            url.host = base.host;
                            url.path = $7720efb2736da874$exports(base.path);
                            url.query = base.query;
                            url.fragment = '';
                            state = $af392317059ba6ca$var$FRAGMENT;
                            break;
                        default:
                            if (!$af392317059ba6ca$var$startsWithWindowsDriveLetter($af392317059ba6ca$var$join($7720efb2736da874$exports(codePoints, pointer), ''))) {
                                url.host = base.host;
                                url.path = $7720efb2736da874$exports(base.path);
                                url.shortenPath();
                            }
                            state = $af392317059ba6ca$var$PATH;
                            continue;
                    }
                    else {
                        state = $af392317059ba6ca$var$PATH;
                        continue;
                    }
                    break;
                case $af392317059ba6ca$var$FILE_SLASH:
                    if (chr === '/' || chr === '\\') {
                        state = $af392317059ba6ca$var$FILE_HOST;
                        break;
                    }
                    if (base && base.scheme === 'file' && !$af392317059ba6ca$var$startsWithWindowsDriveLetter($af392317059ba6ca$var$join($7720efb2736da874$exports(codePoints, pointer), ''))) {
                        if ($af392317059ba6ca$var$isWindowsDriveLetter(base.path[0], true)) $af392317059ba6ca$var$push(url.path, base.path[0]);
                        else url.host = base.host;
                    }
                    state = $af392317059ba6ca$var$PATH;
                    continue;
                case $af392317059ba6ca$var$FILE_HOST:
                    if (chr === $af392317059ba6ca$var$EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
                        if (!stateOverride && $af392317059ba6ca$var$isWindowsDriveLetter(buffer)) state = $af392317059ba6ca$var$PATH;
                        else if (buffer === '') {
                            url.host = '';
                            if (stateOverride) return;
                            state = $af392317059ba6ca$var$PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host === 'localhost') url.host = '';
                            if (stateOverride) return;
                            buffer = '';
                            state = $af392317059ba6ca$var$PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case $af392317059ba6ca$var$PATH_START:
                    if (url.isSpecial()) {
                        state = $af392317059ba6ca$var$PATH;
                        if (chr !== '/' && chr !== '\\') continue;
                    } else if (!stateOverride && chr === '?') {
                        url.query = '';
                        state = $af392317059ba6ca$var$QUERY;
                    } else if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = $af392317059ba6ca$var$FRAGMENT;
                    } else if (chr !== $af392317059ba6ca$var$EOF) {
                        state = $af392317059ba6ca$var$PATH;
                        if (chr !== '/') continue;
                    }
                    break;
                case $af392317059ba6ca$var$PATH:
                    if (chr === $af392317059ba6ca$var$EOF || chr === '/' || chr === '\\' && url.isSpecial() || !stateOverride && (chr === '?' || chr === '#')) {
                        if ($af392317059ba6ca$var$isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) $af392317059ba6ca$var$push(url.path, '');
                        } else if ($af392317059ba6ca$var$isSingleDot(buffer)) {
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) $af392317059ba6ca$var$push(url.path, '');
                        } else {
                            if (url.scheme === 'file' && !url.path.length && $af392317059ba6ca$var$isWindowsDriveLetter(buffer)) {
                                if (url.host) url.host = '';
                                buffer = $af392317059ba6ca$var$charAt(buffer, 0) + ':'; // normalize windows drive letter
                            }
                            $af392317059ba6ca$var$push(url.path, buffer);
                        }
                        buffer = '';
                        if (url.scheme === 'file' && (chr === $af392317059ba6ca$var$EOF || chr === '?' || chr === '#')) while(url.path.length > 1 && url.path[0] === '')$af392317059ba6ca$var$shift(url.path);
                        if (chr === '?') {
                            url.query = '';
                            state = $af392317059ba6ca$var$QUERY;
                        } else if (chr === '#') {
                            url.fragment = '';
                            state = $af392317059ba6ca$var$FRAGMENT;
                        }
                    } else buffer += $af392317059ba6ca$var$percentEncode(chr, $af392317059ba6ca$var$pathPercentEncodeSet);
                    break;
                case $af392317059ba6ca$var$CANNOT_BE_A_BASE_URL_PATH:
                    if (chr === '?') {
                        url.query = '';
                        state = $af392317059ba6ca$var$QUERY;
                    } else if (chr === '#') {
                        url.fragment = '';
                        state = $af392317059ba6ca$var$FRAGMENT;
                    } else if (chr !== $af392317059ba6ca$var$EOF) url.path[0] += $af392317059ba6ca$var$percentEncode(chr, $af392317059ba6ca$var$C0ControlPercentEncodeSet);
                    break;
                case $af392317059ba6ca$var$QUERY:
                    if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = $af392317059ba6ca$var$FRAGMENT;
                    } else if (chr !== $af392317059ba6ca$var$EOF) {
                        if (chr === "'" && url.isSpecial()) url.query += '%27';
                        else if (chr === '#') url.query += '%23';
                        else url.query += $af392317059ba6ca$var$percentEncode(chr, $af392317059ba6ca$var$C0ControlPercentEncodeSet);
                    }
                    break;
                case $af392317059ba6ca$var$FRAGMENT:
                    if (chr !== $af392317059ba6ca$var$EOF) url.fragment += $af392317059ba6ca$var$percentEncode(chr, $af392317059ba6ca$var$fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function(input) {
        var result, codePoints, index;
        if ($af392317059ba6ca$var$charAt(input, 0) === '[') {
            if ($af392317059ba6ca$var$charAt(input, input.length - 1) !== ']') return $af392317059ba6ca$var$INVALID_HOST;
            result = $af392317059ba6ca$var$parseIPv6($af392317059ba6ca$var$stringSlice(input, 1, -1));
            if (!result) return $af392317059ba6ca$var$INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if ($af392317059ba6ca$var$exec($af392317059ba6ca$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return $af392317059ba6ca$var$INVALID_HOST;
            result = '';
            codePoints = $1491789629013d78$exports(input);
            for(index = 0; index < codePoints.length; index++)result += $af392317059ba6ca$var$percentEncode(codePoints[index], $af392317059ba6ca$var$C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = $b02276690096b48b$exports(input);
            if ($af392317059ba6ca$var$exec($af392317059ba6ca$var$FORBIDDEN_HOST_CODE_POINT, input)) return $af392317059ba6ca$var$INVALID_HOST;
            result = $af392317059ba6ca$var$parseIPv4(input);
            if (result === null) return $af392317059ba6ca$var$INVALID_HOST;
            this.host = result;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function() {
        return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function() {
        return this.username !== '' || this.password !== '';
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function() {
        return $1d9d3902a50a2fcd$exports($af392317059ba6ca$var$specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !$af392317059ba6ca$var$isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ':';
        if (host !== null) {
            output += '//';
            if (url.includesCredentials()) output += username + (password ? ':' + password : '') + '@';
            output += $af392317059ba6ca$var$serializeHost(host);
            if (port !== null) output += ':' + port;
        } else if (scheme === 'file') output += '//';
        output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + $af392317059ba6ca$var$join(path, '/') : '';
        if (query !== null) output += '?' + query;
        if (fragment !== null) output += '#' + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function(href) {
        var failure = this.parse(href);
        if (failure) throw new $af392317059ba6ca$var$TypeError(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme === 'blob') try {
            return new $af392317059ba6ca$var$URLConstructor(scheme.path[0]).origin;
        } catch (error) {
            return 'null';
        }
        if (scheme === 'file' || !this.isSpecial()) return 'null';
        return scheme + '://' + $af392317059ba6ca$var$serializeHost(this.host) + (port !== null ? ':' + port : '');
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function() {
        return this.scheme + ':';
    },
    setProtocol: function(protocol) {
        this.parse($cc1f216aa7e44c59$exports(protocol) + ':', $af392317059ba6ca$var$SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function() {
        return this.username;
    },
    setUsername: function(username) {
        var codePoints = $1491789629013d78$exports($cc1f216aa7e44c59$exports(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = '';
        for(var i = 0; i < codePoints.length; i++)this.username += $af392317059ba6ca$var$percentEncode(codePoints[i], $af392317059ba6ca$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function() {
        return this.password;
    },
    setPassword: function(password) {
        var codePoints = $1491789629013d78$exports($cc1f216aa7e44c59$exports(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = '';
        for(var i = 0; i < codePoints.length; i++)this.password += $af392317059ba6ca$var$percentEncode(codePoints[i], $af392317059ba6ca$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function() {
        var host = this.host;
        var port = this.port;
        return host === null ? '' : port === null ? $af392317059ba6ca$var$serializeHost(host) : $af392317059ba6ca$var$serializeHost(host) + ':' + port;
    },
    setHost: function(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, $af392317059ba6ca$var$HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function() {
        var host = this.host;
        return host === null ? '' : $af392317059ba6ca$var$serializeHost(host);
    },
    setHostname: function(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, $af392317059ba6ca$var$HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function() {
        var port = this.port;
        return port === null ? '' : $cc1f216aa7e44c59$exports(port);
    },
    setPort: function(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $cc1f216aa7e44c59$exports(port);
        if (port === '') this.port = null;
        else this.parse(port, $af392317059ba6ca$var$PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? '/' + $af392317059ba6ca$var$join(path, '/') : '';
    },
    setPathname: function(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, $af392317059ba6ca$var$PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function() {
        var query = this.query;
        return query ? '?' + query : '';
    },
    setSearch: function(search) {
        search = $cc1f216aa7e44c59$exports(search);
        if (search === '') this.query = null;
        else {
            if ($af392317059ba6ca$var$charAt(search, 0) === '?') search = $af392317059ba6ca$var$stringSlice(search, 1);
            this.query = '';
            this.parse(search, $af392317059ba6ca$var$QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function() {
        var fragment = this.fragment;
        return fragment ? '#' + fragment : '';
    },
    setHash: function(hash) {
        hash = $cc1f216aa7e44c59$exports(hash);
        if (hash === '') {
            this.fragment = null;
            return;
        }
        if ($af392317059ba6ca$var$charAt(hash, 0) === '#') hash = $af392317059ba6ca$var$stringSlice(hash, 1);
        this.fragment = '';
        this.parse(hash, $af392317059ba6ca$var$FRAGMENT);
    },
    update: function() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var $af392317059ba6ca$var$URLConstructor = function URL(url /* , base */ ) {
    var that = $e75aa794ae249210$exports(this, $af392317059ba6ca$var$URLPrototype);
    var base = $f59d8e2e21363a88$exports(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = $af392317059ba6ca$var$setInternalState(that, new $af392317059ba6ca$var$URLState(url, false, base));
    if (!$ce6ba28f66317609$exports) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var $af392317059ba6ca$var$URLPrototype = $af392317059ba6ca$var$URLConstructor.prototype;
var $af392317059ba6ca$var$accessorDescriptor = function(getter, setter) {
    return {
        get: function() {
            return $af392317059ba6ca$var$getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return $af392317059ba6ca$var$getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if ($ce6ba28f66317609$exports) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'href', $af392317059ba6ca$var$accessorDescriptor('serialize', 'setHref'));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'origin', $af392317059ba6ca$var$accessorDescriptor('getOrigin'));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'protocol', $af392317059ba6ca$var$accessorDescriptor('getProtocol', 'setProtocol'));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'username', $af392317059ba6ca$var$accessorDescriptor('getUsername', 'setUsername'));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'password', $af392317059ba6ca$var$accessorDescriptor('getPassword', 'setPassword'));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'host', $af392317059ba6ca$var$accessorDescriptor('getHost', 'setHost'));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'hostname', $af392317059ba6ca$var$accessorDescriptor('getHostname', 'setHostname'));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'port', $af392317059ba6ca$var$accessorDescriptor('getPort', 'setPort'));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'pathname', $af392317059ba6ca$var$accessorDescriptor('getPathname', 'setPathname'));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'search', $af392317059ba6ca$var$accessorDescriptor('getSearch', 'setSearch'));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'searchParams', $af392317059ba6ca$var$accessorDescriptor('getSearchParams'));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    $ae34d1f2f4f59697$exports($af392317059ba6ca$var$URLPrototype, 'hash', $af392317059ba6ca$var$accessorDescriptor('getHash', 'setHash'));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$a5378e288f28a3de$exports($af392317059ba6ca$var$URLPrototype, 'toJSON', function toJSON() {
    return $af392317059ba6ca$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
$a5378e288f28a3de$exports($af392317059ba6ca$var$URLPrototype, 'toString', function toString() {
    return $af392317059ba6ca$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if ($af392317059ba6ca$var$NativeURL) {
    var $af392317059ba6ca$var$nativeCreateObjectURL = $af392317059ba6ca$var$NativeURL.createObjectURL;
    var $af392317059ba6ca$var$nativeRevokeObjectURL = $af392317059ba6ca$var$NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if ($af392317059ba6ca$var$nativeCreateObjectURL) $a5378e288f28a3de$exports($af392317059ba6ca$var$URLConstructor, 'createObjectURL', $2d52694feff5f895$exports($af392317059ba6ca$var$nativeCreateObjectURL, $af392317059ba6ca$var$NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if ($af392317059ba6ca$var$nativeRevokeObjectURL) $a5378e288f28a3de$exports($af392317059ba6ca$var$URLConstructor, 'revokeObjectURL', $2d52694feff5f895$exports($af392317059ba6ca$var$nativeRevokeObjectURL, $af392317059ba6ca$var$NativeURL));
}
$7fe02f462050b03b$exports($af392317059ba6ca$var$URLConstructor, 'URL');
$ca66147c52f1c36f$exports({
    global: true,
    constructor: true,
    forced: !$28c2cba1e1035c76$exports,
    sham: !$ce6ba28f66317609$exports
}, {
    URL: $af392317059ba6ca$var$URLConstructor
});




'use strict';


// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$ca66147c52f1c36f$exports({
    target: 'URL',
    proto: true,
    enumerable: true
}, {
    toJSON: function toJSON() {
        return $6dd48e140907213f$exports(URL.prototype.toString, this);
    }
});


'use strict';



var $211c217de79f8f69$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $211c217de79f8f69$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $211c217de79f8f69$exports));
try {
    regeneratorRuntime = $211c217de79f8f69$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $211c217de79f8f69$var$runtime;
    else Function("r", "regeneratorRuntime = r")($211c217de79f8f69$var$runtime);
}


var $ef19cea07311852a$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($ef19cea07311852a$exports);
})($ef19cea07311852a$exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});


const $8f3cb5ff5bcc33ef$export$4c5dd147b21b9176 = (locations)=>{
    var map = (0, (/*@__PURE__*/$parcel$interopDefault($ef19cea07311852a$exports))).map('map', {
        zoomControl: false
    });
    // var map = L.map('map', { zoomControl: false }).setView([31.111745, -118.113491], );
    (0, (/*@__PURE__*/$parcel$interopDefault($ef19cea07311852a$exports))).tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        referrerPolicy: 'no-referrer'
    }).addTo(map);
    const points = [];
    locations.forEach((loc)=>{
        const point = [
            loc.coordinates[1],
            loc.coordinates[0]
        ];
        points.push(point);
        (0, (/*@__PURE__*/$parcel$interopDefault($ef19cea07311852a$exports))).marker(point).addTo(map).bindPopup(`<h1 style="font-size: 1.4rem">Day ${loc.day}: ${loc.description}</h1>`, {
            autoClose: false
        }).openPopup();
    });
    const bounds = (0, (/*@__PURE__*/$parcel$interopDefault($ef19cea07311852a$exports))).latLngBounds(points).pad(0.5);
    map.fitBounds(bounds);
    map.scrollWheelZoom.disable();
};


'use strict';
function $af63e388eb3e7024$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $0a51f960109e0fa4$var$toString } = Object.prototype;
const { getPrototypeOf: $0a51f960109e0fa4$var$getPrototypeOf } = Object;
const { iterator: $0a51f960109e0fa4$var$iterator, toStringTag: $0a51f960109e0fa4$var$toStringTag } = Symbol;
const $0a51f960109e0fa4$var$kindOf = ((cache)=>(thing)=>{
        const str = $0a51f960109e0fa4$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $0a51f960109e0fa4$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$0a51f960109e0fa4$var$kindOf(thing) === type;
};
const $0a51f960109e0fa4$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $0a51f960109e0fa4$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $0a51f960109e0fa4$var$isUndefined = $0a51f960109e0fa4$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $0a51f960109e0fa4$var$isBuffer(val) {
    return val !== null && !$0a51f960109e0fa4$var$isUndefined(val) && val.constructor !== null && !$0a51f960109e0fa4$var$isUndefined(val.constructor) && $0a51f960109e0fa4$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $0a51f960109e0fa4$var$isArrayBuffer = $0a51f960109e0fa4$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $0a51f960109e0fa4$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $0a51f960109e0fa4$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $0a51f960109e0fa4$var$isString = $0a51f960109e0fa4$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $0a51f960109e0fa4$var$isFunction = $0a51f960109e0fa4$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $0a51f960109e0fa4$var$isNumber = $0a51f960109e0fa4$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $0a51f960109e0fa4$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $0a51f960109e0fa4$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $0a51f960109e0fa4$var$isPlainObject = (val)=>{
    if ($0a51f960109e0fa4$var$kindOf(val) !== 'object') return false;
    const prototype = $0a51f960109e0fa4$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($0a51f960109e0fa4$var$toStringTag in val) && !($0a51f960109e0fa4$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $0a51f960109e0fa4$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$0a51f960109e0fa4$var$isObject(val) || $0a51f960109e0fa4$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $0a51f960109e0fa4$var$isDate = $0a51f960109e0fa4$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0a51f960109e0fa4$var$isFile = $0a51f960109e0fa4$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $0a51f960109e0fa4$var$isBlob = $0a51f960109e0fa4$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0a51f960109e0fa4$var$isFileList = $0a51f960109e0fa4$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $0a51f960109e0fa4$var$isStream = (val)=>$0a51f960109e0fa4$var$isObject(val) && $0a51f960109e0fa4$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $0a51f960109e0fa4$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $0a51f960109e0fa4$var$isFunction(thing.append) && ((kind = $0a51f960109e0fa4$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $0a51f960109e0fa4$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $0a51f960109e0fa4$var$isURLSearchParams = $0a51f960109e0fa4$var$kindOfTest('URLSearchParams');
const [$0a51f960109e0fa4$var$isReadableStream, $0a51f960109e0fa4$var$isRequest, $0a51f960109e0fa4$var$isResponse, $0a51f960109e0fa4$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($0a51f960109e0fa4$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $0a51f960109e0fa4$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $0a51f960109e0fa4$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($0a51f960109e0fa4$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($0a51f960109e0fa4$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $0a51f960109e0fa4$var$findKey(obj, key) {
    if ($0a51f960109e0fa4$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $0a51f960109e0fa4$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $0a51f960109e0fa4$var$isContextDefined = (context)=>!$0a51f960109e0fa4$var$isUndefined(context) && context !== $0a51f960109e0fa4$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $0a51f960109e0fa4$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $0a51f960109e0fa4$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $0a51f960109e0fa4$var$findKey(result, key) || key;
        if ($0a51f960109e0fa4$var$isPlainObject(result[targetKey]) && $0a51f960109e0fa4$var$isPlainObject(val)) result[targetKey] = $0a51f960109e0fa4$var$merge(result[targetKey], val);
        else if ($0a51f960109e0fa4$var$isPlainObject(val)) result[targetKey] = $0a51f960109e0fa4$var$merge({}, val);
        else if ($0a51f960109e0fa4$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$0a51f960109e0fa4$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $0a51f960109e0fa4$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $0a51f960109e0fa4$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $0a51f960109e0fa4$var$forEach(b, (val, key)=>{
        if (thisArg && $0a51f960109e0fa4$var$isFunction(val)) a[key] = (0, $af63e388eb3e7024$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $0a51f960109e0fa4$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $0a51f960109e0fa4$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $0a51f960109e0fa4$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $0a51f960109e0fa4$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $0a51f960109e0fa4$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $0a51f960109e0fa4$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($0a51f960109e0fa4$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$0a51f960109e0fa4$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $0a51f960109e0fa4$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $0a51f960109e0fa4$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $0a51f960109e0fa4$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$0a51f960109e0fa4$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $0a51f960109e0fa4$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $0a51f960109e0fa4$var$isHTMLForm = $0a51f960109e0fa4$var$kindOfTest('HTMLFormElement');
const $0a51f960109e0fa4$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $0a51f960109e0fa4$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $0a51f960109e0fa4$var$isRegExp = $0a51f960109e0fa4$var$kindOfTest('RegExp');
const $0a51f960109e0fa4$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $0a51f960109e0fa4$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $0a51f960109e0fa4$var$freezeMethods = (obj)=>{
    $0a51f960109e0fa4$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($0a51f960109e0fa4$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$0a51f960109e0fa4$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $0a51f960109e0fa4$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $0a51f960109e0fa4$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $0a51f960109e0fa4$var$noop = ()=>{};
const $0a51f960109e0fa4$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $0a51f960109e0fa4$var$isSpecCompliantForm(thing) {
    return !!(thing && $0a51f960109e0fa4$var$isFunction(thing.append) && thing[$0a51f960109e0fa4$var$toStringTag] === 'FormData' && thing[$0a51f960109e0fa4$var$iterator]);
}
const $0a51f960109e0fa4$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($0a51f960109e0fa4$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($0a51f960109e0fa4$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $0a51f960109e0fa4$var$isArray(source) ? [] : {};
                $0a51f960109e0fa4$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$0a51f960109e0fa4$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $0a51f960109e0fa4$var$isAsyncFn = $0a51f960109e0fa4$var$kindOfTest('AsyncFunction');
const $0a51f960109e0fa4$var$isThenable = (thing)=>thing && ($0a51f960109e0fa4$var$isObject(thing) || $0a51f960109e0fa4$var$isFunction(thing)) && $0a51f960109e0fa4$var$isFunction(thing.then) && $0a51f960109e0fa4$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $0a51f960109e0fa4$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $0a51f960109e0fa4$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $0a51f960109e0fa4$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $0a51f960109e0fa4$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $0a51f960109e0fa4$var$isFunction($0a51f960109e0fa4$var$_global.postMessage));
const $0a51f960109e0fa4$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($0a51f960109e0fa4$var$_global) : $0a51f960109e0fa4$var$_setImmediate;
// *********************
const $0a51f960109e0fa4$var$isIterable = (thing)=>thing != null && $0a51f960109e0fa4$var$isFunction(thing[$0a51f960109e0fa4$var$iterator]);
var $0a51f960109e0fa4$export$2e2bcd8739ae039 = {
    isArray: $0a51f960109e0fa4$var$isArray,
    isArrayBuffer: $0a51f960109e0fa4$var$isArrayBuffer,
    isBuffer: $0a51f960109e0fa4$var$isBuffer,
    isFormData: $0a51f960109e0fa4$var$isFormData,
    isArrayBufferView: $0a51f960109e0fa4$var$isArrayBufferView,
    isString: $0a51f960109e0fa4$var$isString,
    isNumber: $0a51f960109e0fa4$var$isNumber,
    isBoolean: $0a51f960109e0fa4$var$isBoolean,
    isObject: $0a51f960109e0fa4$var$isObject,
    isPlainObject: $0a51f960109e0fa4$var$isPlainObject,
    isEmptyObject: $0a51f960109e0fa4$var$isEmptyObject,
    isReadableStream: $0a51f960109e0fa4$var$isReadableStream,
    isRequest: $0a51f960109e0fa4$var$isRequest,
    isResponse: $0a51f960109e0fa4$var$isResponse,
    isHeaders: $0a51f960109e0fa4$var$isHeaders,
    isUndefined: $0a51f960109e0fa4$var$isUndefined,
    isDate: $0a51f960109e0fa4$var$isDate,
    isFile: $0a51f960109e0fa4$var$isFile,
    isBlob: $0a51f960109e0fa4$var$isBlob,
    isRegExp: $0a51f960109e0fa4$var$isRegExp,
    isFunction: $0a51f960109e0fa4$var$isFunction,
    isStream: $0a51f960109e0fa4$var$isStream,
    isURLSearchParams: $0a51f960109e0fa4$var$isURLSearchParams,
    isTypedArray: $0a51f960109e0fa4$var$isTypedArray,
    isFileList: $0a51f960109e0fa4$var$isFileList,
    forEach: $0a51f960109e0fa4$var$forEach,
    merge: $0a51f960109e0fa4$var$merge,
    extend: $0a51f960109e0fa4$var$extend,
    trim: $0a51f960109e0fa4$var$trim,
    stripBOM: $0a51f960109e0fa4$var$stripBOM,
    inherits: $0a51f960109e0fa4$var$inherits,
    toFlatObject: $0a51f960109e0fa4$var$toFlatObject,
    kindOf: $0a51f960109e0fa4$var$kindOf,
    kindOfTest: $0a51f960109e0fa4$var$kindOfTest,
    endsWith: $0a51f960109e0fa4$var$endsWith,
    toArray: $0a51f960109e0fa4$var$toArray,
    forEachEntry: $0a51f960109e0fa4$var$forEachEntry,
    matchAll: $0a51f960109e0fa4$var$matchAll,
    isHTMLForm: $0a51f960109e0fa4$var$isHTMLForm,
    hasOwnProperty: $0a51f960109e0fa4$var$hasOwnProperty,
    hasOwnProp: $0a51f960109e0fa4$var$hasOwnProperty,
    reduceDescriptors: $0a51f960109e0fa4$var$reduceDescriptors,
    freezeMethods: $0a51f960109e0fa4$var$freezeMethods,
    toObjectSet: $0a51f960109e0fa4$var$toObjectSet,
    toCamelCase: $0a51f960109e0fa4$var$toCamelCase,
    noop: $0a51f960109e0fa4$var$noop,
    toFiniteNumber: $0a51f960109e0fa4$var$toFiniteNumber,
    findKey: $0a51f960109e0fa4$var$findKey,
    global: $0a51f960109e0fa4$var$_global,
    isContextDefined: $0a51f960109e0fa4$var$isContextDefined,
    isSpecCompliantForm: $0a51f960109e0fa4$var$isSpecCompliantForm,
    toJSONObject: $0a51f960109e0fa4$var$toJSONObject,
    isAsyncFn: $0a51f960109e0fa4$var$isAsyncFn,
    isThenable: $0a51f960109e0fa4$var$isThenable,
    setImmediate: $0a51f960109e0fa4$var$_setImmediate,
    asap: $0a51f960109e0fa4$var$asap,
    isIterable: $0a51f960109e0fa4$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $f2fd8632892200c7$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).inherits($f2fd8632892200c7$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $f2fd8632892200c7$var$prototype = $f2fd8632892200c7$var$AxiosError.prototype;
const $f2fd8632892200c7$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $f2fd8632892200c7$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($f2fd8632892200c7$var$AxiosError, $f2fd8632892200c7$var$descriptors);
Object.defineProperty($f2fd8632892200c7$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$f2fd8632892200c7$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($f2fd8632892200c7$var$prototype);
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $f2fd8632892200c7$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $f2fd8632892200c7$export$2e2bcd8739ae039 = $f2fd8632892200c7$var$AxiosError;


// eslint-disable-next-line strict
var $92fbca5b49d9b1b0$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $b4fa0ac54ada5015$export$a143d493d941bafc;
var $b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a;
var $b4fa0ac54ada5015$export$f99ded8fe4b79145;
var $b4fa0ac54ada5015$export$599f31c3813fae4d;
'use strict';
var $bfa49c0062a5803d$export$a48f0734ac7c2329;
var $bfa49c0062a5803d$export$d622b2ad8d90c771;
var $bfa49c0062a5803d$export$6100ba28696e12de;
'use strict';
$bfa49c0062a5803d$export$a48f0734ac7c2329 = $bfa49c0062a5803d$var$byteLength;
$bfa49c0062a5803d$export$d622b2ad8d90c771 = $bfa49c0062a5803d$var$toByteArray;
$bfa49c0062a5803d$export$6100ba28696e12de = $bfa49c0062a5803d$var$fromByteArray;
var $bfa49c0062a5803d$var$lookup = [];
var $bfa49c0062a5803d$var$revLookup = [];
var $bfa49c0062a5803d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $bfa49c0062a5803d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $bfa49c0062a5803d$var$i = 0, $bfa49c0062a5803d$var$len = $bfa49c0062a5803d$var$code.length; $bfa49c0062a5803d$var$i < $bfa49c0062a5803d$var$len; ++$bfa49c0062a5803d$var$i){
    $bfa49c0062a5803d$var$lookup[$bfa49c0062a5803d$var$i] = $bfa49c0062a5803d$var$code[$bfa49c0062a5803d$var$i];
    $bfa49c0062a5803d$var$revLookup[$bfa49c0062a5803d$var$code.charCodeAt($bfa49c0062a5803d$var$i)] = $bfa49c0062a5803d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bfa49c0062a5803d$var$revLookup['-'.charCodeAt(0)] = 62;
$bfa49c0062a5803d$var$revLookup['_'.charCodeAt(0)] = 63;
function $bfa49c0062a5803d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bfa49c0062a5803d$var$byteLength(b64) {
    var lens = $bfa49c0062a5803d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa49c0062a5803d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa49c0062a5803d$var$toByteArray(b64) {
    var tmp;
    var lens = $bfa49c0062a5803d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bfa49c0062a5803d$var$Arr($bfa49c0062a5803d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 18 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 2 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 10 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bfa49c0062a5803d$var$tripletToBase64(num) {
    return $bfa49c0062a5803d$var$lookup[num >> 18 & 0x3F] + $bfa49c0062a5803d$var$lookup[num >> 12 & 0x3F] + $bfa49c0062a5803d$var$lookup[num >> 6 & 0x3F] + $bfa49c0062a5803d$var$lookup[num & 0x3F];
}
function $bfa49c0062a5803d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bfa49c0062a5803d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $bfa49c0062a5803d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bfa49c0062a5803d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bfa49c0062a5803d$var$lookup[tmp >> 2] + $bfa49c0062a5803d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bfa49c0062a5803d$var$lookup[tmp >> 10] + $bfa49c0062a5803d$var$lookup[tmp >> 4 & 0x3F] + $bfa49c0062a5803d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $23e3cc2fb993da68$export$aafa59e2e03f2942;
var $23e3cc2fb993da68$export$68d8715fc104d294;
$23e3cc2fb993da68$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$23e3cc2fb993da68$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $b4fa0ac54ada5015$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$b4fa0ac54ada5015$export$a143d493d941bafc = $b4fa0ac54ada5015$var$Buffer;
$b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a = $b4fa0ac54ada5015$var$SlowBuffer;
$b4fa0ac54ada5015$export$f99ded8fe4b79145 = 50;
const $b4fa0ac54ada5015$var$K_MAX_LENGTH = 0x7fffffff;
$b4fa0ac54ada5015$export$599f31c3813fae4d = $b4fa0ac54ada5015$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $b4fa0ac54ada5015$var$Buffer.TYPED_ARRAY_SUPPORT = $b4fa0ac54ada5015$var$typedArraySupport();
if (!$b4fa0ac54ada5015$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $b4fa0ac54ada5015$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($b4fa0ac54ada5015$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($b4fa0ac54ada5015$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $b4fa0ac54ada5015$var$createBuffer(length) {
    if (length > $b4fa0ac54ada5015$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $b4fa0ac54ada5015$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $b4fa0ac54ada5015$var$allocUnsafe(arg);
    }
    return $b4fa0ac54ada5015$var$from(arg, encodingOrOffset, length);
}
$b4fa0ac54ada5015$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $b4fa0ac54ada5015$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $b4fa0ac54ada5015$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $b4fa0ac54ada5015$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($b4fa0ac54ada5015$var$isInstance(value, ArrayBuffer) || value && $b4fa0ac54ada5015$var$isInstance(value.buffer, ArrayBuffer)) return $b4fa0ac54ada5015$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($b4fa0ac54ada5015$var$isInstance(value, SharedArrayBuffer) || value && $b4fa0ac54ada5015$var$isInstance(value.buffer, SharedArrayBuffer))) return $b4fa0ac54ada5015$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $b4fa0ac54ada5015$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $b4fa0ac54ada5015$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $b4fa0ac54ada5015$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $b4fa0ac54ada5015$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $b4fa0ac54ada5015$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($b4fa0ac54ada5015$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($b4fa0ac54ada5015$var$Buffer, Uint8Array);
function $b4fa0ac54ada5015$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $b4fa0ac54ada5015$var$alloc(size, fill, encoding) {
    $b4fa0ac54ada5015$var$assertSize(size);
    if (size <= 0) return $b4fa0ac54ada5015$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $b4fa0ac54ada5015$var$createBuffer(size).fill(fill, encoding) : $b4fa0ac54ada5015$var$createBuffer(size).fill(fill);
    return $b4fa0ac54ada5015$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $b4fa0ac54ada5015$var$Buffer.alloc = function(size, fill, encoding) {
    return $b4fa0ac54ada5015$var$alloc(size, fill, encoding);
};
function $b4fa0ac54ada5015$var$allocUnsafe(size) {
    $b4fa0ac54ada5015$var$assertSize(size);
    return $b4fa0ac54ada5015$var$createBuffer(size < 0 ? 0 : $b4fa0ac54ada5015$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $b4fa0ac54ada5015$var$Buffer.allocUnsafe = function(size) {
    return $b4fa0ac54ada5015$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $b4fa0ac54ada5015$var$Buffer.allocUnsafeSlow = function(size) {
    return $b4fa0ac54ada5015$var$allocUnsafe(size);
};
function $b4fa0ac54ada5015$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$b4fa0ac54ada5015$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $b4fa0ac54ada5015$var$byteLength(string, encoding) | 0;
    let buf = $b4fa0ac54ada5015$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $b4fa0ac54ada5015$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $b4fa0ac54ada5015$var$checked(array.length) | 0;
    const buf = $b4fa0ac54ada5015$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $b4fa0ac54ada5015$var$fromArrayView(arrayView) {
    if ($b4fa0ac54ada5015$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $b4fa0ac54ada5015$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $b4fa0ac54ada5015$var$fromArrayLike(arrayView);
}
function $b4fa0ac54ada5015$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return buf;
}
function $b4fa0ac54ada5015$var$fromObject(obj) {
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(obj)) {
        const len = $b4fa0ac54ada5015$var$checked(obj.length) | 0;
        const buf = $b4fa0ac54ada5015$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $b4fa0ac54ada5015$var$numberIsNaN(obj.length)) return $b4fa0ac54ada5015$var$createBuffer(0);
        return $b4fa0ac54ada5015$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $b4fa0ac54ada5015$var$fromArrayLike(obj.data);
}
function $b4fa0ac54ada5015$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $b4fa0ac54ada5015$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $b4fa0ac54ada5015$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $b4fa0ac54ada5015$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $b4fa0ac54ada5015$var$Buffer.alloc(+length);
}
$b4fa0ac54ada5015$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $b4fa0ac54ada5015$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$b4fa0ac54ada5015$var$Buffer.compare = function compare(a, b) {
    if ($b4fa0ac54ada5015$var$isInstance(a, Uint8Array)) a = $b4fa0ac54ada5015$var$Buffer.from(a, a.offset, a.byteLength);
    if ($b4fa0ac54ada5015$var$isInstance(b, Uint8Array)) b = $b4fa0ac54ada5015$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(a) || !$b4fa0ac54ada5015$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$b4fa0ac54ada5015$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$b4fa0ac54ada5015$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $b4fa0ac54ada5015$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $b4fa0ac54ada5015$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($b4fa0ac54ada5015$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) buf = $b4fa0ac54ada5015$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $b4fa0ac54ada5015$var$byteLength(string, encoding) {
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $b4fa0ac54ada5015$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $b4fa0ac54ada5015$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $b4fa0ac54ada5015$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $b4fa0ac54ada5015$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$b4fa0ac54ada5015$var$Buffer.byteLength = $b4fa0ac54ada5015$var$byteLength;
function $b4fa0ac54ada5015$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $b4fa0ac54ada5015$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $b4fa0ac54ada5015$var$utf8Slice(this, start, end);
        case 'ascii':
            return $b4fa0ac54ada5015$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $b4fa0ac54ada5015$var$latin1Slice(this, start, end);
        case 'base64':
            return $b4fa0ac54ada5015$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $b4fa0ac54ada5015$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$b4fa0ac54ada5015$var$Buffer.prototype._isBuffer = true;
function $b4fa0ac54ada5015$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$b4fa0ac54ada5015$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$b4fa0ac54ada5015$var$swap(this, i, i + 1);
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $b4fa0ac54ada5015$var$swap(this, i, i + 3);
        $b4fa0ac54ada5015$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $b4fa0ac54ada5015$var$swap(this, i, i + 7);
        $b4fa0ac54ada5015$var$swap(this, i + 1, i + 6);
        $b4fa0ac54ada5015$var$swap(this, i + 2, i + 5);
        $b4fa0ac54ada5015$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $b4fa0ac54ada5015$var$utf8Slice(this, 0, length);
    return $b4fa0ac54ada5015$var$slowToString.apply(this, arguments);
};
$b4fa0ac54ada5015$var$Buffer.prototype.toLocaleString = $b4fa0ac54ada5015$var$Buffer.prototype.toString;
$b4fa0ac54ada5015$var$Buffer.prototype.equals = function equals(b) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $b4fa0ac54ada5015$var$Buffer.compare(this, b) === 0;
};
$b4fa0ac54ada5015$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $b4fa0ac54ada5015$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($b4fa0ac54ada5015$var$customInspectSymbol) $b4fa0ac54ada5015$var$Buffer.prototype[$b4fa0ac54ada5015$var$customInspectSymbol] = $b4fa0ac54ada5015$var$Buffer.prototype.inspect;
$b4fa0ac54ada5015$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($b4fa0ac54ada5015$var$isInstance(target, Uint8Array)) target = $b4fa0ac54ada5015$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $b4fa0ac54ada5015$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($b4fa0ac54ada5015$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $b4fa0ac54ada5015$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $b4fa0ac54ada5015$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $b4fa0ac54ada5015$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $b4fa0ac54ada5015$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$b4fa0ac54ada5015$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $b4fa0ac54ada5015$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$b4fa0ac54ada5015$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $b4fa0ac54ada5015$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $b4fa0ac54ada5015$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($b4fa0ac54ada5015$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $b4fa0ac54ada5015$var$utf8Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $b4fa0ac54ada5015$var$asciiWrite(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$asciiToBytes(string), buf, offset, length);
}
function $b4fa0ac54ada5015$var$base64Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$base64ToBytes(string), buf, offset, length);
}
function $b4fa0ac54ada5015$var$ucs2Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$b4fa0ac54ada5015$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $b4fa0ac54ada5015$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $b4fa0ac54ada5015$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $b4fa0ac54ada5015$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $b4fa0ac54ada5015$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $b4fa0ac54ada5015$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$b4fa0ac54ada5015$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $b4fa0ac54ada5015$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bfa49c0062a5803d$export$6100ba28696e12de(buf);
    else return $bfa49c0062a5803d$export$6100ba28696e12de(buf.slice(start, end));
}
function $b4fa0ac54ada5015$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $b4fa0ac54ada5015$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $b4fa0ac54ada5015$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $b4fa0ac54ada5015$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $b4fa0ac54ada5015$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $b4fa0ac54ada5015$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $b4fa0ac54ada5015$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $b4fa0ac54ada5015$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$b4fa0ac54ada5015$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $b4fa0ac54ada5015$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$b4fa0ac54ada5015$var$Buffer.prototype.readUintLE = $b4fa0ac54ada5015$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUintBE = $b4fa0ac54ada5015$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint8 = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint16LE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint16BE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint32LE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint32BE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readBigUInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$b4fa0ac54ada5015$var$Buffer.prototype.readBigUInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readBigInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readBigInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 8, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 8, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $b4fa0ac54ada5015$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeUintLE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUintBE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint8 = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint16LE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint16BE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint32LE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint32BE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $b4fa0ac54ada5015$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $b4fa0ac54ada5015$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigUInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigUInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $b4fa0ac54ada5015$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $23e3cc2fb993da68$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeFloat(this, value, offset, true, noAssert);
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeFloat(this, value, offset, false, noAssert);
};
function $b4fa0ac54ada5015$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $23e3cc2fb993da68$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeDouble(this, value, offset, true, noAssert);
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$b4fa0ac54ada5015$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$b4fa0ac54ada5015$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$b4fa0ac54ada5015$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $b4fa0ac54ada5015$var$Buffer.isBuffer(val) ? val : $b4fa0ac54ada5015$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $b4fa0ac54ada5015$var$errors = {};
function $b4fa0ac54ada5015$var$E(sym, getMessage, Base) {
    $b4fa0ac54ada5015$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$b4fa0ac54ada5015$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$b4fa0ac54ada5015$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$b4fa0ac54ada5015$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $b4fa0ac54ada5015$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $b4fa0ac54ada5015$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $b4fa0ac54ada5015$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $b4fa0ac54ada5015$var$checkBounds(buf, offset, byteLength) {
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $b4fa0ac54ada5015$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $b4fa0ac54ada5015$var$checkBounds(buf, offset, byteLength);
}
function $b4fa0ac54ada5015$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $b4fa0ac54ada5015$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $b4fa0ac54ada5015$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $b4fa0ac54ada5015$var$validateNumber(value, type);
        throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $b4fa0ac54ada5015$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $b4fa0ac54ada5015$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $b4fa0ac54ada5015$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($b4fa0ac54ada5015$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $b4fa0ac54ada5015$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $b4fa0ac54ada5015$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $b4fa0ac54ada5015$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $b4fa0ac54ada5015$var$base64ToBytes(str) {
    return $bfa49c0062a5803d$export$d622b2ad8d90c771($b4fa0ac54ada5015$var$base64clean(str));
}
function $b4fa0ac54ada5015$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $b4fa0ac54ada5015$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $b4fa0ac54ada5015$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $b4fa0ac54ada5015$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $b4fa0ac54ada5015$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $b4fa0ac54ada5015$var$BufferBigIntNotDefined : fn;
}
function $b4fa0ac54ada5015$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $1a17727e3ca99c94$require$Buffer = $b4fa0ac54ada5015$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $1a17727e3ca99c94$var$isVisitable(thing) {
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $1a17727e3ca99c94$var$removeBrackets(key) {
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $1a17727e3ca99c94$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $1a17727e3ca99c94$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $1a17727e3ca99c94$var$isFlatArray(arr) {
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(arr) && !arr.some($1a17727e3ca99c94$var$isVisitable);
}
const $1a17727e3ca99c94$var$predicates = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFlatObject((0, $0a51f960109e0fa4$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $1a17727e3ca99c94$var$toFormData(obj, formData, options) {
    if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $92fbca5b49d9b1b0$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $1a17727e3ca99c94$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(value) && $1a17727e3ca99c94$var$isFlatArray(value) || ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFileList(value) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $1a17727e3ca99c94$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $1a17727e3ca99c94$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($1a17727e3ca99c94$var$isVisitable(value)) return true;
        formData.append($1a17727e3ca99c94$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($1a17727e3ca99c94$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $1a17727e3ca99c94$var$isVisitable
    });
    function build(value, path) {
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $1a17727e3ca99c94$export$2e2bcd8739ae039 = $1a17727e3ca99c94$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $0b6d5fbd9064a844$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $0b6d5fbd9064a844$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $1a17727e3ca99c94$export$2e2bcd8739ae039)(params, this, options);
}
const $0b6d5fbd9064a844$var$prototype = $0b6d5fbd9064a844$var$AxiosURLSearchParams.prototype;
$0b6d5fbd9064a844$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$0b6d5fbd9064a844$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $0b6d5fbd9064a844$var$encode);
    } : $0b6d5fbd9064a844$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $0b6d5fbd9064a844$export$2e2bcd8739ae039 = $0b6d5fbd9064a844$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $05a98f245b338187$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $05a98f245b338187$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $05a98f245b338187$var$encode;
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $0b6d5fbd9064a844$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $15156ebcfb4812c5$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $15156ebcfb4812c5$export$2e2bcd8739ae039 = $15156ebcfb4812c5$var$InterceptorManager;





'use strict';
var $00f36b71c2a7ac3f$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};



function $36e600d4bd8d4d58$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $cdba156f56d9c0b3$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $36e600d4bd8d4d58$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}






'use strict';
var $75c47b9a7df70563$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $0b6d5fbd9064a844$export$2e2bcd8739ae039);


'use strict';
var $9ab76d0fd47552f9$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $950afdd45c11eefd$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $f1a7bd4b4996e189$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $75c47b9a7df70563$export$2e2bcd8739ae039,
        FormData: $9ab76d0fd47552f9$export$2e2bcd8739ae039,
        Blob: $950afdd45c11eefd$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $aff4ce6cdd77574c$exports = {};

$parcel$export($aff4ce6cdd77574c$exports, "hasBrowserEnv", function () { return $aff4ce6cdd77574c$export$c4996c4b7b93b0bf; });
$parcel$export($aff4ce6cdd77574c$exports, "navigator", function () { return $aff4ce6cdd77574c$export$ec7c8efa7f5790ae; });
$parcel$export($aff4ce6cdd77574c$exports, "hasStandardBrowserEnv", function () { return $aff4ce6cdd77574c$export$c0bcc9250309d66; });
$parcel$export($aff4ce6cdd77574c$exports, "hasStandardBrowserWebWorkerEnv", function () { return $aff4ce6cdd77574c$export$c81692cf5af97dac; });
$parcel$export($aff4ce6cdd77574c$exports, "origin", function () { return $aff4ce6cdd77574c$export$f710a83a91838a36; });
const $aff4ce6cdd77574c$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $aff4ce6cdd77574c$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $aff4ce6cdd77574c$export$c0bcc9250309d66 = $aff4ce6cdd77574c$export$c4996c4b7b93b0bf && (!$aff4ce6cdd77574c$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($aff4ce6cdd77574c$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $aff4ce6cdd77574c$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $aff4ce6cdd77574c$export$f710a83a91838a36 = $aff4ce6cdd77574c$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $4938695c38e1350b$export$2e2bcd8739ae039 = (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $aff4ce6cdd77574c$exports, (0, $f1a7bd4b4996e189$export$2e2bcd8739ae039));


'use strict';
function $3b2bbf5127635efb$export$2e2bcd8739ae039(data, options) {
    return (0, $1a17727e3ca99c94$export$2e2bcd8739ae039)(data, new (0, $4938695c38e1350b$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        visitor: function(value, key, path, helpers) {
            if ((0, $4938695c38e1350b$export$2e2bcd8739ae039).isNode && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $c8fdac2f0594b0a9$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $c8fdac2f0594b0a9$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $c8fdac2f0594b0a9$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $c8fdac2f0594b0a9$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFormData(formData) && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($c8fdac2f0594b0a9$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $c8fdac2f0594b0a9$export$2e2bcd8739ae039 = $c8fdac2f0594b0a9$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $4392fb744c26f5ee$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $4392fb744c26f5ee$var$defaults = {
    transitional: (0, $00f36b71c2a7ac3f$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $c8fdac2f0594b0a9$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBuffer(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isStream(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFile(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBlob(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $3b2bbf5127635efb$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $1a17727e3ca99c94$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $4392fb744c26f5ee$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $4392fb744c26f5ee$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isResponse(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $f2fd8632892200c7$export$2e2bcd8739ae039).from(e, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $4938695c38e1350b$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $4938695c38e1350b$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $4392fb744c26f5ee$var$defaults.headers[method] = {};
});
var $4392fb744c26f5ee$export$2e2bcd8739ae039 = $4392fb744c26f5ee$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $39939d8f2c4d666a$var$ignoreDuplicateOf = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $39939d8f2c4d666a$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $39939d8f2c4d666a$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $332fc3eba15a6bb9$var$$internals = Symbol('internals');
function $332fc3eba15a6bb9$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $332fc3eba15a6bb9$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(value) ? value.map($332fc3eba15a6bb9$var$normalizeValue) : String(value);
}
function $332fc3eba15a6bb9$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $332fc3eba15a6bb9$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $332fc3eba15a6bb9$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $332fc3eba15a6bb9$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $332fc3eba15a6bb9$var$buildAccessors(obj, header) {
    const accessorName = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $332fc3eba15a6bb9$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $332fc3eba15a6bb9$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $332fc3eba15a6bb9$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$332fc3eba15a6bb9$var$isValidHeaderName(header)) setHeaders((0, $39939d8f2c4d666a$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(header) && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $332fc3eba15a6bb9$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $332fc3eba15a6bb9$var$parseTokens(value);
                if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $332fc3eba15a6bb9$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $332fc3eba15a6bb9$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $332fc3eba15a6bb9$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $332fc3eba15a6bb9$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $332fc3eba15a6bb9$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $332fc3eba15a6bb9$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $332fc3eba15a6bb9$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $332fc3eba15a6bb9$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$332fc3eba15a6bb9$var$$internals] = this[$332fc3eba15a6bb9$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $332fc3eba15a6bb9$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $332fc3eba15a6bb9$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$332fc3eba15a6bb9$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).reduceDescriptors($332fc3eba15a6bb9$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).freezeMethods($332fc3eba15a6bb9$var$AxiosHeaders);
var $332fc3eba15a6bb9$export$2e2bcd8739ae039 = $332fc3eba15a6bb9$var$AxiosHeaders;


'use strict';
function $1b3211cf98b1fc9d$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $4392fb744c26f5ee$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5f05ed7c320a541d$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $8375e36a423af45d$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $f2fd8632892200c7$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).inherits($8375e36a423af45d$var$CanceledError, (0, $f2fd8632892200c7$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $8375e36a423af45d$export$2e2bcd8739ae039 = $8375e36a423af45d$var$CanceledError;







'use strict';
function $dbff109b7f5e22f3$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $79a7b620bb64a66c$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4f5412cd0dae3aed$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4f5412cd0dae3aed$export$2e2bcd8739ae039 = $4f5412cd0dae3aed$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $dd6d4425e05b077a$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $dd6d4425e05b077a$export$2e2bcd8739ae039 = $dd6d4425e05b077a$var$throttle;



const $93173d492fe9d75a$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4f5412cd0dae3aed$export$2e2bcd8739ae039)(50, 250);
    return (0, $dd6d4425e05b077a$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $93173d492fe9d75a$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $93173d492fe9d75a$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $aabaaa3820e32699$export$2e2bcd8739ae039 = (0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $4938695c38e1350b$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $4938695c38e1350b$export$2e2bcd8739ae039).origin), (0, $4938695c38e1350b$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $4938695c38e1350b$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $51b4a528f7fee75c$export$2e2bcd8739ae039 = (0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $05561197e8d5bfda$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $672dd09c2eb18b41$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $3ab4466f8c03b360$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $05561197e8d5bfda$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $672dd09c2eb18b41$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





'use strict';
const $30c22c167a0df6c3$var$headersToObject = (thing)=>thing instanceof (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039) ? (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, thing) : thing;
function $30c22c167a0df6c3$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(target) && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($30c22c167a0df6c3$var$headersToObject(a), $30c22c167a0df6c3$var$headersToObject(b), prop, true)
    };
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(Object.keys((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $90e3b762d743f050$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $30c22c167a0df6c3$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $05a98f245b338187$export$2e2bcd8739ae039)((0, $3ab4466f8c03b360$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $aabaaa3820e32699$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $51b4a528f7fee75c$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $72d3f9749acaef4a$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $72d3f9749acaef4a$export$2e2bcd8739ae039 = $72d3f9749acaef4a$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $90e3b762d743f050$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $dbff109b7f5e22f3$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Request aborted', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(msg, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $00f36b71c2a7ac3f$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ETIMEDOUT : (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $93173d492fe9d75a$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $93173d492fe9d75a$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $8375e36a423af45d$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $79a7b620bb64a66c$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $4938695c38e1350b$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



function $90a40128ed2aa990$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $90a40128ed2aa990$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $90a40128ed2aa990$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}








const $ebd9aa0e6d5102ea$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $f2fd8632892200c7$export$2e2bcd8739ae039) ? err : new (0, $8375e36a423af45d$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $ebd9aa0e6d5102ea$export$2e2bcd8739ae039 = $ebd9aa0e6d5102ea$var$composeSignals;


const $045595b6d88fc556$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $045595b6d88fc556$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $045595b6d88fc556$var$readStream(iterable))yield* $045595b6d88fc556$export$71b051935044bd5d(chunk, chunkSize);
};
const $045595b6d88fc556$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $045595b6d88fc556$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $045595b6d88fc556$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $990cf3f47f0b19e3$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $990cf3f47f0b19e3$var$isFunction } = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039);
const $990cf3f47f0b19e3$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).global);
const { ReadableStream: $990cf3f47f0b19e3$var$ReadableStream, TextEncoder: $990cf3f47f0b19e3$var$TextEncoder } = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).global;
const $990cf3f47f0b19e3$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $990cf3f47f0b19e3$var$factory = (env)=>{
    env = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $990cf3f47f0b19e3$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $990cf3f47f0b19e3$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $990cf3f47f0b19e3$var$isFunction(Request);
    const isResponseSupported = $990cf3f47f0b19e3$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $990cf3f47f0b19e3$var$isFunction($990cf3f47f0b19e3$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $990cf3f47f0b19e3$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $990cf3f47f0b19e3$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $990cf3f47f0b19e3$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $4938695c38e1350b$export$2e2bcd8739ae039).origin, {
            body: new $990cf3f47f0b19e3$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $990cf3f47f0b19e3$var$test(()=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $4938695c38e1350b$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $90e3b762d743f050$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $ebd9aa0e6d5102ea$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $93173d492fe9d75a$export$d9fadd12586c18d6)(requestContentLength, (0, $93173d492fe9d75a$export$c1b28109d46c3592)((0, $93173d492fe9d75a$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $045595b6d88fc556$export$b0119225647bd83)(_request.body, $990cf3f47f0b19e3$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, fetchOptions), {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $93173d492fe9d75a$export$d9fadd12586c18d6)(responseContentLength, (0, $93173d492fe9d75a$export$c1b28109d46c3592)((0, $93173d492fe9d75a$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $045595b6d88fc556$export$b0119225647bd83)(response.body, $990cf3f47f0b19e3$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $dbff109b7f5e22f3$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Network Error', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $f2fd8632892200c7$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
        }
    };
};
const $990cf3f47f0b19e3$var$seedCache = new Map();
const $990cf3f47f0b19e3$export$3105c6651375d4fa = (config)=>{
    let env = config ? config.env : {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $990cf3f47f0b19e3$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $990cf3f47f0b19e3$var$factory(env));
        map = target;
    }
    return target;
};
const $990cf3f47f0b19e3$var$adapter = $990cf3f47f0b19e3$export$3105c6651375d4fa();
var $990cf3f47f0b19e3$export$2e2bcd8739ae039 = $990cf3f47f0b19e3$var$adapter;



const $aeaf0cdf32c87a26$var$knownAdapters = {
    http: (0, $92fbca5b49d9b1b0$export$2e2bcd8739ae039),
    xhr: (0, $72d3f9749acaef4a$export$2e2bcd8739ae039),
    fetch: {
        get: $990cf3f47f0b19e3$export$3105c6651375d4fa
    }
};
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach($aeaf0cdf32c87a26$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $aeaf0cdf32c87a26$var$renderReason = (reason)=>`- ${reason}`;
const $aeaf0cdf32c87a26$var$isResolvedHandle = (adapter)=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $aeaf0cdf32c87a26$export$2e2bcd8739ae039 = {
    getAdapter: (adapters, config)=>{
        adapters = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$aeaf0cdf32c87a26$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $aeaf0cdf32c87a26$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter && ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($aeaf0cdf32c87a26$var$renderReason).join('\n') : ' ' + $aeaf0cdf32c87a26$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $aeaf0cdf32c87a26$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $dd383be87f2615f6$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $8375e36a423af45d$export$2e2bcd8739ae039)(null, config);
}
function $dd383be87f2615f6$export$2e2bcd8739ae039(config) {
    $dd383be87f2615f6$var$throwIfCancellationRequested(config);
    config.headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $1b3211cf98b1fc9d$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $aeaf0cdf32c87a26$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $4392fb744c26f5ee$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $dd383be87f2615f6$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $1b3211cf98b1fc9d$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5f05ed7c320a541d$export$2e2bcd8739ae039)(reason)) {
            $dd383be87f2615f6$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $1b3211cf98b1fc9d$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $3d37115bbc67f13c$export$a4ad2735b021c132 = "1.12.2";



'use strict';
const $197627880ab628f6$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $197627880ab628f6$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $197627880ab628f6$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $197627880ab628f6$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $3d37115bbc67f13c$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$197627880ab628f6$var$deprecatedWarnings[opt]) {
            $197627880ab628f6$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$197627880ab628f6$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $197627880ab628f6$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('options must be an object', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $197627880ab628f6$export$2e2bcd8739ae039 = {
    assertOptions: $197627880ab628f6$var$assertOptions,
    validators: $197627880ab628f6$var$validators
};



'use strict';
const $3c793b01c43703e1$var$validators = (0, $197627880ab628f6$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $3c793b01c43703e1$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $197627880ab628f6$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $3c793b01c43703e1$var$validators.transitional($3c793b01c43703e1$var$validators.boolean),
            forcedJSONParsing: $3c793b01c43703e1$var$validators.transitional($3c793b01c43703e1$var$validators.boolean),
            clarifyTimeoutError: $3c793b01c43703e1$var$validators.transitional($3c793b01c43703e1$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $197627880ab628f6$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $3c793b01c43703e1$var$validators.function,
                serialize: $3c793b01c43703e1$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $197627880ab628f6$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $3c793b01c43703e1$var$validators.spelling('baseURL'),
            withXsrfToken: $3c793b01c43703e1$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dd383be87f2615f6$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dd383be87f2615f6$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $3ab4466f8c03b360$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $05a98f245b338187$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $15156ebcfb4812c5$export$2e2bcd8739ae039)(),
            response: new (0, $15156ebcfb4812c5$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $3c793b01c43703e1$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $3c793b01c43703e1$var$Axios.prototype[method] = generateHTTPMethod();
    $3c793b01c43703e1$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $3c793b01c43703e1$export$2e2bcd8739ae039 = $3c793b01c43703e1$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $41c6d49ff23d7cbb$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $41c6d49ff23d7cbb$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $8375e36a423af45d$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $41c6d49ff23d7cbb$export$2e2bcd8739ae039 = $41c6d49ff23d7cbb$var$CancelToken;






'use strict';
function $392194938cc89728$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $7fd4247c35dc1f27$export$2e2bcd8739ae039(payload) {
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $d4f7ae775bec0665$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($d4f7ae775bec0665$var$HttpStatusCode).forEach(([key, value])=>{
    $d4f7ae775bec0665$var$HttpStatusCode[value] = key;
});
var $d4f7ae775bec0665$export$2e2bcd8739ae039 = $d4f7ae775bec0665$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5774572e96b4aaf1$var$createInstance(defaultConfig) {
    const context = new (0, $3c793b01c43703e1$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $af63e388eb3e7024$export$2e2bcd8739ae039)((0, $3c793b01c43703e1$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).extend(instance, (0, $3c793b01c43703e1$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5774572e96b4aaf1$var$createInstance((0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5774572e96b4aaf1$var$axios = $5774572e96b4aaf1$var$createInstance((0, $4392fb744c26f5ee$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5774572e96b4aaf1$var$axios.Axios = (0, $3c793b01c43703e1$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5774572e96b4aaf1$var$axios.CanceledError = (0, $8375e36a423af45d$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.CancelToken = (0, $41c6d49ff23d7cbb$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.isCancel = (0, $5f05ed7c320a541d$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.VERSION = (0, $3d37115bbc67f13c$export$a4ad2735b021c132);
$5774572e96b4aaf1$var$axios.toFormData = (0, $1a17727e3ca99c94$export$2e2bcd8739ae039);
// Expose AxiosError class
$5774572e96b4aaf1$var$axios.AxiosError = (0, $f2fd8632892200c7$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5774572e96b4aaf1$var$axios.Cancel = $5774572e96b4aaf1$var$axios.CanceledError;
// Expose all/spread
$5774572e96b4aaf1$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5774572e96b4aaf1$var$axios.spread = (0, $392194938cc89728$export$2e2bcd8739ae039);
// Expose isAxiosError
$5774572e96b4aaf1$var$axios.isAxiosError = (0, $7fd4247c35dc1f27$export$2e2bcd8739ae039);
// Expose mergeConfig
$5774572e96b4aaf1$var$axios.mergeConfig = (0, $30c22c167a0df6c3$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.AxiosHeaders = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.formToJSON = (thing)=>(0, $c8fdac2f0594b0a9$export$2e2bcd8739ae039)((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5774572e96b4aaf1$var$axios.getAdapter = (0, $aeaf0cdf32c87a26$export$2e2bcd8739ae039).getAdapter;
$5774572e96b4aaf1$var$axios.HttpStatusCode = (0, $d4f7ae775bec0665$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.default = $5774572e96b4aaf1$var$axios;
var // this module should only have a default export
$5774572e96b4aaf1$export$2e2bcd8739ae039 = $5774572e96b4aaf1$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $3be821c10766c4b6$export$1c00760e9e5a4e95, AxiosError: $3be821c10766c4b6$export$c1fbed17c2f6a328, CanceledError: $3be821c10766c4b6$export$1ab0c6b20d94fa14, isCancel: $3be821c10766c4b6$export$3b22524397b493c6, CancelToken: $3be821c10766c4b6$export$fd08e3cb425f0d61, VERSION: $3be821c10766c4b6$export$a4ad2735b021c132, all: $3be821c10766c4b6$export$84bf76cd7afc7469, Cancel: $3be821c10766c4b6$export$848c9b7ead0df967, isAxiosError: $3be821c10766c4b6$export$fbafdbe06a5b5a9a, spread: $3be821c10766c4b6$export$3ae0fd4797ed47c8, toFormData: $3be821c10766c4b6$export$10ae0d317ea97f8b, AxiosHeaders: $3be821c10766c4b6$export$4e7d6ff0f3e6520, HttpStatusCode: $3be821c10766c4b6$export$a972f69c851492b3, formToJSON: $3be821c10766c4b6$export$86d7c59254d6a2c9, getAdapter: $3be821c10766c4b6$export$17ddc20a97d669e2, mergeConfig: $3be821c10766c4b6$export$7ec1ebcfa9d8bd6a } = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);


const $135fa933152ea198$export$de026b00723010c1 = (type, msg, time = 5)=>{
    $135fa933152ea198$export$516836c6a9dfc573();
    const markup = `<div class="alert alert--${type}">${msg}</div>`;
    //console.log('markup', markup);
    document.querySelector('body').insertAdjacentHTML('afterbegin', markup);
    window.setTimeout($135fa933152ea198$export$516836c6a9dfc573, time * 1000);
};
const $135fa933152ea198$export$516836c6a9dfc573 = ()=>{
    const el = document.querySelector('.alert');
    if (el) el.parentElement.removeChild(el);
// window.setTimeout(hideAlert, 5000);
};


const $1eef366fe5f39774$export$596d806903d1f59e = async (email, password)=>{
    try {
        const res = await (0, $5774572e96b4aaf1$export$2e2bcd8739ae039)({
            method: 'POST',
            url: `/api/v1/users/login`,
            withCredentials: true,
            data: {
                email: email,
                password: password
            }
        });
        if (res.data.status === 'success') {
            (0, $135fa933152ea198$export$de026b00723010c1)('success', 'Login successful');
            window.setTimeout(()=>window.location.href = '/', 1000);
        }
    } catch (error) {
        console.log(error);
        (0, $135fa933152ea198$export$de026b00723010c1)('error', error.response.data.message);
    }
};




const $0a9ff7bc353325a6$export$a0973bcfe11b05c9 = async ()=>{
    try {
        const res = await (0, $5774572e96b4aaf1$export$2e2bcd8739ae039)({
            method: 'GET',
            url: `/api/v1/users/logout`,
            withCredentials: true
        });
        if (res.data.status === 'success') {
            (0, $135fa933152ea198$export$de026b00723010c1)('success', 'Logged out successfully');
            window.setTimeout(()=>{
                location.assign('/');
            }, 1500);
        }
    } catch (error) {
        console.log(error);
        (0, $135fa933152ea198$export$de026b00723010c1)('error', error.response.data.message);
    }
};


// Update Settings


const $75bd483a82123819$export$f558026a994b6051 = async (data, type)=>{
    try {
        const url = type === 'data' ? `/api/v1/users/updateMe` : `/api/v1/users/updateMyPassword`;
        const res = await (0, $5774572e96b4aaf1$export$2e2bcd8739ae039)({
            method: 'PATCH',
            url: url,
            data: data,
            withCredentials: true
        });
        if (res.data.status === 'success') (0, $135fa933152ea198$export$de026b00723010c1)('success', `${type.toUpperCase()} updated successfully`);
    } catch (error) {
        console.log(error);
        (0, $135fa933152ea198$export$de026b00723010c1)('error', error.response.data.message);
    }
};




const $5dda1e92e80bf966$export$8d5bdbf26681c0c2 = async (tourId)=>{
    try {
        // 1) Get checkout session from API
        const session = await (0, $5774572e96b4aaf1$export$2e2bcd8739ae039)(`/api/v1/bookings/checkout-session/${tourId}`);
        // 2) Create checkout form + charge credit card
        window.location.replace(session.data.session.url);
    } catch (error) {
        console.log(error);
        (0, $135fa933152ea198$export$de026b00723010c1)('error', error.response.data.message);
    }
};





const $995a94efb32fd1d7$export$7200a869094fec36 = async (name, email, password, passwordConfirm, role)=>{
    try {
        const res = await (0, $5774572e96b4aaf1$export$2e2bcd8739ae039)({
            method: 'POST',
            url: `/api/v1/users/signup`,
            withCredentials: true,
            data: {
                name: name,
                email: email,
                password: password,
                passwordConfirm: passwordConfirm,
                role: role
            }
        });
        if (res.data.status === 'success') {
            (0, $135fa933152ea198$export$de026b00723010c1)('success', 'Sign up successful');
            window.setTimeout(()=>window.location.href = '/', 1000);
        }
    } catch (error) {
        console.log(error);
        (0, $135fa933152ea198$export$de026b00723010c1)('error', error.response.data.message);
    }
};



const $df9d0b489fca5a89$var$SORT_API = {
    newest: '-createdAt',
    'price-asc': 'price',
    'price-desc': '-price',
    rating: '-ratingsAverage',
    'duration-asc': 'duration',
    'duration-desc': '-duration',
    name: 'name'
};
function $df9d0b489fca5a89$var$escapeHtml(str) {
    if (str == null) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $df9d0b489fca5a89$var$formatDate(isoOrDate) {
    const d = new Date(isoOrDate);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric'
    });
}
function $df9d0b489fca5a89$var$cardHtml(tour) {
    var _tour_startLocation, _tour_startDates, _tour_locations;
    const name = $df9d0b489fca5a89$var$escapeHtml(tour.name);
    const summary = $df9d0b489fca5a89$var$escapeHtml(tour.summary);
    const loc = $df9d0b489fca5a89$var$escapeHtml(((_tour_startLocation = tour.startLocation) === null || _tour_startLocation === void 0 ? void 0 : _tour_startLocation.description) || '');
    const slug = $df9d0b489fca5a89$var$escapeHtml(tour.slug);
    const diff = $df9d0b489fca5a89$var$escapeHtml(tour.difficulty);
    const dateStr = $df9d0b489fca5a89$var$formatDate((_tour_startDates = tour.startDates) === null || _tour_startDates === void 0 ? void 0 : _tour_startDates[0]);
    var _tour_locations_length;
    const stops = (_tour_locations_length = (_tour_locations = tour.locations) === null || _tour_locations === void 0 ? void 0 : _tour_locations.length) !== null && _tour_locations_length !== void 0 ? _tour_locations_length : 0;
    const img = $df9d0b489fca5a89$var$escapeHtml(tour.imageCover);
    return `
<article class="card">
  <div class="card__header">
    <div class="card__picture">
      <div class="card__picture-overlay">&nbsp;</div>
      <img class="card__picture-img" src="/img/tours/${img}" alt="${name}" />
    </div>
    <h3 class="heading-tertirary"><span>${name}</span></h3>
  </div>
  <div class="card__details">
    <h4 class="card__sub-heading">${diff} ${tour.duration}-day tour</h4>
    <p class="card__text">${summary}</p>
    <div class="card__data">
      <svg class="card__icon"><use xlink:href="/img/icons.svg#icon-map-pin"></use></svg>
      <span>${loc}</span>
    </div>
    <div class="card__data">
      <svg class="card__icon"><use xlink:href="/img/icons.svg#icon-calendar"></use></svg>
      <span>${dateStr}</span>
    </div>
    <div class="card__data">
      <svg class="card__icon"><use xlink:href="/img/icons.svg#icon-flag"></use></svg>
      <span>${stops} stops</span>
    </div>
    <div class="card__data">
      <svg class="card__icon"><use xlink:href="/img/icons.svg#icon-user"></use></svg>
      <span>${tour.maxGroupSize} people</span>
    </div>
  </div>
  <div class="card__footer">
    <p class="card__footer-link">
      <span class="card__footer-value">$${tour.price}</span>
      <span class="card__footer-text"> per person</span>
    </p>
    <p class="card__ratings">
      <span class="card__footer-value">${tour.ratingsAverage}</span>
      <span class="card__footer-text"> rating (${tour.ratingsQuantity})</span>
    </p>
  </div>
  <a class="btn btn--green btn--small" href="/tour/${slug}">Details</a>
</article>`;
}
function $df9d0b489fca5a89$export$cc132a420ff038d6() {
    const main = document.querySelector('.main--tours-overview');
    const select = document.getElementById('sort-tours');
    const grid = document.getElementById('tour-cards');
    const emptyEl = document.getElementById('tour-sort-empty');
    if (!main || !select || !grid) return;
    const setLoading = (on)=>{
        grid.classList.toggle('card-container--loading', on);
        select.disabled = on;
    };
    const showEmpty = (show)=>{
        if (emptyEl) emptyEl.hidden = !show;
    };
    const applyTours = (tours)=>{
        if (!tours.length) {
            grid.innerHTML = '';
            showEmpty(true);
            return;
        }
        showEmpty(false);
        grid.innerHTML = tours.map((t)=>$df9d0b489fca5a89$var$cardHtml(t)).join('');
    };
    const runSort = async (sortKey)=>{
        const apiSort = $df9d0b489fca5a89$var$SORT_API[sortKey] || $df9d0b489fca5a89$var$SORT_API.newest;
        const params = new URLSearchParams({
            sort: apiSort,
            limit: '200'
        });
        const url = `/api/v1/tours?${params.toString()}`;
        setLoading(true);
        try {
            var _json_data, _json_data1;
            const res = await fetch(url, {
                credentials: 'same-origin',
                headers: {
                    Accept: 'application/json'
                }
            });
            if (!res.ok) throw new Error(`Request failed: ${res.status}`);
            const json = await res.json();
            const tours = ((_json_data = json.data) === null || _json_data === void 0 ? void 0 : _json_data.tours) || ((_json_data1 = json.data) === null || _json_data1 === void 0 ? void 0 : _json_data1.tour) || [];
            applyTours(tours);
            const next = new URL(window.location.href);
            next.searchParams.set('sort', sortKey);
            window.history.replaceState({}, '', next.toString());
        } catch (e) {
            console.error(e);
            (0, $135fa933152ea198$export$de026b00723010c1)('error', 'Could not update tour order. Please try again.');
        } finally{
            setLoading(false);
        }
    };
    select.addEventListener('change', ()=>{
        runSort(select.value);
    });
}


const $63550209912f8dbf$var$map = document.getElementById('map');
if ($63550209912f8dbf$var$map) {
    const locations = JSON.parse($63550209912f8dbf$var$map.dataset.locations);
    (0, $8f3cb5ff5bcc33ef$export$4c5dd147b21b9176)(locations);
}
const $63550209912f8dbf$var$loginForm = document.querySelector('.form.form--login');
const $63550209912f8dbf$var$signupForm = document.querySelector('.form.form--signup');
const $63550209912f8dbf$var$logoutBtn = document.querySelector('.nav__el.nav__el--logout');
const $63550209912f8dbf$var$userDataForm = document.querySelector('.form.form-user-data');
const $63550209912f8dbf$var$userSettingsForm = document.querySelector('.form.form-user-settings');
const $63550209912f8dbf$var$bookTourBtn = document.getElementById('book-tour');
if ($63550209912f8dbf$var$loginForm) $63550209912f8dbf$var$loginForm.addEventListener('submit', (e)=>{
    e.preventDefault();
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;
    (0, $1eef366fe5f39774$export$596d806903d1f59e)(email, password);
});
if ($63550209912f8dbf$var$signupForm) $63550209912f8dbf$var$signupForm.addEventListener('submit', (e)=>{
    e.preventDefault();
    const name = document.getElementById('name').value;
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;
    const passwordConfirm = document.getElementById('passwordConfirm').value;
    const role = document.getElementById('role').value;
    (0, $995a94efb32fd1d7$export$7200a869094fec36)(name, email, password, passwordConfirm, role);
});
if ($63550209912f8dbf$var$logoutBtn) $63550209912f8dbf$var$logoutBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    (0, $0a9ff7bc353325a6$export$a0973bcfe11b05c9)();
});
if ($63550209912f8dbf$var$userDataForm) $63550209912f8dbf$var$userDataForm.addEventListener('submit', (e)=>{
    e.preventDefault();
    const form = new FormData();
    form.append('name', document.getElementById('name').value);
    form.append('email', document.getElementById('email').value);
    form.append('photo', document.getElementById('photo').files[0]);
    (0, $75bd483a82123819$export$f558026a994b6051)(form, 'data');
});
if ($63550209912f8dbf$var$userSettingsForm) $63550209912f8dbf$var$userSettingsForm.addEventListener('submit', async (e)=>{
    e.preventDefault();
    document.querySelector('.btn--save-password').textContent = 'Updating...';
    const passwordCurrent = document.getElementById('password-current').value;
    const password = document.getElementById('password').value;
    const passwordConfirm = document.getElementById('password-confirm').value;
    await (0, $75bd483a82123819$export$f558026a994b6051)({
        passwordCurrent: passwordCurrent,
        password: password,
        passwordConfirm: passwordConfirm
    }, 'password');
    document.querySelector('.btn--save-password').textContent = 'Save password';
    document.getElementById('password-current').value = '';
    document.getElementById('password').value = '';
    document.getElementById('password-confirm').value = '';
});
if ($63550209912f8dbf$var$bookTourBtn) $63550209912f8dbf$var$bookTourBtn.addEventListener('click', (e)=>{
    $63550209912f8dbf$var$bookTourBtn.textContent = 'Processing...';
    const tourId = $63550209912f8dbf$var$bookTourBtn.dataset.tourId;
    //console.log(tourId);
    (0, $5dda1e92e80bf966$export$8d5bdbf26681c0c2)(tourId);
});
(0, $df9d0b489fca5a89$export$cc132a420ff038d6)();
const $63550209912f8dbf$var$alertMessage = document.querySelector('body').dataset.alert;
if ($63550209912f8dbf$var$alertMessage) {
    (0, $135fa933152ea198$export$de026b00723010c1)('success', $63550209912f8dbf$var$alertMessage, 10);
    window.setTimeout(()=>{
        window.location.href = '/my-tours';
    }, 10000);
}

})();
//# sourceMappingURL=index.js.map
